// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/bg-countdown.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/line-poncho.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/bg-generico.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600,700);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Template Name: Codefox - Bootstrap 4 Admin Template
Author: CoderThemes
Email: coderthemes@gmail.com
File: main stylesheet
*/
/*======================================
01.General
02.Helper
03.Bootstrap Custom
04.Waves
05.Menu
06.Demo Only
07.Buttons
08.Card
09.Modals
10.Checkbox Radio
11.Tab & Accordions
12.Progressbar
13.Alerts
14.Notifications
15.Tooltips & Popovers
16.Charts
17.Form elements
18.Form advanced
19.Form validation
20.Form pickers
21.Form wizard
22.Form editors
23.Form upload
24.Tables
25.Table datatable
26.Table responsive
27.Tablesaw
28.Table editable
29.Sweatalert
30.Widgets
31.Nestable
32.Rangeslider
33.Rating
34.Calendar
35.Maps
36.Account Pages
37.Extra Pages
38.Timeline
39.Invoice
40.Responsive
=======================================*/
/* =============
   General
============= */
body {
  font-family: 'Poppins', sans-serif;
  margin: 0;
  padding-bottom: 60px;
  overflow-x: hidden;
  color: #797979;
  font-size: 13px;
  background-color: #f3f3f3;
}

html {
  position: relative;
  min-height: 100%;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  color: #313a46;
  font-family: 'Poppins', sans-serif;
  margin: 10px 0;
}

.h1,
h1 {
  font-size: 36px;
}

.h2,
h2 {
  font-size: 30px;
}

.h3,
h3 {
  font-size: 24px;
}

.h4,
h4 {
  font-size: 18px;
}

.h5,
h5 {
  font-size: 15px;
}

.h6,
h6 {
  font-size: 12px;
}

p {
  line-height: 1.6;
}

* {
  outline: none !important;
}

b,
strong {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
}

a:hover {
  outline: 0;
  text-decoration: none;
}

a:active {
  outline: 0;
  text-decoration: none;
}

a:focus {
  outline: 0;
  text-decoration: none;
}

.container {
  width: auto;
}

.container-alt {
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

#wrapper {
  height: 100%;
  overflow: hidden;
  width: 100%;
}

/* =============
   Helper classes
============= */
.p-0 {
  padding: 0 !important;
}

.p-20 {
  padding: 20px !important;
}

.p-30 {
  padding: 30px !important;
}

.p-l-0 {
  padding-left: 0 !important;
}

.p-r-0 {
  padding-right: 0 !important;
}

.p-t-0 {
  padding-top: 0 !important;
}

.p-b-0 {
  padding-bottom: 0 !important;
}

.p-t-10 {
  padding-top: 10px !important;
}

.p-b-10 {
  padding-bottom: 10px !important;
}

.p-l-r-10 {
  padding-left: 10px;
  padding-right: 10px;
}

.m-0 {
  margin: 0 !important;
}

.m-r-5 {
  margin-right: 5px !important;
}

.m-r-10 {
  margin-right: 10px !important;
}

.m-r-15 {
  margin-right: 15px !important;
}

.m-l-5 {
  margin-left: 5px !important;
}

.m-l-10 {
  margin-left: 10px !important;
}

.m-l-15 {
  margin-left: 15px !important;
}

.m-t-5 {
  margin-top: 5px !important;
}

.m-t-0 {
  margin-top: 5 !important;
}

.m-t-10 {
  margin-top: 10px !important;
}

.m-t-15 {
  margin-top: 15px !important;
}

.m-t-20 {
  margin-top: 20px !important;
}

.m-t-30 {
  margin-top: 30px !important;
}

.m-t-40 {
  margin-top: 40px !important;
}

.m-t-50 {
  margin-top: 50px !important;
}

.m-b-0 {
  margin-bottom: 0 !important;
}

.m-b-5 {
  margin-bottom: 5px !important;
}

.m-b-10 {
  margin-bottom: 10px !important;
}

.m-b-15 {
  margin-bottom: 15px !important;
}

.m-b-20 {
  margin-bottom: 20px !important;
}

.m-b-25 {
  margin-bottom: 25px !important;
}

.m-b-30 {
  margin-bottom: 30px !important;
}

.w-xs {
  min-width: 80px;
}

.w-sm {
  min-width: 95px;
}

.w-md {
  min-width: 110px;
}

.w-lg {
  min-width: 140px;
}

.center-page {
  float: none !important;
  margin: 0 auto !important;
}

.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 100%;
  overflow: hidden;
}

.font-secondary {
  font-family: 'Poppins', sans-serif;
}

.font-600 {
  font-weight: 600;
}

.font-normal {
  font-weight: normal;
}

.font-light {
  font-weight: 300;
}

.font-14 {
  font-size: 14px !important;
}

.wrapper-md {
  padding: 20px;
}

.pull-in {
  margin-left: -20px;
  margin-right: -20px;
}

.b-0 {
  border: none !important;
}

.vertical-middle {
  vertical-align: middle !important;
}

.bx-shadow {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
}

.bx-shadow-none {
  box-shadow: none !important;
}

.mx-box {
  max-height: 380px;
  min-height: 380px;
}

.thumb-sm {
  height: 32px;
  width: 32px;
}

.thumb-md {
  height: 48px;
  width: 48px;
}

.thumb-lg {
  height: 88px;
  width: 88px;
}

.thumb-xl {
  height: 120px;
  width: 120px;
}

.bg-transparent {
  background-color: transparent !important;
}

.slimScrollDiv {
  height: auto !important;
}

/* Table type box */
.table-box {
  display: table;
  height: 100%;
  width: 100%;
}

.table-box .table-detail {
  display: table-cell;
  vertical-align: middle;
}

/******************  ui images  ********************/
.thumbnail {
  padding: 4px;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
}

/* =============
   Bootstrap-custom
============= */
.breadcrumb {
  background-color: transparent;
  margin-bottom: 15px;
  padding-top: 10px;
  padding-left: 0;
}

.breadcrumb a {
  color: #98a6ad;
}

.media {
  margin-top: 25px;
}

.media:first-child {
  margin-top: 0;
}

.breadcrumb > li + li:before {
  padding: 0 5px;
  color: #98a6ad;
  content: '/\\00a0';
}

/* Dropdown */
.dropdown-menu {
  padding: 4px 0;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06),
    0 1px 0 0 rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(152, 166, 173, 0.15);
}

.dropdown-menu > li > a {
  padding: 7px 20px;
  font-size: 13px;
}

.dropdown-menu > li > a:focus,
.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:active,
.dropdown-menu > li > a.active {
  background-color: #f3f3f3 !important;
  color: #313a46;
}

.dropdown-menu > .active > a,
.dropdown-menu > .active > a:hover,
.dropdown-menu > .active > a:focus {
  background-color: #f3f3f3 !important;
}

.dropdown-lg {
  width: 260px;
}

.blockquote {
  padding: 10px 20px;
  margin: 0 0 20px;
  font-size: 16px;
  border-left: 5px solid #f3f3f3;
}

.blockquote-reverse {
  border-left: 0;
  border-right: 4px solid #f3f3f3;
  text-align: right;
}

.custom-control-input:checked ~ .custom-control-label:before {
  border-color: #348cd4;
  background-color: #348cd4;
}

/* Background colors */
.bg-custom {
  background-color: #348cd4 !important;
}

.bg-primary {
  background-color: #3456d4 !important;
}

.bg-success {
  background-color: #78c350 !important;
}

.bg-info {
  background-color: #45bbe0 !important;
}

.bg-warning {
  background-color: #ff9800 !important;
}

.bg-danger {
  background-color: #f7531f !important;
}

.bg-muted {
  background-color: #797979 !important;
}

.bg-inverse {
  background-color: #3b3e47 !important;
}

.bg-purple {
  background-color: #8892d6 !important;
}

.bg-pink {
  background-color: #f06292 !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.bg-dark {
  background-color: #313a46 !important;
}

/* Text colors */
.text-custom {
  color: #348cd4 !important;
}

.text-white {
  color: #ffffff !important;
}

.text-danger {
  color: #f7531f !important;
}

.text-muted {
  color: #98a6ad !important;
}

.text-primary {
  color: #3456d4 !important;
}

.text-warning {
  color: #ff9800 !important;
}

.text-success {
  color: #78c350 !important;
}

.text-info {
  color: #45bbe0 !important;
}

.text-inverse {
  color: #3b3e47 !important;
}

.text-pink {
  color: #f06292 !important;
}

.text-purple {
  color: #8892d6 !important;
}

.text-dark {
  color: #313a46 !important;
}

/* Badge */
.badge {
  background-color: #348cd4;
  font-family: 'Poppins', sans-serif;
  color: #ffffff;
  padding: 3px 5px;
  font-size: 10px;
  font-weight: 600;
}

.badge-xs {
  font-size: 9px;
}

.badge-xs,
.badge-sm {
  transform: translate(0, -2px);
}

.badge-white {
  background-color: rgba(255, 255, 255, 0.7);
  color: #313a46 !important;
}

.badge-primary {
  background-color: #3456d4;
}

.badge-success {
  background-color: #78c350;
}

.badge-info {
  background-color: #45bbe0;
}

.badge-warning {
  background-color: #ff9800;
}

.badge-danger {
  background-color: #f7531f;
}

.badge-purple {
  background-color: #8892d6;
}

.badge-pink {
  background-color: #f06292;
}

.badge-inverse {
  background-color: #3b3e47;
}

/******* spinner *******/
.spinner-border,
.spinner-grow {
  margin-right: 10px;
  margin-top: 10px;
}

/******* carousel *******/
.carousel-control {
  width: 10%;
}

.carousel-control span {
  position: absolute;
  top: 50%;
  z-index: 5;
  display: inline-block;
  font-size: 30px;
}

/******* Pagination *******/
.pagination .page-link {
  color: #313a46;
}

.pagination-split .page-item {
  margin-left: 5px;
  float: left;
}

.pagination-split .page-link {
  border-radius: 3px;
}

.page-item.active .page-link {
  background: #348cd4;
  border-color: #348cd4;
}

.list-group-item {
  color: #797979;
}

.list-group-item.disabled,
.list-group-item.disabled:focus,
.list-group-item.disabled:hover,
.list-group-item:hover {
  background: #f3f3f3;
  color: #797979;
}

.list-group-item.active,
.list-group-item.active:focus,
.list-group-item.active:hover {
  background-color: #348cd4;
  border-color: #348cd4;
}

.list-group-item.active .list-group-item-text,
.list-group-item.active:focus .list-group-item-text,
.list-group-item.active:hover .list-group-item-text {
  color: rgba(255, 255, 255, 0.7);
}

/*!
 * Waves v0.7.6
 * http://fian.my.id/Waves 
 * 
 * Copyright 2014-2018 Alfiana E. Sibuea and other contributors 
 * Released under the MIT license 
 * https://github.com/fians/Waves/blob/master/LICENSE */
.waves-effect {
  position: relative;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.waves-effect .waves-ripple {
  position: absolute;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  opacity: 0;
  background: rgba(0, 0, 0, 0.2);
  background: radial-gradient(
    rgba(0, 0, 0, 0.2) 0,
    rgba(0, 0, 0, 0.3) 40%,
    rgba(0, 0, 0, 0.4) 50%,
    rgba(0, 0, 0, 0.5) 60%,
    rgba(255, 255, 255, 0) 70%
  );
  transition: all 0.5s ease-out;
  transition-property: transform, opacity;
  transform: scale(0) translate(0, 0);
  pointer-events: none;
}

.waves-effect.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
  background: radial-gradient(
    rgba(255, 255, 255, 0.2) 0,
    rgba(255, 255, 255, 0.3) 40%,
    rgba(255, 255, 255, 0.4) 50%,
    rgba(255, 255, 255, 0.5) 60%,
    rgba(255, 255, 255, 0) 70%
  );
}

.waves-effect.waves-classic .waves-ripple {
  background: rgba(0, 0, 0, 0.2);
}

.waves-effect.waves-classic.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}

.waves-notransition {
  transition: none !important;
}

.waves-button,
.waves-circle {
  transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(
    circle,
    white 100%,
    black 100%
  );
}

.waves-button,
.waves-button:hover,
.waves-button:visited,
.waves-button-input {
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: none;
  outline: none;
  color: inherit;
  background-color: rgba(0, 0, 0, 0);
  font-size: 1em;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  z-index: 1;
}

.waves-button {
  padding: 0.85em 1.1em;
  border-radius: 0.2em;
}

.waves-button-input {
  margin: 0;
  padding: 0.85em 1.1em;
}

.waves-input-wrapper {
  border-radius: 0.2em;
  vertical-align: bottom;
}

.waves-input-wrapper.waves-button {
  padding: 0;
}

.waves-input-wrapper .waves-button-input {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
}

.waves-circle {
  text-align: center;
  width: 2.5em;
  height: 2.5em;
  line-height: 2.5em;
  border-radius: 50%;
}

.waves-float {
  -webkit-mask-image: none;
  box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);
  transition: all 300ms;
}

.waves-float:active {
  box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);
}

.waves-block {
  display: block;
}

.waves-effect.waves-light .waves-ripple {
  background-color: rgba(255, 255, 255, 0.4);
}

.waves-effect.waves-custom .waves-ripple {
  background-color: rgba(52, 140, 212, 0.4);
}

.waves-effect.waves-primary .waves-ripple {
  background-color: rgba(52, 86, 212, 0.4);
}

.waves-effect.waves-success .waves-ripple {
  background-color: rgba(120, 195, 80, 0.4);
}

.waves-effect.waves-info .waves-ripple {
  background-color: rgba(69, 187, 224, 0.4);
}

.waves-effect.waves-warning .waves-ripple {
  background-color: rgba(255, 152, 0, 0.4);
}

.waves-effect.waves-danger .waves-ripple {
  background-color: rgba(247, 83, 31, 0.4);
}

.waves-effect.waves-pink .waves-ripple {
  background-color: rgba(240, 98, 146, 0.4);
}

.waves-effect.purple .waves-ripple {
  background-color: rgba(136, 146, 214, 0.4);
}

.waves-effect.waves-inverse .waves-ripple {
  background-color: rgba(59, 62, 71, 0.4);
}

/*
Template Name: Codefox - Bootstrap 4 Admin Template
Author: CoderThemes
Email: coderthemes@gmail.com
File: Menu

*/
/* Metis Menu css */
.metismenu li {
  display: block;
  width: 100%;
}

.metismenu .arrow {
  float: right;
  line-height: 1.42857;
}

.metismenu .mm-collapse {
  display: none;
}

.metismenu .mm-collapse.mm-show {
  display: block;
}

.metismenu .collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition-timing-function: ease;
  transition-duration: 0.35s;
  transition-property: height, visibility;
}

.navbar-default {
  background-color: #348cd4;
  border-radius: 0;
  margin-bottom: 0;
  padding: 0px;
}

.navbar-default .navbar-left li a.menu-item {
  padding: 0 15px;
  line-height: 68px;
}

.navbar-default .navbar-right .dropdown-toggle:after {
  display: none;
}

.nav > li > a {
  position: relative;
  display: block;
  padding: 10px 15px;
}

.logo {
  line-height: 70px;
}

.logo i {
  display: none;
}

.user-box a.user-link {
  padding-top: 17px !important;
  padding-bottom: 17px !important;
}

.user-box .user-img {
  position: relative;
  height: 36px;
  width: 36px;
  margin: 0 auto;
}

.navbar-default .right-menu-item {
  padding: 0px 10px;
  line-height: 63px;
  text-align: center;
  background-color: transparent !important;
  color: rgba(255, 255, 255, 0.7);
  display: inline-block;
  position: relative;
}

.navbar-default .right-menu-item > i {
  font-size: 22px;
  vertical-align: -webkit-baseline-middle;
}

.navbar-default .right-menu-item .badge {
  position: absolute;
  top: 12px;
  right: 5px;
}

.navbar-default .navbar-nav > .open > a,
.navbar-default .navbar-nav > .open > a:focus,
.navbar-default .navbar-nav > .open > a:hover {
  background-color: rgba(49, 58, 70, 0.05);
}

.side-menu {
  width: 240px;
  z-index: 10;
  background: #ffffff;
  bottom: 0;
  margin-top: 0;
  padding-bottom: 30px;
  position: fixed;
  top: 71px;
  border-right: 1px solid #e6e6e6;
}

.side-menu .waves-effect .waves-ripple {
  background-color: rgba(52, 140, 212, 0.4);
}

.enlarged .side-menu {
  position: absolute;
}

.content-page {
  margin-left: 240px;
  overflow: hidden;
}

.content-page .content {
  padding: 0 15px 10px 15px;
  margin-top: 70px;
}

.button-menu-mobile {
  border: none;
  color: #ffffff;
  display: inline-block;
  height: 36px;
  width: 36px;
  background-color: #348cd4;
  border-radius: 2px;
  border: 1px solid #4998d8;
  font-size: 16px;
  margin: 17px 10px;
}

#sidebar-menu > ul > li > a {
  color: #313a46;
  display: block;
  padding: 13px 25px;
  font-size: 14.2px;
  position: relative;
}

#sidebar-menu > ul > li > a:hover,
#sidebar-menu > ul > li > a:focus,
#sidebar-menu > ul > li > a:active {
  color: #313a46;
  text-decoration: none;
  background-color: #f9f9f9;
}

#sidebar-menu {
  padding-top: 10px;
}

#sidebar-menu .menu-arrow {
  transition: transform 0.15s;
  position: absolute;
  right: 20px;
  display: inline-block;
  font-family: 'Material Design Icons';
  text-rendering: auto;
  line-height: 25px;
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transform: translate(0, 0);
}

#sidebar-menu .menu-arrow:before {
  content: '\\F142';
}

#sidebar-menu .badge {
  margin-top: 3px;
}

#sidebar-menu li.mm-active > a > .menu-arrow {
  transform: rotate(90deg);
}

#sidebar-menu ul li a i {
  display: inline-block;
  font-size: 18px;
  line-height: 17px;
  margin: 0 15px 0 3px;
  text-align: center;
  width: 20px;
  color: rgba(49, 58, 70, 0.8);
}

#sidebar-menu ul li a .drop-arrow {
  float: right;
}

#sidebar-menu ul li a .drop-arrow i {
  margin-right: 0;
}

#sidebar-menu > ul > li > a.mm-active {
  color: #313a46 !important;
  background-color: #f9f9f9;
}

.nav-second-level.nav li a,
.nav-thrid-level.nav li a {
  padding: 8px 20px 8px 10px;
  color: #797979;
}

.nav-second-level.nav li a:focus,
.nav-thrid-level.nav li a:focus {
  background-color: #ffffff;
}

.nav-second-level.nav li a:hover,
.nav-thrid-level.nav li a:hover {
  background-color: #ffffff;
  color: #313a46;
}

.nav-second-level.nav > li > a {
  padding-left: 62px;
}

.nav-second-level.nav > li > a .menu-arrow {
  line-height: 22px !important;
  font-size: 16px !important;
}

.nav-second-level.nav li.mm-active > a {
  color: #313a46;
}

.nav-third-level.nav > li > a {
  padding-left: 72px;
}

.nav-third-level.nav li.mm-active > a {
  color: #313a46;
}

.menu-title {
  padding: 12px 20px !important;
  letter-spacing: 0.05em;
  pointer-events: none;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  color: #98a6ad;
  font-family: 'Poppins', sans-serif;
}

.enlarged .slimScrollDiv,
.enlarged .slimscroll-menu {
  overflow: inherit !important;
}

.enlarged .slimScrollBar {
  visibility: hidden;
}

.enlarged #wrapper #sidebar-menu .menu-title,
.enlarged #wrapper #sidebar-menu .menu-arrow,
.enlarged #wrapper #sidebar-menu .badge {
  display: none !important;
}

.enlarged #wrapper #sidebar-menu .mm-collapse.mm-show {
  display: none;
}

.enlarged #wrapper #sidebar-menu .nav.mm-collapse {
  height: inherit !important;
}

.enlarged #wrapper #sidebar-menu ul ul {
  padding-bottom: 5px;
  padding-top: 5px;
  z-index: 9999;
  background-color: #ffffff;
}

.enlarged #wrapper .left.side-menu {
  width: 70px;
  z-index: 5;
}

.enlarged #wrapper .left.side-menu #sidebar-menu > ul > li > a {
  padding: 15px 20px;
}

.enlarged #wrapper .left.side-menu #sidebar-menu > ul > li > a:hover,
.enlarged #wrapper .left.side-menu #sidebar-menu > ul > li > a:active,
.enlarged #wrapper .left.side-menu #sidebar-menu > ul > li > a:focus {
  color: #313a46 !important;
  background-color: #f9f9f9;
}

.enlarged #wrapper .left.side-menu #sidebar-menu > ul > li > a i {
  font-size: 18px;
  margin-right: 20px !important;
}

.enlarged #wrapper .left.side-menu #sidebar-menu ul > li {
  position: relative;
  white-space: nowrap;
}

.enlarged #wrapper .left.side-menu #sidebar-menu ul > li:hover > a {
  position: relative;
  width: 260px;
  color: #ffffff !important;
  background-color: #348cd4;
}

.enlarged
  #wrapper
  .left.side-menu
  #sidebar-menu
  ul
  > li:hover
  > a
  > i {
  color: #ffffff;
}

.enlarged #wrapper .left.side-menu #sidebar-menu ul > li:hover > ul {
  display: block;
  left: 70px;
  position: absolute;
  width: 190px;
  box-shadow: 3px 0px 11px 1px rgba(0, 0, 0, 0.08);
}

.enlarged
  #wrapper
  .left.side-menu
  #sidebar-menu
  ul
  > li:hover
  > ul
  a {
  box-shadow: none;
  padding: 8px 20px;
  position: relative;
  width: 190px;
  z-index: 6;
}

.enlarged
  #wrapper
  .left.side-menu
  #sidebar-menu
  ul
  > li:hover
  > ul
  a:hover {
  color: #313a46;
}

.enlarged
  #wrapper
  .left.side-menu
  #sidebar-menu
  ul
  > li:hover
  a
  span {
  display: inline;
}

.enlarged #wrapper .left.side-menu #sidebar-menu ul ul li:hover > ul {
  display: block;
  left: 190px;
  margin-top: -36px;
  position: absolute;
  width: 190px;
}

.enlarged #wrapper .left.side-menu #sidebar-menu ul ul li.active a {
  color: #313a46;
}

.enlarged #wrapper .left.side-menu #sidebar-menu ul > li > a span {
  display: none;
  padding-left: 10px;
}

.enlarged #wrapper .left.side-menu .user-details {
  display: none;
}

.enlarged #wrapper .content-page {
  margin-left: 70px;
}

.enlarged #wrapper .footer {
  left: 70px;
}

.enlarged #wrapper .topbar .topbar-left {
  width: 70px !important;
}

.enlarged #wrapper .topbar .topbar-left .logo span {
  display: none;
  opacity: 0;
}

.enlarged #wrapper .topbar .topbar-left .logo i {
  display: block;
  line-height: 70px;
  color: #348cd4 !important;
}

.enlarged #wrapper #sidebar-menu > ul > li:hover > a.open :after {
  display: none;
}

.enlarged
  #wrapper
  #sidebar-menu
  > ul
  > li:hover
  > a.mm-active
  :after {
  display: none;
}

#wrapper.right-bar-enabled .right-bar {
  right: 0;
}

#wrapper.right-bar-enabled .left-layout {
  left: 0;
}

/* Search */
.app-search {
  position: relative;
}

.app-search a {
  position: absolute;
  top: 7px;
  right: 26px;
  color: rgba(255, 255, 255, 0.7);
}

.app-search a:hover {
  color: #ffffff;
}

.app-search .form-control,
.app-search .form-control:focus {
  border: 1px solid rgba(255, 255, 255, 0.15);
  font-size: 13px;
  height: 34px;
  color: #ffffff;
  padding: 7px 40px 7px 20px;
  margin: 19px 15px 0 5px;
  background: rgba(255, 255, 255, 0.05);
  box-shadow: none;
  border-radius: 30px;
  width: 190px;
}

.app-search input::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.app-search input:-moz-placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.app-search input::-moz-placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.app-search input:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}

/* Page titles */
.page-title {
  font-size: 16px;
  margin-bottom: 0;
  margin-top: 0;
  font-weight: 600;
  text-transform: uppercase;
}

.header-title {
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 8px;
}

.page-title-box {
  padding: 25px 20px;
  margin: 0 -20px;
}

.page-title-box .page-title {
  margin-bottom: 0;
  float: left;
}

.page-title-box .breadcrumb {
  float: right;
  background-color: transparent !important;
}

/* Body min-height set */
body.enlarged {
  min-height: 1250px;
}

body.enlarged.bg-transparent {
  min-height: 500px;
}

.open > .dropdown-menu {
  display: block;
}

.lang-option .bootstrap-select {
  margin: 17.5px 10px 0 10px !important;
}

.lang-option .bootstrap-select .btn-light {
  background-color: #348cd4 !important;
  border-color: #4998d8 !important;
  box-shadow: none !important;
  color: #ffffff !important;
}

/* Footer */
.footer {
  background-color: #ebebeb;
  bottom: 0;
  padding: 19px 30px 20px;
  position: absolute;
  right: 0;
  left: 240px;
}

.notify-list {
  padding: 10px;
}

.notification-list {
  height: 240px;
}

.notification-list .list-group-item {
  border: 0;
  border-radius: 0 !important;
  padding: 10px 15px;
}

.notification-list .list-group-item:first-of-type {
  border-top: 0;
}

.notification-list em {
  width: 36px;
  color: #ffffff;
  text-align: center;
  height: 36px;
  line-height: 36px;
  border-radius: 50%;
  margin-top: 2px;
  font-size: 16px;
}

.notification-list .media-left {
  float: left;
  display: inherit;
}

.notification-list .media-body {
  display: block;
  width: auto;
  overflow: hidden;
  margin-left: 16px;
}

.notification-list .media-body h5 {
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 100%;
  margin: 0;
  overflow: hidden;
  line-height: 20px;
  font-size: 13px;
  font-weight: 600;
}

.notification-list .media-body p {
  font-size: 13px;
  line-height: 20px;
  color: #797979;
}

.notifi-title {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 15px;
  text-transform: uppercase;
  font-weight: 600;
  padding: 11px 20px 15px;
  color: #313a46;
}

/* =============
   Demo Css
============= */
.demo-box {
  padding: 10px 15px;
}

/* Button demo */
.button-list {
  margin-left: -8px;
  margin-bottom: -12px;
}

.button-list .btn {
  margin-bottom: 12px;
  margin-left: 8px;
}

/* Popover */
.demo-popover .popover {
  position: relative;
  display: block;
  float: left;
  width: 260px;
  margin: 20px;
  z-index: 9;
}

/* Tooltips */
.demo-tooltip .tooltip {
  position: relative;
  display: inline-block;
  margin: 10px 20px;
  opacity: 1;
}

/* Grid page */
.grid-structure .grid-container {
  background-color: rgba(243, 243, 243, 0.5);
  margin-top: 10px;
  padding: 10px 20px;
}

/* Demo Animation */
.demo-animation {
  text-align: center;
}

.demo-animation img {
  position: relative;
  width: 120px;
  display: block;
  margin: 0 auto 40px auto;
  z-index: 1;
  border-radius: 2px;
}

/* Demo only */
.icon-list-demo div {
  cursor: pointer;
  line-height: 45px;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
}

.icon-list-demo div p {
  margin-bottom: 0;
  line-height: inherit;
}

.icon-list-demo i {
  text-align: center;
  vertical-align: middle;
  font-size: 24px;
  width: 50px;
  height: 50px;
  line-height: 50px;
  margin-right: 12px;
  color: rgba(49, 58, 70, 0.7);
  border-radius: 3px;
  display: inline-block;
  transition: all 0.2s;
}

.icon-list-demo .col-md-4 {
  border-radius: 3px;
  -moz-border-radius: 3px;
  background-clip: padding-box;
  margin-bottom: 10px;
}

.icon-list-demo .col-md-4:hover i {
  color: #ffffff;
  background-color: #3456d4;
}

/* Switchery demo */
.switchery-demo {
  margin-bottom: -10px;
}

.switchery-demo .switchery {
  margin-bottom: 10px;
  margin-right: 5px;
}

/* Icon colored demo */
.icon-colored {
  height: 48px;
  width: 48px;
  margin: 1.4rem;
}

/* =============
   Buttons
============= */
.btn {
  border-radius: 2px;
  font-size: 13px;
  padding: 7px 14px;
  outline: none !important;
  font-family: 'Poppins', sans-serif;
}

.btn-md {
  padding: 9px 18px;
}

.btn-group-lg > .btn,
.btn-lg {
  padding: 12px 20px !important;
  font-size: 16px;
}

.btn-group-sm > .btn,
.btn-sm {
  padding: 5px 10px !important;
  font-size: 13px;
}

.btn-group-xs > .btn,
.btn-xs {
  padding: 1px 5px !important;
  font-size: 12px;
}

.btn-group.open .dropdown-toggle {
  box-shadow: 0 0 0 100px rgba(0, 0, 0, 0.1) inset;
}

.btn-custom,
.btn-primary,
.btn-success,
.btn-info,
.btn-warning,
.btn-danger,
.btn-inverse,
.btn-purple,
.btn-pink {
  color: #ffffff !important;
}

.btn-custom {
  background-color: #348cd4;
  border-color: #348cd4;
}

.btn-custom:hover,
.btn-custom:focus,
.btn-custom:active,
.btn-custom.active,
.btn-custom.focus,
.btn-custom:active,
.btn-custom:focus,
.btn-custom:hover,
.open > .dropdown-toggle.btn-custom {
  background-color: #2a7fc5 !important;
  border: 1px solid #2a7fc5 !important;
}

.btn-primary {
  background-color: #3456d4 !important;
  border: 1px solid #3456d4 !important;
}

.btn-primary-map {
  background-color: #2184be !important;
  border: 1px solid #2184be !important;
  left: 10px !important;
  color: #fff;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.btn-primary.focus,
.btn-primary:active,
.btn-primary:focus,
.btn-primary:hover,
.open > .dropdown-toggle.btn-primary {
  background-color: #2a4bc5 !important;
  border-color: #2a4bc5 !important;
}

.btn-success {
  background-color: #78c350 !important;
  border: 1px solid #78c350 !important;
}

.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success.active,
.btn-success.focus,
.btn-success:active,
.btn-success:focus,
.btn-success:hover,
.open > .dropdown-toggle.btn-success {
  background-color: #6aba40 !important;
  border-color: #6aba40 !important;
}

.btn-info {
  background-color: #45bbe0 !important;
  border: 1px solid #45bbe0 !important;
}

.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-info.active,
.btn-info.focus,
.btn-info:active,
.btn-info:focus,
.btn-info:hover,
.open > .dropdown-toggle.btn-info {
  background-color: #2fb3dc !important;
  border-color: #2fb3dc !important;
}

.btn-warning {
  background-color: #ff9800 !important;
  border: 1px solid #ff9800 !important;
}

.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active,
.btn-warning.active,
.btn-warning.focus,
.btn-warning:active,
.btn-warning:focus,
.btn-warning:hover,
.open > .dropdown-toggle.btn-warning {
  background-color: #e68900 !important;
  border-color: #e68900 !important;
}

.btn-danger {
  background-color: #f7531f !important;
  border: 1px solid #f7531f !important;
}

.btn-danger:active,
.btn-danger:focus,
.btn-danger:hover,
.btn-danger.active,
.btn-danger.focus,
.btn-danger:active,
.btn-danger:focus,
.btn-danger:hover,
.open > .dropdown-toggle.btn-danger {
  background-color: #f44109 !important;
  border-color: #f44109 !important;
}

.btn-inverse {
  background-color: #3b3e47 !important;
  border: 1px solid #3b3e47 !important;
}

.btn-inverse:hover,
.btn-inverse:focus,
.btn-inverse:active,
.btn-inverse.active,
.btn-inverse.focus,
.btn-inverse:active,
.btn-inverse:focus,
.btn-inverse:hover,
.open > .dropdown-toggle.btn-inverse {
  background-color: #2f3239 !important;
  border-color: #2f3239 !important;
}

.btn-purple {
  background-color: #8892d6 !important;
  border: 1px solid #8892d6 !important;
}

.btn-purple:hover,
.btn-purple:focus,
.btn-purple:active {
  background-color: #7581cf !important;
  border-color: #7581cf !important;
}

.btn-pink {
  background-color: #f06292 !important;
  border: 1px solid #f06292 !important;
}

.btn-pink:hover,
.btn-pink:focus,
.btn-pink:active {
  background-color: #ee4b82 !important;
  border-color: #ee4b82 !important;
}

.btn-bordered {
  background-color: transparent !important;
}

.btn-bordered.btn-light {
  background-color: #ffffff;
  border: 2px solid rgba(49, 58, 70, 0.07) !important;
}

.btn-bordered.btn-custom {
  color: #348cd4 !important;
  border: 2px solid #348cd4 !important;
}

.btn-bordered.btn-custom:hover,
.btn-bordered.btn-custom:focus,
.btn-bordered.btn-custom:active {
  background-color: #348cd4;
  color: #ffffff !important;
  border: 2px solid #287abc !important;
}

.btn-bordered.btn-primary {
  color: #3456d4 !important;
  border: 2px solid #3456d4 !important;
}

.btn-bordered.btn-primary:hover,
.btn-bordered.btn-primary:focus,
.btn-bordered.btn-primary:active {
  background-color: #3456d4;
  color: #ffffff !important;
  border: 2px solid #2847bc !important;
}

.btn-bordered.btn-success {
  color: #78c350 !important;
  border: 2px solid #78c350 !important;
}

.btn-bordered.btn-success:hover,
.btn-bordered.btn-success:focus,
.btn-bordered.btn-success:active {
  background-color: #78c350;
  color: #ffffff !important;
  border: 2px solid #66b23d !important;
}

.btn-bordered.btn-info {
  color: #45bbe0 !important;
  border: 2px solid #45bbe0 !important;
}

.btn-bordered.btn-info:hover,
.btn-bordered.btn-info:focus,
.btn-bordered.btn-info:active {
  background-color: #45bbe0;
  color: #ffffff !important;
  border: 2px solid #26b0db !important;
}

.btn-bordered.btn-warning {
  color: #ff9800 !important;
  border: 2px solid #ff9800 !important;
}

.btn-bordered.btn-warning:hover,
.btn-bordered.btn-warning:focus,
.btn-bordered.btn-warning:active {
  background-color: #ff9800;
  color: #ffffff !important;
  border: 2px solid #db8300 !important;
}

.btn-bordered.btn-danger {
  color: #f7531f !important;
  border: 2px solid #f7531f !important;
}

.btn-bordered.btn-danger:hover,
.btn-bordered.btn-danger:focus,
.btn-bordered.btn-danger:active {
  background-color: #f7531f;
  color: #ffffff !important;
  border: 2px solid #ea3f08 !important;
}

.btn-bordered.btn-inverse {
  color: #3b3e47 !important;
  border: 2px solid #3b3e47 !important;
}

.btn-bordered.btn-inverse:hover,
.btn-bordered.btn-inverse:focus,
.btn-bordered.btn-inverse:active {
  background-color: #3b3e47;
  color: #ffffff !important;
  border: 2px solid #2b2d34 !important;
}

.btn-bordered.btn-purple {
  color: #8892d6 !important;
  border: 2px solid #8892d6 !important;
}

.btn-bordered.btn-purple:hover,
.btn-bordered.btn-purple:focus,
.btn-bordered.btn-purple:active {
  background-color: #8892d6;
  color: #ffffff !important;
  border: 2px solid #6d7acd !important;
}

.btn-bordered.btn-pink {
  color: #f06292 !important;
  border: 2px solid #f06292 !important;
}

.btn-bordered.btn-pink:hover,
.btn-bordered.btn-pink:focus,
.btn-bordered.btn-pink:active {
  background-color: #f06292;
  color: #ffffff !important;
  border: 2px solid #ed417b !important;
}

.btn-rounded {
  border-radius: 2em;
}

/* Social Buttons */
.btn-facebook {
  color: #ffffff !important;
  background-color: #3b5998 !important;
}

.btn-twitter {
  color: #ffffff !important;
  background-color: #00aced !important;
}

.btn-linkedin {
  color: #ffffff !important;
  background-color: #007bb6 !important;
}

.btn-dribbble {
  color: #ffffff !important;
  background-color: #ea4c89 !important;
}

.btn-googleplus {
  color: #ffffff !important;
  background-color: #dd4b39 !important;
}

.btn-instagram {
  color: #ffffff !important;
  background-color: #517fa4 !important;
}

.btn-pinterest {
  color: #ffffff !important;
  background-color: #cb2027 !important;
}

.btn-dropbox {
  color: #ffffff !important;
  background-color: #007ee5 !important;
}

.btn-flickr {
  color: #ffffff !important;
  background-color: #ff0084 !important;
}

.btn-tumblr {
  color: #ffffff !important;
  background-color: #32506d !important;
}

.btn-skype {
  color: #ffffff !important;
  background-color: #00aff0 !important;
}

.btn-youtube {
  color: #ffffff !important;
  background-color: #bb0000 !important;
}

.btn-github {
  color: #ffffff !important;
  background-color: #171515 !important;
}

/* ===========
   cards
 =============*/
.card {
  border: 1px solid #e2e2e2;
  box-shadow: none;
  margin-bottom: 30px;
}

.card .card-body {
  padding: 20px;
}

.card .card-body p {
  line-height: 24px;
}

.card-heading {
  border: none !important;
  padding: 15px 20px;
  margin: -1px;
  border-radius: 4px 4px 0 0;
}

.card-default > .panel-heading {
  background-color: #ffffff;
  margin: 0;
  color: #797979;
}

.card-title {
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #797979;
}

.card-sub-title {
  color: rgba(255, 255, 255, 0.7);
  margin-top: 3px;
  margin-bottom: -4px;
}

.card-border {
  border-radius: 3px;
}

.card-border .card-heading {
  background-color: #ffffff;
  border-top: 3px solid #ccc !important;
  border-radius: 3px;
  padding: 15px 20px 0;
  margin: -2px 0 0 0 !important;
}

.card-border .card-body {
  padding: 15px 20px 20px 20px;
}

.card-border.card-primary .card-heading {
  border-color: #3456d4 !important;
}

.card-border.card-success .card-heading {
  border-color: #78c350 !important;
}

.card-border.card-info .card-heading {
  border-color: #45bbe0 !important;
}

.card-border.card-warning .card-heading {
  border-color: #ff9800 !important;
}

.card-border.card-danger .card-heading {
  border-color: #f7531f !important;
}

.card-border.card-purple .card-heading {
  border-color: #8892d6 !important;
}

.card-border.card-pink .card-heading {
  border-color: #f06292 !important;
}

.card-border.card-inverse .card-heading {
  border-color: #3b3e47 !important;
}

.accordion .card-title a {
  color: #797979;
}

/* =============
   Modals
============= */
.modal .modal-dialog .modal-content {
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  border-color: #dddddd;
  border-radius: 2px;
  box-shadow: none;
  padding: 16px;
}

.modal .modal-dialog .modal-content .modal-header {
  border-bottom-width: 2px;
  margin: 0;
  padding: 0;
  padding-bottom: 15px;
}

.modal .modal-dialog .modal-content .modal-body {
  padding: 20px 0;
}

.modal .modal-dialog .modal-content .modal-footer {
  padding: 0;
  padding-top: 15px;
}

.modal-full {
  width: 95%;
  max-width: none;
}

.modal-content .nav.nav-tabs + .tab-content {
  margin-bottom: 0;
}

.modal-content .panel-group {
  margin-bottom: 0;
}

.modal-content .panel {
  border-top: none;
}

/* Custom-modal */
.modal-demo {
  background-color: #ffffff;
  width: 600px;
  border-radius: 4px;
  display: none;
  position: relative;
}

.modal-demo .close {
  position: absolute;
  top: 15px;
  right: 25px;
  color: #e2e2e2;
  font-weight: 400;
}

.custom-modal-title {
  padding: 15px 25px 15px 25px;
  line-height: 22px;
  font-size: 18px;
  background-color: #313a46;
  color: #ffffff;
  text-align: left;
  margin: 0;
}

.custom-modal-text {
  padding: 20px;
}

.custombox-modal-flash .close,
.custombox-modal-rotatedown .close {
  top: 20px;
  z-index: 9999;
}

/* =============
   Checkbox and Radios
============= */
.checkbox label,
.radio label {
  padding-left: 25px !important;
  font-weight: 400;
}

.checkbox label:after,
.radio label:after {
  content: '';
  display: table;
  clear: both;
}

.checkbox .cr,
.radio .cr {
  position: relative;
  border: 1px solid #a9a9a9;
  border-radius: 3px;
  width: 20px;
  height: 20px;
  float: left;
}

.radio .cr {
  border-radius: 50%;
}

.checkbox .cr .cr-icon,
.radio .cr .cr-icon {
  position: absolute;
  font-size: 11px;
  line-height: 0;
  top: 9px;
  left: 3px;
}

.radio .cr .cr-icon {
  margin-left: 0.04em;
}

.checkbox label input[type='checkbox'],
.radio label input[type='radio'] {
  display: none !important;
}

.checkbox label input[type='checkbox'] + .cr > .cr-icon,
.radio label input[type='radio'] + .cr > .cr-icon {
  opacity: 0;
}

.checkbox label input[type='checkbox']:checked + .cr > .cr-icon,
.radio label input[type='radio']:checked + .cr > .cr-icon {
  opacity: 1;
}

.checkbox-custom label input[type='checkbox']:checked + .cr {
  background-color: #348cd4;
  border-color: #348cd4;
  color: #ffffff;
}

.checkbox-primary label input[type='checkbox']:checked + .cr {
  background-color: #3456d4;
  border-color: #3456d4;
  color: #ffffff;
}

.checkbox-success label input[type='checkbox']:checked + .cr {
  background-color: #78c350;
  border-color: #78c350;
  color: #ffffff;
}

.checkbox-info label input[type='checkbox']:checked + .cr {
  background-color: #45bbe0;
  border-color: #45bbe0;
  color: #ffffff;
}

.checkbox-warning label input[type='checkbox']:checked + .cr {
  background-color: #ff9800;
  border-color: #ff9800;
  color: #ffffff;
}

.checkbox-danger label input[type='checkbox']:checked + .cr {
  background-color: #f7531f;
  border-color: #f7531f;
  color: #ffffff;
}

.checkbox-inverse label input[type='checkbox']:checked + .cr {
  background-color: #3b3e47;
  border-color: #3b3e47;
  color: #ffffff;
}

.checkbox-pink label input[type='checkbox']:checked + .cr {
  background-color: #f06292;
  border-color: #f06292;
  color: #ffffff;
}

.checkbox-purple label input[type='checkbox']:checked + .cr {
  background-color: #8892d6;
  border-color: #8892d6;
  color: #ffffff;
}

.radio-primary label input[type='radio']:checked + .cr {
  border-color: #3456d4;
  color: #3456d4;
}

.radio-success label input[type='radio']:checked + .cr {
  border-color: #78c350;
  color: #78c350;
}

.radio-info label input[type='radio']:checked + .cr {
  border-color: #45bbe0;
  color: #45bbe0;
}

.radio-warning label input[type='radio']:checked + .cr {
  border-color: #ff9800;
  color: #ff9800;
}

.radio-danger label input[type='radio']:checked + .cr {
  border-color: #f7531f;
  color: #f7531f;
}

.radio-custom label input[type='radio']:checked + .cr {
  border-color: #348cd4;
  color: #348cd4;
}

.radio-inverse label input[type='radio']:checked + .cr {
  border-color: #3b3e47;
  color: #3b3e47;
}

.radio-pink label input[type='radio']:checked + .cr {
  border-color: #f06292;
  color: #f06292;
}

.radio-purple label input[type='radio']:checked + .cr {
  border-color: #8892d6;
  color: #8892d6;
}

.checkbox label input[type='checkbox']:disabled + .cr,
.radio label input[type='radio']:disabled + .cr {
  opacity: 0.5;
}

/* =============
   Tabs
============= */
.tab-content {
  padding: 20px 0 0 0;
}

.nav-tabs > li > a {
  color: #313a46;
  text-transform: uppercase;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
}

.nav-tabs > li > a:hover {
  background-color: rgba(152, 166, 173, 0.1);
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #348cd4;
}

/* Vertial tab */
.tabs-vertical-env .nav.tabs-vertical .nav-link {
  color: #313a46;
  text-align: center;
  font-weight: 600;
  text-transform: uppercase;
}

.tabs-vertical-env .nav.tabs-vertical .nav-link.active,
.tabs-vertical-env .nav.tabs-vertical .nav-link:hover {
  background-color: rgba(152, 166, 173, 0.1);
  color: #348cd4;
}

.tabs-bordered {
  border-bottom: 2px solid rgba(152, 166, 173, 0.2) !important;
}

.tabs-bordered .nav-item .nav-link,
.tabs-bordered .nav-item .nav-link:hover,
.tabs-bordered .nav-item .nav-link:focus {
  border: 0 !important;
  background-color: #ffffff !important;
  padding: 10px 20px !important;
}

.tabs-bordered .nav-item .nav-link.active {
  border-bottom: 2px solid #348cd4 !important;
  margin-bottom: -1px;
  color: #348cd4;
}

/* Navpills */
.nav-pills > li > a {
  color: #313a46;
}

.nav-pills > li.active > a,
.nav-pills > li.active > a:focus,
.nav-pills > li.active > a:hover {
  background-color: #348cd4;
}

/* =============
   Progressbars
============= */
.progress {
  -webkit-box-shadow: none !important;
  background-color: #f3f3f3;
  box-shadow: none !important;
  height: 10px;
  margin-bottom: 18px;
  overflow: hidden;
}

.progress-bar {
  box-shadow: none;
  font-size: 8px;
  font-weight: 600;
  line-height: 12px;
}

.progress.progress-sm {
  height: 5px !important;
}

.progress.progress-sm .progress-bar {
  font-size: 8px;
  line-height: 5px;
}

.progress.progress-md {
  height: 15px !important;
}

.progress.progress-md .progress-bar {
  font-size: 10.8px;
  line-height: 14.4px;
}

.progress.progress-lg {
  height: 20px !important;
}

.progress.progress-lg .progress-bar {
  font-size: 12px;
  line-height: 20px;
}

/* Progressbar Vertical */
.progress-vertical {
  min-height: 250px;
  height: 250px;
  width: 10px;
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}

.progress-vertical .progress-bar {
  width: 100%;
}

.progress-vertical-bottom {
  min-height: 250px;
  height: 250px;
  position: relative;
  width: 10px;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}

.progress-vertical-bottom .progress-bar {
  width: 100%;
  position: absolute;
  bottom: 0;
}

.progress-vertical.progress-sm,
.progress-vertical-bottom.progress-sm {
  width: 5px !important;
}

.progress-vertical.progress-sm .progress-bar,
.progress-vertical-bottom.progress-sm .progress-bar {
  font-size: 8px;
  line-height: 5px;
}

.progress-vertical.progress-md,
.progress-vertical-bottom.progress-md {
  width: 15px !important;
}

.progress-vertical.progress-md .progress-bar,
.progress-vertical-bottom.progress-md .progress-bar {
  font-size: 10.8px;
  line-height: 14.4px;
}

.progress-vertical.progress-lg,
.progress-vertical-bottom.progress-lg {
  width: 20px !important;
}

.progress-vertical.progress-lg .progress-bar,
.progress-vertical-bottom.progress-lg .progress-bar {
  font-size: 12px;
  line-height: 20px;
}

/* =============
   Alerts
============= */
.alert {
  position: relative;
}

.alert .alert-link {
  font-weight: 600;
}

.alert-dismissable .close,
.alert-dismissible .close {
  opacity: 0.9;
}

.alert-icon {
  padding-left: 50px;
}

.alert-icon i {
  position: absolute;
  left: 0;
  height: 50px;
  width: 50px;
  text-align: center;
  top: 0;
  line-height: 50px;
  font-size: 22px;
}

.alert-success {
  color: #78c350;
  background-color: #edf7e8;
  border-color: #b3dd9c;
}

.alert-success .alert-link {
  color: #5fa739;
}

.alert-success hr {
  border-top-color: #5fa739;
}

.alert-info {
  color: #45bbe0;
  background-color: #def3fa;
  border-color: #9cdbef;
}

.alert-info .alert-link {
  color: #23a6cf;
}

.alert-info hr {
  border-top-color: #23a6cf;
}

.alert-warning {
  color: #ff9800;
  background-color: #fff5e6;
  border-color: #ffd699;
}

.alert-warning .alert-link {
  color: #cc7a00;
}

.alert-warning hr {
  border-top-color: #cc7a00;
}

.alert-danger {
  color: #f7531f;
  background-color: #fef2ee;
  border-color: #fb9f81;
}

.alert-danger .alert-link {
  color: #db3b08;
}

.alert-danger hr {
  border-top-color: #db3b08;
}

.alert-white {
  background-color: #ffffff !important;
}

/* =============
   Notification
============= */
.jq-toast-single {
  border-radius: 0;
  font-family: 'Poppins', sans-serif;
  background-color: #313a46;
  font-size: 14px;
}

.jq-toast-single h2 {
  font-family: 'Poppins', sans-serif;
}

.jq-toast-single a {
  font-size: 14px;
}

.jq-toast-single a:hover {
  color: #348cd4;
}

.jq-icon-info {
  background-color: #45bbe0;
  color: #ffffff;
  border-color: #45bbe0;
}

.jq-icon-success {
  background-color: #78c350;
  color: #ffffff;
  border-color: #78c350;
}

.jq-icon-warning {
  background-color: #ff9800;
  color: #ffffff;
  border-color: #ff9800;
}

.jq-icon-error {
  background-color: #f7531f;
  color: #ffffff;
  border-color: #f7531f;
}

.close-jq-toast-single {
  position: absolute;
  top: -12px;
  right: -12px;
  font-size: 20px;
  cursor: pointer;
  height: 32px;
  width: 32px;
  background-color: #313a46;
  border-radius: 50%;
  text-align: center;
  line-height: 32px;
}

.jq-toast-loader {
  height: 3px;
  border-radius: 0;
}

/* =================
   Popover / Tooltips
==================== */
/* Popover */
.popover {
  font-family: inherit;
  border: none;
  border-radius: 3px;
  -moz-border-radius: 3px;
  background-clip: padding-box;
  box-shadow: 0 0 28px rgba(0, 0, 0, 0.15);
}

.popover .popover-title {
  background-color: transparent;
  color: #348cd4;
  padding: 12px 15px;
  font-size: 15px;
  border-bottom: 1px solid rgba(226, 226, 226, 0.7);
}

.popover .popover-header {
  margin-top: 0px;
}

.popover .popover-content {
  padding: 9px 14px;
}

.popover .arrow {
  border-color: transparent !important;
}

/* Tooltips */
.tooltip {
  font-family: 'Poppins', sans-serif;
}

.tooltip .tooltip-inner {
  padding: 4px 10px;
  border-radius: 2px;
  background-color: #313a46;
}

.tooltip.left .tooltip-arrow {
  border-left-color: #313a46;
}

.tooltip.top .tooltip-arrow {
  border-top-color: #313a46;
}

.tooltip.bottom .tooltip-arrow {
  border-bottom-color: #313a46;
}

.tooltip.right .tooltip-arrow {
  border-right-color: #313a46;
}

/* Tooltpster */
.tooltipster-sidetip .tooltipster-box {
  background-color: #348cd4;
  border: 2px solid #348cd4;
}

.tooltipster-sidetip.tooltipster-top .tooltipster-arrow-border,
.tooltipster-sidetip.tooltipster-top .tooltipster-arrow-background {
  border-top-color: #348cd4;
}

.tooltipster-sidetip.tooltipster-bottom .tooltipster-arrow-border,
.tooltipster-sidetip.tooltipster-bottom
  .tooltipster-arrow-background {
  border-bottom-color: #348cd4;
}

.tooltipster-sidetip.tooltipster-left .tooltipster-arrow-border,
.tooltipster-sidetip.tooltipster-left .tooltipster-arrow-background {
  border-left-color: #348cd4;
}

.tooltipster-sidetip.tooltipster-right .tooltipster-arrow-border,
.tooltipster-sidetip.tooltipster-right .tooltipster-arrow-background {
  border-right-color: #348cd4;
}

/* =====================================
   CHARTS
   ===================================== */
.dash-chart-bar {
  height: 370px !important;
  max-height: 500px;
}

/* Dashboard */
#dashboard-chart-one {
  max-height: 320px;
  height: 320px;
}

#dashboard-chart-one .ct-labels .ct-horizontal {
  margin-left: -20px;
  display: block;
  text-align: center !important;
}

#dashboard-chart-one .ct-area {
  fill-opacity: 0.4;
}

#dashboard-chart-one .ct-line {
  stroke-width: 2px;
}

#dashboard-chart-one .ct-point {
  stroke-width: 6px;
}

.chart-detail-list li {
  margin: 0 10px;
}

.chart-detail-list li h5 {
  color: rgba(49, 58, 70, 0.6);
  text-transform: uppercase;
  font-size: 13px;
}

/* Flot chart */
#flotTip {
  padding: 8px 12px;
  background-color: #313a46 !important;
  z-index: 100;
  color: #ffffff;
  opacity: 0.9;
  font-size: 13px;
  border-radius: 3px !important;
}

.legend tr {
  height: 20px;
  font-family: 'Poppins', sans-serif;
}

.legendLabel {
  padding-left: 5px !important;
  line-height: 10px;
  padding-right: 10px;
}

/* Morris chart */
.morris-hover.morris-default-style {
  border-radius: 5px;
  padding: 10px 12px;
}

.morris-chart text {
  font-family: 'Poppins', sans-serif !important;
}

/* Chartist chart */
.ct-golden-section:before {
  float: none;
}

.ct-chart {
  max-height: 300px;
}

.ct-chart .ct-label {
  fill: #98a6ad;
  color: #98a6ad;
  font-size: 14px;
  line-height: 1;
}

.ct-grid {
  stroke: rgba(49, 58, 70, 0.1);
}

.ct-chart.simple-pie-chart-chartist .ct-label {
  color: #ffffff;
  fill: #ffffff;
  font-size: 16px;
}

.ct-chart .ct-series.ct-series-a .ct-bar,
.ct-chart .ct-series.ct-series-a .ct-line,
.ct-chart .ct-series.ct-series-a .ct-point,
.ct-chart .ct-series.ct-series-a .ct-slice-donut {
  stroke: #3456d4;
}

.ct-chart .ct-series.ct-series-b .ct-bar,
.ct-chart .ct-series.ct-series-b .ct-line,
.ct-chart .ct-series.ct-series-b .ct-point,
.ct-chart .ct-series.ct-series-b .ct-slice-donut {
  stroke: #45bbe0;
}

.ct-chart .ct-series.ct-series-c .ct-bar,
.ct-chart .ct-series.ct-series-c .ct-line,
.ct-chart .ct-series.ct-series-c .ct-point,
.ct-chart .ct-series.ct-series-c .ct-slice-donut {
  stroke: #348cd4;
}

.ct-chart .ct-series.ct-series-d .ct-bar,
.ct-chart .ct-series.ct-series-d .ct-line,
.ct-chart .ct-series.ct-series-d .ct-point,
.ct-chart .ct-series.ct-series-d .ct-slice-donut {
  stroke: #8892d6;
}

.ct-chart .ct-series.ct-series-e .ct-bar,
.ct-chart .ct-series.ct-series-e .ct-line,
.ct-chart .ct-series.ct-series-e .ct-point,
.ct-chart .ct-series.ct-series-e .ct-slice-donut {
  stroke: #313a46;
}

.ct-chart .ct-series.ct-series-f .ct-bar,
.ct-chart .ct-series.ct-series-f .ct-line,
.ct-chart .ct-series.ct-series-f .ct-point,
.ct-chart .ct-series.ct-series-f .ct-slice-donut {
  stroke: #f06292;
}

.ct-chart .ct-series.ct-series-g .ct-bar,
.ct-chart .ct-series.ct-series-g .ct-line,
.ct-chart .ct-series.ct-series-g .ct-point,
.ct-chart .ct-series.ct-series-g .ct-slice-donut {
  stroke: #f7531f;
}

.ct-series-a .ct-area,
.ct-series-a .ct-slice-pie {
  fill: #3456d4;
}

.ct-series-b .ct-area,
.ct-series-b .ct-slice-pie {
  fill: #45bbe0;
}

.ct-series-c .ct-area,
.ct-series-c .ct-slice-pie {
  fill: #348cd4;
}

.ct-series-d .ct-area,
.ct-series-d .ct-slice-pie {
  fill: #348cd4;
}

.chartist-tooltip {
  position: absolute;
  display: inline-block;
  opacity: 0;
  min-width: 10px;
  padding: 2px 10px;
  border-radius: 3px;
  background: #313a46;
  color: #ffffff;
  text-align: center;
  pointer-events: none;
  z-index: 1;
  transition: opacity 0.2s linear;
}

.chartist-tooltip.tooltip-show {
  opacity: 1;
}

/* C3 chart */
.c3 svg {
  max-width: 100%;
}

.c3-tooltip td > span {
  background: #313a46;
}

.c3-tooltip td {
  border-left: none;
}

.c3-tooltip {
  box-shadow: 0 8px 40px 0 rgba(0, 0, 0, 0.12);
  opacity: 1;
}

.c3-chart-arcs-title {
  font-size: 18px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
}

.c3-tooltip tr {
  border: none !important;
}

.c3-tooltip th {
  background-color: #313a46;
}

.c3-tooltip .value {
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
}

/* Sparkline chart */
.jqstooltip {
  box-sizing: content-box;
  width: auto !important;
  height: auto !important;
  background-color: #313a46 !important;
  padding: 5px 10px !important;
  border-radius: 3px;
  -moz-border-radius: 3px;
  border-color: #313a46 !important;
}

.jqsfield {
  font-size: 12px !important;
  line-height: 18px !important;
}

/* Google Chart*/
.google-chart .chart {
  display: inline-block;
}

/* =============
   Form Elements
============= */
/* Form components */
label {
  font-weight: 500;
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
}

textarea.form-control {
  min-height: 90px;
}

.form-control {
  border: 1px solid #dadada;
  border-radius: 4px;
  padding: 7px 12px;
  height: 38px;
  max-width: 100%;
  font-size: 13px;
  box-shadow: none;
  transition: all 300ms linear;
  appearance: auto;
}

.form-control:focus {
  border: 1px solid #afafaf;
  box-shadow: none;
  outline: 0 !important;
}

.input-lg {
  height: 46px;
  padding: 10px 16px;
  font-size: 14px;
  line-height: 1.3333333;
  border-radius: 4px;
}

.input-sm {
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}

.form-horizontal .form-group {
  margin-left: -10px;
}

.form-control-feedback {
  line-height: 38px !important;
}

.input-group-btn .btn {
  padding: 7px 12px;
}

.input-group-btn .btn-sm {
  padding: 5px 10px;
}

.input-group-btn .btn-lg {
  padding: 10px 17px;
}

.has-success .checkbox,
.has-success .checkbox-inline,
.has-success .control-label,
.has-success .help-block,
.has-success .radio,
.has-success .radio-inline,
.has-success.checkbox label,
.has-success.checkbox-inline label,
.has-success.radio label,
.has-success.radio-inline label,
.has-success .form-control-feedback {
  color: #78c350;
}

.has-warning .checkbox,
.has-warning .checkbox-inline,
.has-warning .control-label,
.has-warning .help-block,
.has-warning .radio,
.has-warning .radio-inline,
.has-warning.checkbox label,
.has-warning.checkbox-inline label,
.has-warning.radio label,
.has-warning.radio-inline label,
.has-warning .form-control-feedback {
  color: #ff9800;
}

.has-error .checkbox,
.has-error .checkbox-inline,
.has-error .control-label,
.has-error .help-block,
.has-error .radio,
.has-error .radio-inline,
.has-error.checkbox label,
.has-error.checkbox-inline label,
.has-error.radio label,
.has-error.radio-inline label,
.has-error .form-control-feedback {
  color: #f7531f;
}

.has-success .form-control {
  border-color: #78c350;
  box-shadow: none !important;
}

.has-warning .form-control {
  border-color: #ff9800;
  box-shadow: none !important;
}

.has-error .form-control {
  border-color: #f7531f;
  box-shadow: none !important;
}

.input-group-text {
  font-size: 26px;
}

/* =============
   Form Advanced
============= */
/* Bootstrap tagsinput */
.bootstrap-tagsinput {
  box-shadow: none;
  padding: 5px 7px 5px;
  width: 100%;
  border: 1px solid #e3e3e3;
}

.bootstrap-tagsinput .badge-info {
  background-color: #348cd4 !important;
  display: inline-block;
  padding: 5px;
  margin: 3px 1px;
}

.bootstrap-select {
  height: inherit;
}

.bootstrap-select > .dropdown-menu > .dropdown-menu li a {
  display: block;
  width: 100%;
  clear: both;
  font-weight: 400;
  color: #313a46;
  text-align: inherit;
  white-space: nowrap;
  background: 0 0;
  border: 0;
}

/* Select 2 */
.select2-container {
  width: 100% !important;
}

.select2-container .select2-selection--single {
  border: 1px solid #e3e3e3 !important;
  height: 38px !important;
}

.select2-container
  .select2-selection--single
  .select2-selection__rendered {
  line-height: 36px !important;
  padding-left: 12px !important;
}

.select2-container
  .select2-selection--single
  .select2-selection__arrow {
  height: 34px;
  width: 34px;
  right: 3px;
}

.select2-container
  .select2-selection--single
  .select2-selection__arrow
  b {
  border-color: #999 transparent transparent transparent;
  border-width: 6px 6px 0 6px;
}

.select2-container--open
  .select2-selection--single
  .select2-selection__arrow
  b {
  border-color: transparent transparent #999 transparent !important;
  border-width: 0 6px 6px 6px !important;
}

.select2-container--default
  .select2-results__option--highlighted[aria-selected] {
  background-color: #348cd4;
}

.select2-results__option {
  padding: 6px 12px;
}

.select2-dropdown {
  border: 1px solid #e3e3e3 !important;
  padding-top: 5px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
}

.select2-search input {
  border: 1px solid #e3e3e3 !important;
}

.select2-container .select2-selection--multiple {
  min-height: 38px !important;
  border: 1px solid #e3e3e3 !important;
}

.select2-container
  .select2-selection--multiple
  .select2-selection__rendered {
  padding: 2px 10px;
}

.select2-container
  .select2-selection--multiple
  .select2-search__field {
  margin-top: 7px;
  border: 0 !important;
}

.select2-container
  .select2-selection--multiple
  .select2-selection__choice {
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 1px;
  padding: 0 7px;
}

/* bootstrap-filestyle */
.bootstrap-filestyle label {
  margin: 0;
  height: 100%;
}

/* AUTOCOMPLETE */
.autocomplete-suggestions {
  border: 1px solid #f9f9f9;
  background: #ffffff;
  cursor: default;
  overflow: auto;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
}

.autocomplete-suggestion {
  padding: 2px 5px;
  white-space: nowrap;
  overflow: hidden;
}

.autocomplete-no-suggestion {
  padding: 2px 5px;
}

.autocomplete-selected {
  background: rgba(152, 166, 173, 0.3);
  cursor: pointer;
}

.autocomplete-suggestions strong {
  font-weight: bold;
  color: #313a46;
}

.autocomplete-group {
  padding: 2px 5px;
}

.autocomplete-group strong {
  font-weight: bold;
  font-size: 16px;
  color: #313a46;
  display: block;
}

/* Bootstrap-select */
.bootstrap-select:not([class*='col-']):not(
    [class*='form-control']
  ):not(.input-group-btn) {
  width: 100% !important;
}

.bootstrap-select .dropdown-toggle:focus {
  outline: none !important;
}

/* Bootstrap filestyle */
.icon-span-filestyle {
  padding-right: 5px;
}

/* =============
   Form validation
============= */
.parsley-error {
  border-color: #f7531f !important;
}

.parsley-errors-list {
  display: none;
  margin: 0;
  padding: 0;
}

.parsley-errors-list > li {
  font-size: 12px;
  list-style: none;
  color: #f7531f;
  margin-top: 5px;
}

/* =============
   Form pickers
============= */
.bootstrap-timepicker-widget table td input {
  border: 1px solid rgba(49, 58, 70, 0.3);
  width: 35px;
}

.datepicker-dropdown {
  padding: 10px !important;
}

.datepicker td,
.datepicker th {
  width: 30px;
  height: 30px;
}

.datepicker table tr td.active:hover,
.datepicker table tr td.active:hover:hover,
.datepicker table tr td.active.disabled:hover,
.datepicker table tr td.active.disabled:hover:hover,
.datepicker table tr td.active:active,
.datepicker table tr td.active:hover:active,
.datepicker table tr td.active.disabled:active,
.datepicker table tr td.active.disabled:hover:active,
.datepicker table tr td.active.active,
.datepicker table tr td.active:hover.active,
.datepicker table tr td.active.disabled.active,
.datepicker table tr td.active.disabled:hover.active,
.datepicker table tr td.active.disabled,
.datepicker table tr td.active:hover.disabled,
.datepicker table tr td.active.disabled.disabled,
.datepicker table tr td.active.disabled:hover.disabled,
.datepicker table tr td.active[disabled],
.datepicker table tr td.active:hover[disabled],
.datepicker table tr td.active.disabled[disabled],
.datepicker table tr td.active.disabled:hover[disabled],
.datepicker table tr td.selected,
.datepicker table tr td.selected:hover,
.datepicker table tr td.selected.disabled,
.datepicker table tr td.selected.disabled:hover {
  background-color: #348cd4 !important;
  color: #ffffff !important;
  background-image: none !important;
  text-shadow: none !important;
}

.datepicker table tr td.today,
.datepicker table tr td.today:hover,
.datepicker table tr td.today.disabled,
.datepicker table tr td.today.disabled:hover {
  background-color: #78c350 !important;
  color: #ffffff !important;
  background-image: none !important;
}

.datepicker-inline {
  border: 2px solid rgba(49, 58, 70, 0.1);
}

.daterangepicker td.active,
.daterangepicker td.active:hover {
  background-color: #348cd4;
  color: #ffffff !important;
}

.daterangepicker .input-mini.active {
  border: 1px solid rgba(49, 58, 70, 0.1);
}

.daterangepicker .ranges li {
  border-radius: 2px;
  color: #313a46;
  font-weight: 600;
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
}

.daterangepicker select.hourselect,
.daterangepicker select.minuteselect,
.daterangepicker select.secondselect,
.daterangepicker select.ampmselect {
  border: 1px solid rgba(49, 58, 70, 0.3);
  padding: 2px;
  width: 60px;
}

.daterangepicker .ranges li.active,
.daterangepicker .ranges li:hover {
  background-color: #348cd4;
  color: #ffffff;
}

.datepicker > div {
  display: block;
}

.table-condensed > thead > tr > th,
.table-condensed > tbody > tr > td {
  font-size: 14px;
  padding: 5px;
  color: #797979;
}

/* =============
   Form Wizard
============= */
.wizard > .content {
  background: #ffffff;
  min-height: 240px;
  padding: 20px !important;
  border: 1px solid #f3f3f3;
  margin-top: 10px !important;
}

.wizard > .content > .body {
  padding: 0px;
  position: relative;
  width: 100%;
}

.wizard > .content > .body input {
  border: 1px solid #e9e9e9;
}

.wizard > .content > .body ul > li {
  display: block;
  line-height: 30px;
}

.wizard > .content > .body label.error {
  color: #f7531f;
  margin-left: 0;
  margin-top: 5px;
  font-size: 12px;
}

.wizard > .content > .body label {
  display: inline-block;
  margin-top: 10px;
}

.wizard > .steps a {
  font-size: 16px;
  text-align: center;
  font-family: 'Poppins', sans-serif;
}

.wizard > .steps .number {
  font-size: 74px;
  line-height: 86px;
  font-family: 'Poppins', sans-serif;
  position: absolute;
  left: 10px;
  top: -14px;
  opacity: 0.1;
}

.wizard > .steps .disabled a {
  background: #f3f3f3;
  color: #3c4655 !important;
  cursor: default;
  border: 1px solid #e6e6e6;
}

.wizard > .steps .disabled a:hover {
  background: #e6e6e6;
  border: 1px solid #dadada;
}

.wizard > .steps .disabled a:active {
  background: #e6e6e6;
  border: 1px solid #dadada;
}

.wizard > .steps .current a {
  background: #348cd4;
}

.wizard > .steps .current a:hover {
  background: #348cd4;
}

.wizard > .steps .current a:hover .number {
  color: #ffffff;
  opacity: 0.4;
}

.wizard > .steps .current a:active {
  background: #348cd4;
}

.wizard > .steps .current a:active .number {
  color: #ffffff;
  opacity: 0.4;
}

.wizard > .steps .current a .number {
  color: #ffffff;
  opacity: 0.4;
}

.wizard > .steps .done a {
  background: #f3f3f3 !important;
  color: #3c4655 !important;
}

.wizard > .steps a,
.wizard > .steps a:hover,
.wizard > .steps a:active,
.wizard > .content {
  border-radius: 2px;
  position: relative;
}

.wizard > .actions {
  margin-top: 15px !important;
}

.wizard > .actions a {
  background: #348cd4;
  border-radius: 25px !important;
  color: #ffffff;
}

.wizard > .actions a:hover {
  background: #21649b;
  color: #ffffff;
}

.wizard > .actions a:active {
  background: #21649b;
  color: #ffffff;
}

.wizard > .actions .disabled a {
  background: #ffffff;
  color: #313a46;
  cursor: default;
  border: 1px solid #eaeaea;
}

.wizard > .actions .disabled a:hover {
  background: #f3f3f3;
  color: #313a46;
  cursor: default;
  border: 1px solid #eaeaea;
}

.wizard > .actions .disabled a:active {
  background: #f3f3f3;
  color: #313a46;
  cursor: default;
  border: 1px solid #eaeaea;
}

.wizard.vertical > .content {
  margin-top: 0px !important;
}

@media (max-width: 560px) {
  .wizard.vertical > .steps,
  .wizard.vertical > .content {
    width: 100%;
  }
}

/* =============
   Form Editor
============= */
/* Summernote */
.note-editor {
  position: relative;
  margin-bottom: 0px;
}

.note-editor .btn-light {
  background-color: transparent;
  border-color: transparent !important;
}

.note-editor .btn-group-sm > .btn,
.note-editor .btn-sm {
  padding: 8px 12px !important;
}

.note-editor .note-toolbar {
  background-color: #f3f3f3;
  border-bottom: 1px solid #e2e2e2;
  margin: 0;
}

.note-editor .note-statusbar {
  background-color: #ffffff;
}

.note-editor .note-statusbar .note-resizebar {
  border-top: none;
  height: 15px;
  padding-top: 3px;
}

.note-editor.note-frame {
  border: 1px solid #e2e2e2 !important;
}

.note-popover .popover .popover-content {
  padding: 5px 0 10px 5px;
}

.note-popover .btn-default {
  background-color: transparent;
  border-color: transparent !important;
}

.note-popover .btn-group-sm > .btn,
.note-popover .btn-sm {
  padding: 8px 12px !important;
}

.note-toolbar {
  padding: 5px 0 10px 5px;
}

/* Wysiwig css */
.mce-panel {
  border: 1px solid #f3f3f3 !important;
  background-color: #f3f3f3 !important;
}

.mce-menu {
  background-color: #ffffff !important;
  box-shadow: 0 0px 24px 0 rgba(0, 0, 0, 0.06),
    0 1px 0px 0 rgba(0, 0, 0, 0.02);
}

.mce-menubar .mce-menubtn:hover,
.mce-menubar .mce-menubtn.mce-active,
.mce-menubar .mce-menubtn:focus {
  border-color: #f3f3f3 !important;
}

.mce-menu-item:hover,
.mce-menu-item.mce-selected,
.mce-menu-item:focus,
.mce-menu-item-normal.mce-active,
.mce-primary {
  background-color: #348cd4 !important;
}

.mce-window-head .mce-title {
  font-family: 'Poppins', sans-serif;
}

.mce-window {
  padding: 20px !important;
}

.mce-window-head {
  padding-bottom: 20px !important;
  border-bottom: 0 !important;
}

/* =============
   Form Uploads
============= */
.jFiler-input-dragDrop {
  width: 100%;
  background-color: #fafafa;
}

.jFiler-theme-default .jFiler-input {
  width: 100%;
}

.jFiler-theme-default .jFiler-input-button {
  background-color: #348cd4;
  background-image: none !important;
  color: #ffffff;
  border: 1px solid #348cd4 !important;
}

/* =============
   Tables
============= */
th {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
}

.table-centered td {
  vertical-align: middle !important;
}

/* Table colored */
.table-colored thead th {
  color: #ffffff;
}

.table-colored.table-custom thead th {
  background-color: #348cd4;
}

.table-colored.table-primary thead th {
  background-color: #3456d4;
}

.table-colored.table-success thead th {
  background-color: #78c350;
}

.table-colored.table-info thead th {
  background-color: #45bbe0;
}

.table-colored.table-warning thead th {
  background-color: #ff9800;
}

.table-colored.table-danger thead th {
  background-color: #f7531f;
}

.table-colored.table-inverse thead th {
  background-color: #3b3e47;
}

.table-colored.table-pink thead th {
  background-color: #f06292;
}

.table-colored.table-purple thead th {
  background-color: #8892d6;
}

/* Table colored-bordered */
.table-colored-bordered thead th {
  border-bottom: 0 !important;
  color: #ffffff;
}

.table-colored-bordered.table-bordered-primary {
  border: 2px solid #3456d4;
}

.table-colored-bordered.table-bordered-primary thead th {
  background-color: #3456d4;
}

.table-colored-bordered.table-bordered-success {
  border: 2px solid #78c350;
}

.table-colored-bordered.table-bordered-success thead th {
  background-color: #78c350;
}

.table-colored-bordered.table-bordered-info {
  border: 2px solid #45bbe0;
}

.table-colored-bordered.table-bordered-info thead th {
  background-color: #45bbe0;
}

.table-colored-bordered.table-bordered-custom {
  border: 2px solid #348cd4;
}

.table-colored-bordered.table-bordered-custom thead th {
  background-color: #348cd4;
}

.table-colored-bordered.table-bordered-warning {
  border: 2px solid #ff9800;
}

.table-colored-bordered.table-bordered-warning thead th {
  background-color: #ff9800;
}

.table-colored-bordered.table-bordered-danger {
  border: 2px solid #f7531f;
}

.table-colored-bordered.table-bordered-danger thead th {
  background-color: #f7531f;
}

.table-colored-bordered.table-bordered-inverse {
  border: 2px solid #3b3e47;
}

.table-colored-bordered.table-bordered-inverse thead th {
  background-color: #3b3e47;
}

.table-colored-bordered.table-bordered-pink {
  border: 2px solid #f06292;
}

.table-colored-bordered.table-bordered-pink thead th {
  background-color: #f06292;
}

.table-colored-bordered.table-bordered-purple {
  border: 2px solid #8892d6;
}

.table-colored-bordered.table-bordered-purple thead th {
  background-color: #8892d6;
}

/* Table full colored */
.table-colored-full {
  color: #ffffff;
}

.table-colored-full thead th {
  border-bottom: 0 !important;
  padding: 10px !important;
}

.table-colored-full tbody td,
.table-colored-full tbody th {
  border: 0 !important;
}

.table-colored-full tbody tr:hover {
  color: #ffffff;
}

.table-colored-full.table-full-primary {
  background-color: rgba(52, 86, 212, 0.8);
}

.table-colored-full.table-full-primary thead th {
  background-color: #3456d4;
}

.table-colored-full.table-full-primary tbody tr:hover {
  background-color: #3456d4;
}

.table-colored-full.table-full-success {
  background-color: rgba(120, 195, 80, 0.8);
}

.table-colored-full.table-full-success thead th {
  background-color: #78c350;
}

.table-colored-full.table-full-success tbody tr:hover {
  background-color: #78c350;
}

.table-colored-full.table-full-info {
  background-color: rgba(69, 187, 224, 0.8);
}

.table-colored-full.table-full-info thead th {
  background-color: #45bbe0;
}

.table-colored-full.table-full-info tbody tr:hover {
  background-color: #45bbe0;
}

.table-colored-full.table-full-custom {
  background-color: rgba(52, 140, 212, 0.8);
}

.table-colored-full.table-full-custom thead th {
  background-color: #348cd4;
}

.table-colored-full.table-full-custom tbody tr:hover {
  background-color: #348cd4;
}

.table-colored-full.table-full-warning {
  background-color: rgba(255, 152, 0, 0.8);
}

.table-colored-full.table-full-warning thead th {
  background-color: #ff9800;
}

.table-colored-full.table-full-warning tbody tr:hover {
  background-color: #ff9800;
}

.table-colored-full.table-full-danger {
  background-color: rgba(247, 83, 31, 0.8);
}

.table-colored-full.table-full-danger thead th {
  background-color: #f7531f;
}

.table-colored-full.table-full-danger tbody tr:hover {
  background-color: #f7531f;
}

.table-colored-full.table-full-inverse {
  background-color: rgba(59, 62, 71, 0.8);
}

.table-colored-full.table-full-inverse thead th {
  background-color: #3b3e47;
}

.table-colored-full.table-full-inverse tbody tr:hover {
  background-color: #3b3e47;
}

.table-colored-full.table-full-pink {
  background-color: rgba(240, 98, 146, 0.8);
}

.table-colored-full.table-full-pink thead th {
  background-color: #f06292;
}

.table-colored-full.table-full-pink tbody tr:hover {
  background-color: #f06292;
}

.table-colored-full.table-full-purple {
  background-color: rgba(136, 146, 214, 0.8);
}

.table-colored-full.table-full-purple thead th {
  background-color: #8892d6;
}

.table-colored-full.table-full-purple tbody tr:hover {
  background-color: #8892d6;
}

/* =============
   Datatable
============= */
/* Data table */
div.dt-button-info {
  background-color: #348cd4;
  border: none;
  color: #ffffff;
  box-shadow: none;
  border-radius: 3px;
  text-align: center;
  z-index: 21;
}

div.dt-button-info h2 {
  border-bottom: none;
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

table.dataTable {
  margin-top: 10px !important;
  margin-bottom: 18px !important;
}

.table-bordered.dataTable > thead > tr > td,
.table-bordered.dataTable > thead > tr > th {
  border-bottom-width: 1px !important;
}

.dataTables_wrapper .dataTables_length select {
  width: 75px !important;
}

.dataTables_wrapper .form-control {
  padding: 4px 12px;
  height: 30px;
  width: auto;
}

.dataTables_wrapper .sorting:before,
.dataTables_wrapper .sorting_asc:before {
  display: none !important;
}

.fixedHeader-floating .sorting:before,
.fixedHeader-floating .sorting_asc:before {
  display: none !important;
}

.btn-toolbar {
  display: block;
}

/* Fixed Header table */
.fixedHeader-floating {
  top: 70px !important;
}

/* Key Table border */
table.dataTable th.focus,
table.dataTable td.focus {
  outline: 2px solid #348cd4 !important;
  outline-offset: -1px;
  background-color: #348cd4;
  color: #ffffff;
}

/* Responsive data table */
table.dataTable.dtr-inline.collapsed
  > tbody
  > tr
  > td:first-child:before,
table.dataTable.dtr-inline.collapsed
  > tbody
  > tr
  > th:first-child:before {
  box-shadow: 0 0 3px rgba(67, 89, 102, 0.2);
  background-color: #78c350;
}

table.dataTable.dtr-inline.collapsed
  > tbody
  > tr.parent
  > td:first-child:before,
table.dataTable.dtr-inline.collapsed
  > tbody
  > tr.parent
  > th:first-child:before {
  background-color: #f7531f;
}

table.dataTable > tbody > tr.child span.dtr-title {
  font-family: 'Poppins', sans-serif;
}

/* ColVid Tables */
div.ColVis {
  float: none;
  margin-right: 30px;
}

button.ColVis_Button,
.ColVis_Button:hover {
  float: none;
  border-radius: 3px;
  outline: none !important;
  background: none;
  box-shadow: none;
  color: #ffffff !important;
  background-color: #348cd4 !important;
  border: 1px solid #348cd4 !important;
}

.dataTables_length {
  float: left;
}

div.ColVis_collectionBackground {
  background-color: transparent;
}

ul.ColVis_collection {
  padding: 10px 0 0 0;
  background-color: #ffffff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  border: none;
}

ul.ColVis_collection li {
  background: transparent !important;
  padding: 3px 10px !important;
  border: none !important;
  box-shadow: none !important;
}

#datatable-colvid_info {
  float: left;
}

/* Responsive Table */
.table-rep-plugin .dropdown-menu li.checkbox-row {
  padding: 2px 15px !important;
}

.table-rep-plugin .table-responsive {
  border: none !important;
}

.table-rep-plugin tbody th {
  font-size: 14px;
  font-weight: normal;
}

.table-rep-plugin .checkbox-row {
  padding-left: 40px;
}

.table-rep-plugin .checkbox-row label {
  display: inline-block;
  padding-left: 5px;
  position: relative;
}

.table-rep-plugin .checkbox-row label::before {
  -o-transition: 0.3s ease-in-out;
  -webkit-transition: 0.3s ease-in-out;
  background-color: #ffffff;
  border-radius: 3px;
  border: 1px solid #98a6ad;
  content: '';
  display: inline-block;
  height: 17px;
  left: 0;
  margin-left: -20px;
  position: absolute;
  transition: 0.3s ease-in-out;
  width: 17px;
  outline: none !important;
}

.table-rep-plugin .checkbox-row label::after {
  color: #f3f3f3;
  display: inline-block;
  font-size: 11px;
  height: 16px;
  left: 0;
  margin-left: -20px;
  padding-left: 3px;
  padding-top: 1px;
  position: absolute;
  top: -1px;
  width: 16px;
}

.table-rep-plugin .checkbox-row input[type='checkbox'] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
}

.table-rep-plugin
  .checkbox-row
  input[type='checkbox']:disabled
  + label {
  opacity: 0.65;
}

.table-rep-plugin
  .checkbox-row
  input[type='checkbox']:focus
  + label::before {
  outline-offset: -2px;
  outline: none;
}

.table-rep-plugin
  .checkbox-row
  input[type='checkbox']:checked
  + label::after {
  content: '\\f00c';
  font-family: 'FontAwesome';
}

.table-rep-plugin
  .checkbox-row
  input[type='checkbox']:disabled
  + label::before {
  background-color: #e2e2e2;
  cursor: not-allowed;
}

.table-rep-plugin
  .checkbox-row
  input[type='checkbox']:checked
  + label::before {
  background-color: #ffffff;
  border-color: #348cd4;
}

.table-rep-plugin
  .checkbox-row
  input[type='checkbox']:checked
  + label::after {
  color: #348cd4;
}

.table-rep-plugin table.focus-on tbody tr.focused th,
.table-rep-plugin table.focus-on tbody tr.focused td,
.table-rep-plugin .sticky-table-header {
  background-color: #348cd4;
  border-color: #348cd4;
}

.table-rep-plugin table.focus-on tbody tr.focused th table,
.table-rep-plugin table.focus-on tbody tr.focused td table,
.table-rep-plugin .sticky-table-header table {
  color: #ffffff;
}

.table-rep-plugin .fixed-solution .sticky-table-header {
  top: 70px !important;
}

/* =============
   Tablesaw
============= */
.tablesaw thead {
  background: rgba(243, 243, 243, 0.7);
  background-image: none;
  border: none;
}

.tablesaw thead th {
  text-shadow: none;
  letter-spacing: 0.06em;
}

.tablesaw thead tr:first-child th {
  font-weight: 600;
  border: none;
  font-family: 'Poppins', sans-serif;
}

.tablesaw td {
  border-top: 1px solid rgba(243, 243, 243, 0.7) !important;
}

.tablesaw td,
.tablesaw tbody th {
  font-size: inherit;
  line-height: inherit;
  padding: 10px !important;
}

.tablesaw-stack tbody tr,
.tablesaw tbody tr {
  border-bottom: none;
}

.tablesaw-sortable
  .tablesaw-sortable-head.tablesaw-sortable-ascending
  button:after,
.tablesaw-sortable
  .tablesaw-sortable-head.tablesaw-sortable-descending
  button:after {
  font-family: FontAwesome;
  font-size: 10px;
}

.tablesaw-sortable
  .tablesaw-sortable-head.tablesaw-sortable-ascending
  button:after {
  content: '\\f176';
}

.tablesaw-sortable
  .tablesaw-sortable-head.tablesaw-sortable-descending
  button:after {
  content: '\\f175';
}

.tablesaw-bar .btn-select.btn-small:after,
.tablesaw-bar .btn-select.btn-micro:after {
  font-size: 8px;
  padding-right: 10px;
}

.tablesaw-swipe .tablesaw-cell-persist {
  box-shadow: none;
}

.tablesaw-enhanced .tablesaw-bar .btn {
  text-shadow: none;
  background-image: none;
}

.tablesaw-enhanced .tablesaw-bar .btn.btn-select:hover {
  background: #ffffff;
}

.tablesaw-enhanced .tablesaw-bar .btn:hover,
.tablesaw-enhanced .tablesaw-bar .btn:focus,
.tablesaw-enhanced .tablesaw-bar .btn:active {
  color: #348cd4 !important;
  background-color: #f3f3f3;
  outline: none !important;
  box-shadow: none !important;
  background-image: none;
}

/* =============
   Table editable
============= */
.add-edit-table td,
.add-edit-table th {
  vertical-align: middle !important;
}

.add-edit-table td {
  border: 0 !important;
}

#datatable-editable .actions a {
  padding: 5px;
}

#datatable-editable .form-control {
  background-color: #ffffff;
  width: 100%;
}

#datatable-editable .fa-trash-o {
  color: #f7531f;
}

#datatable-editable .fa-times {
  color: #f7531f;
}

#datatable-editable .fa-pencil {
  color: #348cd4;
}

#datatable-editable .fa-save {
  color: #78c350;
}

#datatable td {
  font-weight: normal;
}

.modal-block {
  background: transparent;
  margin: 40px auto;
  max-width: 600px;
  padding: 0;
  position: relative;
  text-align: left;
}

.dt-buttons {
  float: left;
}

div#datatable-buttons_info {
  float: left;
}

table.dataTable thead th {
  position: relative;
  background-image: none !important;
}

table.dataTable thead th.sorting:after,
table.dataTable thead th.sorting_asc:after,
table.dataTable thead th.sorting_desc:after {
  position: absolute;
  top: 7px;
  right: 8px;
  display: block;
  font-family: FontAwesome;
}

table.dataTable thead th.sorting:after {
  content: '\\f0dc';
  padding-top: 0.12em;
}

table.dataTable thead th.sorting_asc:after {
  content: '\\f0de';
}

table.dataTable thead th.sorting_desc:after {
  content: '\\f0dd';
}

.DTFC_LeftBodyWrapper table thead th.sorting:after,
.dataTables_scrollBody table thead th.sorting:after,
.DTFC_RightBodyLiner table thead th.sorting:after,
.DTFC_LeftBodyWrapper table thead th.sorting_asc:after,
.dataTables_scrollBody table thead th.sorting_asc:after,
.DTFC_RightBodyLiner table thead th.sorting_asc:after,
.DTFC_LeftBodyWrapper table thead th.sorting_desc:after,
.dataTables_scrollBody table thead th.sorting_desc:after,
.DTFC_RightBodyLiner table thead th.sorting_desc:after {
  display: none !important;
}

/* =========== */
/* Sweet Alert */
/* =========== */
.swal2-container {
  font-family: inherit;
}

.swal2-container .swal2-title {
  font-size: 24px !important;
  font-weight: 500 !important;
}

.swal2-icon.swal2-question {
  border-color: #348cd4 !important;
  color: #348cd4 !important;
}

.swal2-popup .swal2-content {
  font-size: 16px !important;
}

.swal2-popup .swal2-styled:focus {
  box-shadow: none !important;
}

.swal2-icon.swal2-success .swal2-success-ring {
  border-color: #78c350 !important;
}

.swal2-icon.swal2-success [class^='swal2-success-line'] {
  background: #78c350 !important;
}

/* =============
   Widgets
============= */
.widget-box-one .widget-one-icon {
  position: absolute;
  right: 30px;
  font-size: 72px !important;
  top: 0;
  color: #f3f3f3;
  overflow: hidden;
  vertical-align: middle;
  line-height: 2 !important;
}

.widget-box-one .wigdet-one-content {
  position: relative;
}

.widget-box-two p {
  font-size: 14px;
}

.widget-box-two .widget-two-icon {
  position: absolute;
  right: 30px;
  font-size: 30px !important;
  top: 30px;
  overflow: hidden;
  vertical-align: middle;
  height: 80px;
  width: 80px;
  text-align: center;
  line-height: 80px;
  border-radius: 50%;
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.2);
}

.widget-box-two .wigdet-two-content {
  position: relative;
}

.widget-two-custom {
  background-color: #348cd4;
  border-color: #348cd4;
}

.widget-two-primary {
  background-color: #3456d4;
  border-color: #3456d4;
}

.widget-two-success {
  background-color: #78c350;
  border-color: #78c350;
}

.widget-two-warning {
  background-color: #ff9800;
  border-color: #ff9800;
}

.widget-two-info {
  background-color: #45bbe0;
  border-color: #45bbe0;
}

.widget-two-danger {
  background-color: #f7531f;
  border-color: #f7531f;
}

.widget-two-inverse {
  background-color: #3b3e47;
  border-color: #3b3e47;
}

.widget-two-purple {
  background-color: #8892d6;
  border-color: #8892d6;
}

.widget-two-pink {
  background-color: #f06292;
  border-color: #f06292;
}

.widget-two-default {
  background-color: #ffffff;
}

.widget-two-default .widget-two-icon {
  color: silver;
  border: 2px solid silver;
}

.widget-box-three img {
  height: 48px;
  width: 48px;
  line-height: 80px;
}

.widget-box-three .bg-icon {
  height: 80px;
  width: 80px;
  line-height: 76px;
  text-align: center;
  border-radius: 50%;
  -moz-border-radius: 50%;
  background-clip: padding-box;
  border: 1px dashed #98a6ad;
  background-color: #f3f3f3;
  margin-right: 20px;
}

.widget-box-three .bg-icon i {
  vertical-align: middle;
  font-size: 36px;
  color: #98a6ad;
}

.widget-user {
  position: relative;
}

.widget-user img {
  width: 60px;
  height: 60px;
}

.user-position {
  position: absolute;
  top: 0;
  border-left: 1px solid #e2e2e2;
  bottom: 0;
  width: 44px;
  font-size: 16px;
  text-align: center;
  right: 0;
  left: auto;
  display: -moz-flex;
  display: flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  flex-direction: row;
}

.user-position span {
  transform: rotate(90deg);
}

/* Avatar box */
.avatar-sm-box {
  height: 32px;
  width: 32px;
  color: #ffffff;
  display: block;
  line-height: 32px;
  text-align: center;
  border-radius: 50%;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
}

/* =============
   Nestable
============= */
.custom-dd .dd-list .dd-item .dd-handle {
  background: #f3f3f3;
  border: 1px solid #d1d7da;
  padding: 10px 16px;
  height: auto;
  font-size: 13px;
  font-weight: normal;
  border-radius: 3px;
}

.custom-dd .dd-list .dd-item .dd-handle:hover {
  color: #348cd4;
}

.custom-dd .dd-list .dd-item button {
  height: auto;
  font-size: 25px;
  margin: 8px auto;
  color: #797979;
  width: 35px;
}

.custom-dd-empty .dd-list .dd3-handle {
  border: none;
  background: #f3f3f3;
  height: 36px !important;
  width: 36px !important;
}

.custom-dd-empty .dd-list .dd3-handle:before {
  color: inherit;
  top: 7px;
}

.custom-dd-empty .dd-list .dd3-handle:hover {
  color: #348cd4;
}

.custom-dd-empty .dd-list .dd3-content {
  height: auto;
  border: none;
  padding: 8px 16px 8px 46px;
  background: #f3f3f3;
  font-family: 'Poppins', sans-serif;
}

.custom-dd-empty .dd-list .dd3-content:hover {
  color: #348cd4;
}

.custom-dd-empty .dd-list button {
  width: 26px;
  height: 26px;
  font-size: 16px;
  font-weight: 600;
}

.dd-dragel > .dd-item .dd-handle {
  padding: 8px 16px !important;
  background: #f3f3f3;
  height: auto;
}

.dd-placeholder,
.dd-empty {
  background: #f3f3f3;
  border: 1px dashed #98a6ad;
}

.dd-dragel > .dd3-item > .dd3-handle {
  border: none;
  background: #f3f3f3;
  height: 36px !important;
  width: 36px !important;
}

.dd-dragel > .dd3-item > .dd3-handle:before {
  color: inherit;
  top: 7px;
}

.dd-dragel > .dd3-item > .dd3-content {
  padding: 8px 16px 8px 46px;
  background: #f3f3f3;
  height: auto;
}

/* =====================================
   rangeslider
   ===================================== */
.control-label span {
  font-size: 13px;
}

.irs--modern .irs-bar,
.irs--modern .irs-to,
.irs--modern .irs-from,
.irs--modern .irs-single {
  background: #348cd4 !important;
}

.irs--modern .irs-to:before,
.irs--modern .irs-from:before,
.irs--modern .irs-single:before {
  border-top-color: #348cd4;
}

.irs--modern .irs-min,
.irs--modern .irs-max {
  color: #98a6ad;
}

.irs--modern .irs-grid-text {
  font-size: 12px;
}

.irs--modern .irs-handle > i:nth-child(1) {
  width: 8px;
  height: 8px;
}

/* =============
   Rating
============= */
.rating-md i {
  font-size: 18px;
}

.rating-lg i {
  font-size: 24px;
}

/* =============
   Calendar
============= */
.calendar {
  float: left;
  margin-bottom: 0;
}

.fc-view {
  margin-top: 30px;
}

.none-border .modal-footer {
  border-top: none;
}

.fc-toolbar {
  margin-bottom: 5px;
  margin-top: 10px;
}

.fc-toolbar h2 {
  font-size: 18px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  line-height: 30px;
  text-transform: uppercase;
}

.fc-day-grid-event .fc-time {
  font-family: 'Poppins', sans-serif;
}

.fc-day {
  background: #ffffff;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active,
.fc-toolbar button:focus,
.fc-toolbar button:hover,
.fc-toolbar .ui-state-hover {
  z-index: 0;
}

.fc th.fc-widget-header {
  background: #e2e2e2;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
}

.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #e2e2e2;
}

.fc-button {
  background: #e2e2e2;
  border: none;
  color: #797979;
  text-transform: capitalize;
  box-shadow: none !important;
  border-radius: 3px !important;
  margin: 0 3px !important;
  padding: 6px 12px !important;
  height: auto !important;
}

.fc-text-arrow {
  font-family: inherit;
  font-size: 16px;
}

.fc-state-hover {
  background: #f3f3f3;
}

.fc-state-highlight {
  background: #f0f0f0;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #348cd4 !important;
  color: #ffffff !important;
  text-shadow: none !important;
}

.fc-cell-overlay {
  background: #f0f0f0;
}

.fc-unthemed .fc-today {
  background: #ffffff;
}

.fc-event {
  border-radius: 2px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  margin: 5px 7px;
  padding: 5px 5px;
  text-align: center;
  color: #ffffff !important;
}

.external-event {
  cursor: move;
  margin: 10px 0;
  padding: 6px 10px;
}

.external-event.bg-primary {
  background-color: rgba(52, 86, 212, 0.3) !important;
  color: #3456d4;
}

.external-event.bg-success {
  background-color: rgba(120, 195, 80, 0.3) !important;
  color: #78c350;
}

.external-event.bg-info {
  background-color: rgba(69, 187, 224, 0.3) !important;
  color: #45bbe0;
}

.external-event.bg-warning {
  background-color: rgba(255, 152, 0, 0.3) !important;
  color: #ff9800;
}

.external-event.bg-danger {
  background-color: rgba(247, 83, 31, 0.3) !important;
  color: #f7531f;
}

.external-event.bg-pink {
  background-color: rgba(240, 98, 146, 0.3) !important;
  color: #f06292;
}

.external-event.bg-purple {
  background-color: rgba(136, 146, 214, 0.3) !important;
  color: #8892d6;
}

.external-event.bg-inverse {
  background-color: rgba(59, 62, 71, 0.3) !important;
  color: #3b3e47;
}

.fc-basic-view td.fc-week-number span {
  padding-right: 8px;
  font-weight: 700;
  font-family: 'Poppins', sans-serif;
}

.fc-basic-view td.fc-day-number {
  padding-right: 8px;
  font-weight: 700;
  font-family: 'Poppins', sans-serif;
}

/* =============
   Maps
============= */
.gmaps,
.gmaps-panaroma {
  height: 300px;
  background: #eeeeee;
  border-radius: 3px;
}

.gmaps-overlay {
  display: block;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  line-height: 40px;
  background: #5d9cec;
  border-radius: 4px;
  padding: 10px 20px;
}

.gmaps-overlay_arrow {
  left: 50%;
  margin-left: -16px;
  width: 0;
  height: 0;
  position: absolute;
}

.gmaps-overlay_arrow.above {
  bottom: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-top: 16px solid #5d9cec;
}

.gmaps-overlay_arrow.below {
  top: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-bottom: 16px solid #5d9cec;
}

/* Vector Map */
.jvectormap-zoomin,
.jvectormap-zoomout {
  width: 10px;
  height: 10px;
  line-height: 10px;
}

.jvectormap-zoomout {
  top: 40px;
}

/* Mapael Map */
.mapael .map {
  position: relative;
}

.mapael .mapTooltip {
  position: absolute;
  background-color: #348cd4;
  opacity: 0.95;
  border-radius: 3px;
  padding: 2px 10px;
  z-index: 1000;
  max-width: 200px;
  display: none;
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
}

.mapael .zoomIn,
.mapael .zoomOut,
.mapael .zoomReset {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  border-radius: 2px;
  font-weight: 500;
  cursor: pointer;
  background-color: #348cd4;
  text-decoration: none;
  color: #ffffff;
  font-size: 14px;
  position: absolute;
  top: 0;
  left: 10px;
  width: 24px;
  height: 24px;
  line-height: 24px;
}

.map .zoomIn {
  top: 25px;
}

.map .zoomOut {
  top: 50px;
}

/* =============
   Account Pages
============= */
.wrapper-page {
  margin: 12% auto;
  position: relative;
  max-width: 520px;
}

.account-pages .account-content {
  padding: 30px;
}

.account-pages .account-btn {
  position: absolute;
  left: 0;
  right: 0;
}

.account-logo-box {
  padding: 10px;
  border-radius: 5px 5px 0 0;
}

.checkmark {
  width: 100px;
  margin: 0 auto;
  padding: 20px 0;
}

.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
  animation: dash 2s ease-in-out;
  -webkit-animation: dash 2s ease-in-out;
}

.spin {
  animation: spin 2s;
  -webkit-animation: spin 2s;
  transform-origin: 50% 50%;
  -webkit-transform-origin: 50% 50%;
}

@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes text {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* =============
   extra pages
============= */
/* =============
   About Us
============= */
.border {
  height: 4px;
  width: 48px;
  border-radius: 5px;
  background-color: #3456d4;
}

.about-features-box {
  margin: 20px 0;
}

.about-features-box p {
  line-height: 24px;
  width: 90%;
  margin: 0 auto;
}

.feature-icon {
  height: 80px;
  width: 80px;
  margin: 0 auto;
  border-radius: 50%;
  font-size: 36px;
  color: #ffffff;
  line-height: 80px;
}

.about-team img {
  max-width: 150px;
  margin: 0 auto;
}

.about-team .about-team-member {
  margin: 30px 0px;
}

.about-team .about-team-member h4 {
  padding-top: 10px;
  font-weight: 600;
}

.about-team .about-team-member p {
  color: #98a6ad;
}

/* =============
   Contact Us
============= */
.contact-map {
  background-color: #f3f3f3;
}

.contact-box {
  padding: 30px;
}

.contact-detail {
  margin-bottom: 40px;
}

.contact-detail i {
  float: left;
  width: 32px;
  font-size: 20px;
}

.contact-detail p,
.contact-detail address {
  overflow: hidden;
}

.contact-detail a {
  color: #496174;
}

/* =============
   Members list
============= */
.member-box .dropdown-toggle:after {
  display: none;
}

.member-card .member-thumb {
  position: relative;
}

.member-card .member-star {
  position: absolute;
  top: 12px;
  right: 10px;
  font-size: 16px;
  background-color: #ffffff;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  line-height: 20px;
  text-align: center;
}

.social-links li a {
  border-radius: 50%;
  color: rgba(121, 121, 121, 0.5);
  display: inline-block;
  height: 30px;
  line-height: 30px;
  border: 2px solid rgba(121, 121, 121, 0.5);
  text-align: center;
  width: 30px;
}

.social-links li a:hover {
  color: #797979;
  border: 2px solid #797979;
}

/* =============
   Pages - Common
============= */
.home-wrapper {
  margin: 10% 0;
}

/* =============
   Count Down
============= */
.count-down-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}

#count-down {
  margin-top: 50px;
}

#count-down .clock-presenter {
  height: 140px;
  line-height: 30px;
  padding: 0 30px;
  text-align: center;
}

#count-down .clock-presenter .digit {
  margin-top: 20px;
  font-size: 60px;
  font-family: 'Poppins', sans-serif;
  line-height: 60px;
  font-weight: 600;
  height: 60px;
  display: inline-block;
  overflow: hidden;
  text-align: center;
  position: relative;
  cursor: default;
  color: #ffffff;
}

#count-down .clock-presenter .note {
  position: relative;
  bottom: 0;
  padding-top: 5px;
  cursor: default;
  font-size: 16px;
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
  text-transform: uppercase;
}

@media (max-width: 992px) {
  #count-down .clock-presenter .digit {
    font-size: 42px;
  }
}

@media (max-width: 767px) {
  #count-down .clock-presenter {
    width: 50%;
    float: left;
  }
  #count-down .clock-presenter .digit {
    font-size: 36px;
  }
  #count-down .hours_dash {
    border-right: none;
  }
}

/* =============
   FAQ
============= */
.question-q-box {
  height: 30px;
  width: 30px;
  color: #ffffff;
  background-color: #348cd4;
  text-align: center;
  border-radius: 3px;
  float: left;
  line-height: 30px;
}

.question {
  margin-top: 0;
  margin-left: 50px;
  font-weight: 400;
  font-size: 16px;
}

.answer {
  margin-left: 50px;
  color: #98a6ad;
  margin-bottom: 40px;
}

/* =============
   Pricing
============= */
.pricing-column {
  position: relative;
  margin-bottom: 40px;
}

.pricing-column .inner-box {
  position: relative;
  padding: 0 0 30px;
}

.pricing-column .plan-header {
  position: relative;
  padding: 30px 20px 25px;
  background-color: #3456d4;
}

.pricing-column .plan-title {
  font-size: 16px;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 10px;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.pricing-column .plan-price {
  font-size: 48px;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 10px;
  color: #ffffff;
}

.pricing-column .plan-duration {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
}

.pricing-column .plan-stats {
  position: relative;
  padding: 30px 20px 15px;
}

.pricing-column .plan-stats li {
  margin-bottom: 15px;
  line-height: 24px;
}

.ribbon {
  position: absolute;
  left: 10px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;
  font-family: 'Poppins', sans-serif;
}

.ribbon span {
  font-size: 10px;
  font-weight: bold;
  color: #ffffff;
  text-transform: uppercase;
  text-align: center;
  line-height: 20px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  width: 100px;
  display: block;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06),
    0 1px 0 0 rgba(0, 0, 0, 0.02);
  background: #348cd4;
  background: linear-gradient(#78c350 0%, #78c350 100%);
  position: absolute;
  top: 19px;
  letter-spacing: 1px;
  left: -21px;
}

.ribbon span:before {
  content: '';
  position: absolute;
  left: 0;
  top: 100%;
  z-index: -1;
  border-left: 3px solid #5fa739;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #5fa739;
}

.ribbon span:after {
  content: '';
  position: absolute;
  right: 0;
  top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-right: 3px solid #5fa739;
  border-bottom: 3px solid transparent;
  border-top: 3px solid #5fa739;
}

/* =============
   Timeline
============= */
.timeline {
  border-collapse: collapse;
  border-spacing: 0;
  display: table;
  margin-bottom: 50px;
  position: relative;
  table-layout: fixed;
  width: 100%;
}

.timeline .time-show-btn {
  margin-bottom: 30px;
  margin-top: 30px;
  position: relative;
}

.timeline .time-show-btn a {
  color: #ffffff;
}

.timeline:before {
  background-color: rgba(121, 121, 121, 0.3);
  bottom: 0;
  content: '';
  left: 50%;
  position: absolute;
  top: 30px;
  width: 2px;
  z-index: 0;
}

.timeline .timeline-icon {
  -webkit-border-radius: 50%;
  background: #797979;
  border-radius: 50%;
  color: #ffffff;
  display: block;
  height: 20px;
  left: -54px;
  margin-top: -10px;
  position: absolute;
  text-align: center;
  top: 50%;
  width: 20px;
}

.timeline .timeline-icon i {
  color: #ffffff;
  font-size: 13px;
  margin-top: 4px;
  position: absolute;
  left: 4px;
}

.timeline .time-icon:before {
  font-size: 16px;
  margin-top: 5px;
}

h3.timeline-title {
  color: #797979;
  font-size: 20px;
  font-weight: 400;
  margin: 0 0 5px;
  text-transform: uppercase;
}

.timeline-item {
  display: table-row;
}

.timeline-item:before {
  content: '';
  display: block;
  width: 50%;
}

.timeline-item .timeline-desk .arrow {
  border-bottom: 12px solid transparent;
  border-right: 12px solid rgba(226, 226, 226, 0.3) !important;
  border-top: 12px solid transparent;
  display: block;
  height: 0;
  left: -12px;
  margin-top: -12px;
  position: absolute;
  top: 50%;
  width: 0;
}

.timeline-item .timeline-desk .timeline-box {
  padding: 20px;
}

.timeline-item .timeline-date {
  margin-bottom: 10px;
}

.timeline-item.alt:after {
  content: '';
  display: block;
  width: 50%;
}

.timeline-item.alt .timeline-desk .arrow-alt {
  border-bottom: 12px solid transparent;
  border-left: 12px solid rgba(226, 226, 226, 0.3) !important;
  border-top: 12px solid transparent;
  display: block;
  height: 0;
  left: auto;
  margin-top: -12px;
  position: absolute;
  right: -12px;
  top: 50%;
  width: 0;
}

.timeline-item.alt .timeline-desk .album {
  margin-top: 20px;
}

.timeline-item.alt .timeline-desk .album a {
  margin-left: 5px;
}

.timeline-item.alt .timeline-icon {
  left: auto;
  right: -56px;
}

.timeline-item.alt:before {
  display: none;
}

.timeline-item.alt .panel {
  margin-left: 0;
  margin-right: 45px;
}

.timeline-desk {
  display: table-cell;
  vertical-align: top;
  width: 50%;
}

.timeline-desk h4 {
  font-size: 16px;
  font-weight: 300;
  margin: 0;
}

.timeline-desk .panel {
  background: rgba(226, 226, 226, 0.25);
  display: block;
  margin-bottom: 5px;
  margin-left: 45px;
  position: relative;
  text-align: left;
  border: 0;
}

.timeline-desk h5 span {
  color: #797979;
  display: block;
  font-size: 12px;
  margin-bottom: 4px;
}

.timeline-desk p {
  color: #999999;
  font-size: 14px;
  margin-bottom: 0;
}

.timeline-desk .album {
  margin-top: 12px;
}

.timeline-desk .album a {
  margin-right: 5px;
}

.timeline-desk .album img {
  height: 36px;
  width: auto;
  border-radius: 3px;
}

.timeline-desk .notification {
  background: none repeat scroll 0 0 #ffffff;
  margin-top: 20px;
  padding: 8px;
}

@media (max-width: 768px) {
  .timeline {
    margin-left: 20px;
    width: auto !important;
    display: block;
  }
  .timeline:before {
    left: 0 !important;
  }
  .timeline .timeline-item {
    display: block;
  }
  .timeline .timeline-desk {
    display: block;
    width: 100%;
  }
  .timeline .timeline-desk .panel {
    margin-left: 45px !important;
    margin-right: 0px !important;
    margin-bottom: 20px !important;
  }
  .timeline .timeline-item.alt .timeline-icon {
    left: -56px;
  }
  .timeline .timeline-item.alt .timeline-desk .arrow-alt {
    border-right: 12px solid rgba(226, 226, 226, 0.3) !important;
    border-top: 12px solid transparent;
    border-left: none !important;
    left: -12px;
  }
}

@media only screen and (min-width: 769px) {
  .timeline .time-show-btn {
    text-align: right;
  }
  .timeline .time-show-btn a {
    position: relative;
    left: 70px;
  }
}

.timeline-left {
  margin-left: 20px;
  width: auto;
  display: block;
}

.timeline-left:before {
  left: 0 !important;
}

.timeline-left .time-show {
  margin-bottom: 30px;
  margin-top: 30px;
  position: relative;
}

.timeline-left .timeline-item {
  display: block;
}

.timeline-left .timeline-desk {
  display: block;
  width: 100%;
}

.timeline-left .panel {
  margin-bottom: 20px;
}

/* =============
   Print css
============= */
@media print {
  .page-title-box,
  .topbar-left,
  .breadcrumb,
  .page-title,
  .footer {
    display: none;
    margin: 0;
    padding: 0;
  }
  .left,
  .right-bar {
    display: none;
  }
  .content {
    margin-top: 0 !important;
    padding-top: 0;
  }
  .content-page {
    margin-left: 0 !important;
    margin-top: 0;
  }
}

/* =============
   Responsive
============= */
@media (min-width: 768px) and (max-width: 991px) {
  body {
    overflow-x: hidden;
  }
}

@media (max-width: 768px) {
  body {
    overflow-x: hidden;
  }
  .topbar-left {
    width: 70px !important;
  }
  .topbar-left span {
    display: none !important;
  }
  .topbar-left i {
    display: block !important;
    line-height: 70px !important;
  }
  .content-page .content {
    margin-top: 75px;
  }
  .topbar .topbar-left {
    height: 70px;
  }
  .navbar-nav.navbar-right {
    float: right;
  }
  .content-page {
    margin-left: 0 !important;
  }
  .enlarged .left.side-menu {
    margin-left: -70px;
  }
  .footer {
    left: 0 !important;
  }
  .mobile-sidebar {
    left: 0;
  }
  .mobile-content {
    left: 250px;
    right: -250px;
  }
  .wrapper-page {
    width: 90%;
  }
  .dataTables_wrapper .col-6 {
    width: 100%;
    text-align: left;
  }
  div#datatable-buttons_info {
    float: none;
  }
  .ms-container {
    width: 100%;
  }
  .m-t-sm-50 {
    margin-top: 50px !important;
  }
  .contact-box {
    padding: 0px;
  }
}

@media (max-width: 767px) {
  .navbar-nav .open .dropdown-menu {
    background-color: #ffffff;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
    left: auto;
    position: absolute;
    right: 0;
  }
  .navbar-nav .open .dropdown-menu li {
    display: block;
  }
  .navbar-nav {
    margin: 0;
    display: inline-block;
  }
  .navbar-nav li {
    display: inline-block;
    line-height: 1px;
  }
  .dropdown-lg {
    width: 200px !important;
  }
  .user-box {
    float: right;
  }
  .dataTables_length {
    float: none;
    margin-bottom: 10px;
  }
}

@media (max-width: 480px) {
  .side-menu {
    z-index: 10 !important;
  }
  .button-menu-mobile {
    display: block;
  }
  .search-bar {
    display: none !important;
  }
  .wizard .steps ul li {
    width: 100%;
  }
}

@media (max-width: 420px) {
  .hide-phone {
    display: none !important;
  }
  .account-pages .account-content {
    padding: 30px 0;
  }
}

/* Container-alt */
@media (min-width: 768px) {
  .container-alt {
    width: 750px;
  }
  .nav-tabs.nav-justified > li > a {
    border-bottom: 2px solid #e2e2e2;
  }
}

@media (min-width: 992px) {
  .container-alt {
    width: 970px;
  }
}

@media (min-width: 1200px) {
  .container-alt {
    width: 1170px;
  }
}

@media (max-width: 419px) {
  .hidden-xxs {
    display: none;
  }
  .topbar-left {
    width: 70px !important;
  }
  .logo .icon-c-logo {
    display: inline-block !important;
    line-height: 58px !important;
  }
  .logo span {
    display: none !important;
  }
  .wrapper-page .logo span {
    display: inline-block !important;
  }
  .content-page {
    margin-left: 70px;
  }
  .forced .side-menu.left {
    box-shadow: 0 12px 12px rgba(0, 0, 0, 0.1);
  }
  .enlarged .side-menu.left {
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1) !important;
  }
  .page-title {
    font-size: 15px;
    max-width: 250px;
    white-space: nowrap;
  }
  .navbar-default {
    padding: 0;
  }
  .navbar-default .navbar-left {
    padding-left: 0 !important;
  }
  .navbar-default .navbar-left li {
    padding: 0 5px;
  }
  .topbar-left {
    display: none;
  }
  .editable-responsive {
    overflow-x: auto;
  }
  .page-title-box .breadcrumb {
    display: none;
  }
  .navbar-nav .open .dropdown-menu {
    margin-right: -20px;
  }
  .user-box .dropdown-menu {
    margin-right: 0 !important;
  }
  .dropdown-lg {
    width: 200px !important;
  }
  .user-list .user-list-item .icon,
  .user-list .user-list-item .avatar {
    display: none;
  }
  .user-list .user-list-item .user-desc {
    margin-left: 0;
  }
}
#exportarBtn {
  margin-top: -5px;
}
/*# sourceMappingURL=style.css.map */

td .select2-container {
  max-width: 380px !important;
}
.logo-header-menu {
  background-position: center !important;
  padding: 10px;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-origin: content-box, padding-box !important;
}
.cursor-none {
  cursor: default !important;
}

.info-blue {
  font-size: 23;
  margin-left: 5;
  color: #45bbe0;
}

.btn-block {
  display: block;
  width: 100%;
}

label {
  font-weight: 700;
  margin-bottom: 5px;
}

.btn-primary {
  color: #fff;
  background-color: #337ab7;
  border-color: #2e6da4;
}

.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-8,
.col-md-10,
.col-md-12,
.col-sm-3,
.col-sm-4,
.col-sm-6,
.col-sm-9,
.col-sm-12 {
  margin-bottom: 15px;
}

.icon-alert {
  color: #ffc107;
  border-color: black;
  font-size: 2em;
  margin-top: 5px;
}

a {
  text-decoration: none;
}

.row-panel {
  margin-left: 10px;
  margin-right: 5px;
}

.row-plano {
  display: flex;
  margin-top: 10px;
}

.mr-1 {
  margin-right: 5px;
}

table {
  border-color: black;
}

.span-tab {
  text-transform: uppercase;
  font-weight: 500;
}

.select2-multiple {
  height: auto;
}

.icon-alert-num {
  color: red;
  position: absolute;
  font-size: small;
}
.mr-2 {
  margin-left: 10px;
}

.icon-new {
  color: blue;
  position: inherit;
  font-size: small;
}
.checkbox-line {
  margin-top: 10px;
  margin-left: -23px;
}

.checkFilter {
  margin-top: 10px;
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.btn-close {
  font-size: 0.8em;
}

.mr-line {
  margin-left: 5px;
}

.mr-15 {
  margin-left: -25px;
}

.radio-inline {
  margin-left: -25px;
}

.margin-popup {
  margin-left: 10px;
  margin-right: 5px;
  margin-top: 5px;
}

/**
*Mainmenu-area
**/

.mainmenu-area {
  /* position: fixed;*/
  /*left: 0;
  top: 0;*/
  width: 100%;
  z-index: 9999999;
  transition: 0.3s;
  background-color: #ffffff;
  padding: 35px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center bottom;
  background-size: contain;
  margin-bottom: 1px;
}

.overlay,
.overlay a,
.mainmenu-area a {
  color: #ffffff;
}

.mainmenu-area .logo {
  text-transform: uppercase;
  letter-spacing: 2px;
  height: inherit;
  margin-top: 8px;
  padding-left: 0;
}

.logo-img {
  width: 220px;
  min-width: auto;
  margin-top: 0px;
  margin-left: 85px;
}

.mainmenu-area .logo h2 {
  margin-bottom: 0;
}

.mainmenu-area #primary-menu > ul > li > a {
  background: none;
  padding: 30px 15px;
  position: relative;
  border-top: 3px solid transparent;
  text-align: center;
}
/*
.mainmenu-area #primary-menu > ul > li > a:before {
  content: "";
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  top: -10px;
  width: 0;
  height: 0;
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
  border-top: 10px solid #ffffff;
  opacity: 0;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
*/

.mainmenu-area #primary-menu > ul > li > a:hover:before,
.mainmenu-area #primary-menu > ul > li.active > a:before {
  opacity: 1;
  top: 0;
}

.mainmenu-area #primary-menu ul li.active a,
.mainmenu-area #primary-menu ul li a:hover {
  border-top: 3px solid #ff2400;
}

.mainmenu-area.affix {
  background-color: #0b2331;
}

.login-area {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat scroll center
    center / cover;
  min-height: 473px;
  position: relative;
}
.image-instalaciones {
  position: absolute;
  right: 85px;
  top: -120px;
}
.login-areabox {
  margin-top: 55px;
  background-color: #ffffff;
  padding: 12px;
  color: #607d8b;
  border-radius: 20px;
  box-shadow: 0px 0px 20px -5px rgba(0, 0, 0, 0.59);
  position: relative;
}
login-box {
  min-height: 181px;
  margin-bottom: 55px;
  margin-top: 55px;
  background-color: #ffffff;
  padding: 25px;
  color: #607d8b;
  border-radius: 20px;
  box-shadow: 0px 0px 20px -5px rgba(0, 0, 0, 0.59);
  position: relative;
}

.label-log {
  font-weight: 700;
  font-size: 15px;
}

.btn-primary-log {
  color: #fff;
  background-color: #337ab7;
  border-color: #2e6da4;
}

.form-control {
  margin-bottom: 0px;
  height: auto;
  padding: 10px 10px;
}

.text-footer {
  font-size: 14px;
  line-height: 19px;
  margin-top: 36px;
  margin-bottom: 0px;
}

.text-right-log {
  text-align: right !important;
}
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 9px;
  padding-bottom: 9px;
  background-color: #eed0571f;
  margin-bottom: -50px;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
}

.loginRecuperarClave {
  color: #607d8b !important;
  font-weight: bold;
  text-decoration: underline;
  text-align: right;
}

.col-form-label {
  line-height: 2.1 !important;
  padding-right: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/resources/scss/style.scss","webpack://./src/resources/css/style.css","webpack://./src/resources/scss/_general.scss","webpack://./src/resources/scss/_variables.scss","webpack://./src/resources/scss/_helper.scss","webpack://./src/resources/scss/_bootstrap-custom.scss","webpack://./src/resources/scss/_waves.scss","webpack://./src/resources/scss/_menu.scss","webpack://./src/resources/scss/_demo-only.scss","webpack://./src/resources/scss/_buttons.scss","webpack://./src/resources/scss/_card.scss","webpack://./src/resources/scss/_modal.scss","webpack://./src/resources/scss/_checkbox-radio.scss","webpack://./src/resources/scss/_tab-accordions.scss","webpack://./src/resources/scss/_progressbar.scss","webpack://./src/resources/scss/_alerts.scss","webpack://./src/resources/scss/_notification.scss","webpack://./src/resources/scss/_tooltip-popovers.scss","webpack://./src/resources/scss/_charts.scss","webpack://./src/resources/scss/_form-elements.scss","webpack://./src/resources/scss/_form-advanced.scss","webpack://./src/resources/scss/_form-validation.scss","webpack://./src/resources/scss/_form-pickers.scss","webpack://./src/resources/scss/_form-wizard.scss","webpack://./src/resources/scss/_form-editors.scss","webpack://./src/resources/scss/_form-upload.scss","webpack://./src/resources/scss/_tables.scss","webpack://./src/resources/scss/_table-datatable.scss","webpack://./src/resources/scss/_table-responsive.scss","webpack://./src/resources/scss/_tablesaw.scss","webpack://./src/resources/scss/_table-editable.scss","webpack://./src/resources/scss/_sweetalert.scss","webpack://./src/resources/scss/_widgets.scss","webpack://./src/resources/scss/_nestable.scss","webpack://./src/resources/scss/_rangeslider.scss","webpack://./src/resources/scss/_rating.scss","webpack://./src/resources/scss/_calendar.scss","webpack://./src/resources/scss/_maps.scss","webpack://./src/resources/scss/_account-pages.scss","webpack://./src/resources/scss/_extra-pages.scss","webpack://./src/resources/scss/_timeline.scss","webpack://./src/resources/scss/_invoice.scss","webpack://./src/resources/scss/_responsive.scss"],"names":[],"mappings":"AAAA;;;;;CCKC;ADED;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;wCCwCwC;AC9CxC;;eDkDe;AC9Cf;EACI,kCCgCgC;ED/BhC,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,cCYY;EDXZ,eC+BiB;ED9BjB,yBCSY;AFuChB;;AC9CE;EACI,kBAAkB;EAClB,gBAAgB;ADiDtB;;AC/CE;;;;;;;;;;;;EAYC,cAAA;EDkDD,kCAAkC;EChDlC,cAAQ;ADkDV;;AAEA;;EC/CI,eAAe;ADkDnB;;AC/CE;;EAEC,eAAA;ADkDH;;AAEA;;EAEE,eAAe;AChDf;;ADmDF;;EC/CI,eAAA;ADkDJ;;AAEA;;EC/CI,eClBa;AFoEjB;;AAEA;;EC9CM,eAAU;ADiDhB;;AAEA;ECrDG,gBAKU;ADkDb;;AAEA;EACE,wBAAwB;AC1DxB;;AD6DF;;EAEE,kCAAkC;EChDlC,gBAAW;ADkDb;;AAEA;EChDE,UAAA;EACE,qBAAiB;ADkDrB;;AAEA;EChDG,UAAA;EDkDD,qBAAqB;AChDrB;;ADmDF;EChDI,UC1DI;ED2DL,qBAAA;ADkDH;;AAEA;EACE,WAAW;AG1Ib;;AH6IA;EACE,iBAAiB;EG3InB,kBAAM;EACJ,kBAAS;EACV,mBAAA;AH6ID;;AAEA;EG5IC,YAAA;EH8IC,gBAAgB;EG7IlB,WAAO;AH+IP;;AAEA;;eG7Ie;AHgJf;EACE,qBAAqB;AG/IvB;;AHkJA;EACE,wBAAwB;AGhJ1B;;AHmJA;EACE,wBAAwB;AGjJ1B;;AHoJA;EACE,0BAA0B;AGlJ5B;;AHqJA;EACE,2BAA2B;AGnJ7B;;AHsJA;EGnJC,yBAAA;AHqJD;;AAEA;EGpJC,4BAAA;AHsJD;;AAEA;EGrJC,4BAAA;AHuJD;;AAEA;EGtJC,+BAAA;AHwJD;;AAEA;EGvJC,kBAAA;EHyJC,mBAAmB;AGxJrB;;AH2JA;EACE,oBAAoB;AGzJtB;;AH4JA;EACE,4BAA4B;AG1J9B;;AH6JA;EACE,6BAA6B;AG3J/B;;AH8JA;EACE,6BAA6B;AG5J/B;;AH+JA;EACE,2BAA2B;AG7J7B;;AHgKA;EACE,4BAA4B;AG9J9B;;AHiKA;EACE,4BAA4B;AG/J9B;;AHkKA;EACE,0BAA0B;AGhK5B;;AHmKA;EACE,wBAAwB;AGjK1B;;AHoKA;EACE,2BAA2B;AGlK7B;;AHqKA;EACE,2BAA2B;AGnK7B;;AHsKA;EACE,2BAA2B;AGpK7B;;AHuKA;EACE,2BAA2B;AGrK7B;;AHwKA;EACE,2BAA2B;AGtK7B;;AHyKA;EACE,2BAA2B;AGvK7B;;AH0KA;EACE,2BAA2B;AGxK7B;;AH2KA;EACE,6BAA6B;AGzK/B;;AH4KA;EACE,8BAA8B;AG1KhC;;AH6KA;EACE,8BAA8B;AG3KhC;;AH8KA;EACE,8BAA8B;AG5KhC;;AH+KA;EACE,8BAA8B;AG7KhC;;AHgLA;EACE,8BAA8B;AG7KhC;;AHgLA;EG7KC,eAAA;AH+KD;;AAEA;EG7KE,eAAa;AH+Kf;;AAEA;EG7KC,gBAAA;AH+KD;;AAEA;EG9KC,gBAAA;AHgLD;;AAEA;EG/KC,sBAAA;EHiLC,yBAAyB;AGhL3B;;AHmLA;EACE,uBAAuB;EGjLzB,mBAAY;EACV,cAAa;EACd,WAAA;EHmLC,gBAAgB;AGlLlB;;AHqLA;EACE,kCAAkC;AGnLpC;;AHsLA;EACE,gBAAgB;AGpLlB;;AHuLA;EGpLC,mBAAA;AHsLD;;AAEA;EGrLC,gBAAA;AHuLD;;AAEA;EGtLC,0BAAA;AHwLD;;AAEA;EGtLE,aAAA;AHwLF;;AAEA;EGvLA,kBAAgB;EACd,mBAAY;AHyLd;;AGvLA;EACE,uBAAiB;AH0LnB;;AAEA;EGzLA,iCAAU;AH2LV;;AAEA;EGzLA,0CAAU;AH4LV;;AAEA;EG1LA,2BAAU;AH6LV;;AAEA;EACE,iBAAiB;EG5LnB,iBAAU;AH8LV;;AAEA;EACE,YAAY;EG7Ld,WAAA;AH+LA;;AAEA;EG5LA,YAAc;EACZ,WAAQ;AH8LV;;AG3LA;EAEA,YAAW;EACT,WAAS;AH6LX;;AAEA;EACE,aAAa;EGjMf,YAKE;AH8LF;;AAEA;EACE,wCAAwC;AG3L1C;;AH8LA;EG1LE,uBAAkB;AH4LpB;;AAEA,mBAAmB;AI/YnB;EJiZE,cAAc;EACd,YAAY;EI9Yd,WAAY;AJgZZ;;AAEA;EI9YE,mBAAe;EAKhB,sBAAA;AJ4YD;;AAEA,oDE1Ye;AF2Yf;EACE,YAAY;EI/Yd,kBAAO;EACL,yBAAgB;AJiZlB;;AIlZA;;eAIC;AJmZD;EIhZA,6BAAyB;EACvB,mBAAc;EACd,iBFNa;EEOb,eAAS;AJkZX;;AI/YA;EACA,cAAe;AJkZf;;AAEA;EI1YC,gBAAA;AJ4YD;;AAEA;EIjZM,aFKW;AF8YjB;;AI/YA;EACE,cAAA;EACA,cFpBY;EEqBb,iBAAA;AJkZD;;AAEA,aIlZE;AJmZF;EACE,cAAc;EI/Yf;iCJmZgC;EIjZjC,2CAAY;AJmZZ;;AAEA;EIjZE,iBAAiB;EAClB,eAAA;AJmZD;;AAEA;;;;EAIE,oCAAoC;EI/YtC,cAAA;AJiZA;;AAEA;;;EIxYA,oCAAW;AJ4YX;;AAEA;EI1YA,YAAY;AJ4YZ;;AAEA;EI1YA,kBAAY;EACV,gBAAgB;EACjB,eAAA;EJ4YC,8BAA8B;AI1YhC;;AJ6YA;EACE,cAAc;EI1YhB,+BAAY;EACV,iBAAgB;AJ4YlB;;AIzYA;EACE,qBFrFO;EEsFR,yBAAA;AJ4YD;;AAEA,sBE7dS;AF8dT;EACE,oCAAoC;AI1YtC;;AJ6YA;EACE,oCAAoC;AI1YtC;;AJ6YA;EACE,oCAAoC;AI1YtC;;AJ6YA;EACE,oCAAoC;AI1YtC;;AJ6YA;EACE,oCAAoC;AI1YtC;;AJ6YA;EACE,oCAAoC;AIzYtC;;AJ4YA;EIzYC,oCAAA;AJ2YD;;AAEA;EIzYC,oCAAA;AJ2YD;;AAEA;EIzYC,oCAAA;AJ2YD;;AAEA;EIzYC,oCAAA;AJ2YD;;AAEA;EIzYC,oCAAA;AJ2YD;;AAEA;EIzYC,oCAAA;AJ2YD;;AAEA,gBExhBiB;AFyhBjB;EACE,yBAAyB;AIzY3B;;AJ4YA;EACE,yBAAyB;AIzY3B;;AJ4YA;EACE,yBAAyB;AIzY3B;;AJ4YA;EACE,yBAAyB;AIzY3B;;AJ4YA;EACE,yBAAyB;AIzY3B;;AJ4YA;EACE,yBAAyB;AIzY3B;;AJ4YA;EIzYE,yBF7I0B;AFwhB5B;;AAEA;EIzYE,yBAAgB;AJ2YlB;;AIxYA;EACE,yBAAc;AJ2YhB;;AIxYA;EACE,yBAAmB;AJ2YrB;;AAEA;EIzYC,yBAAA;AJ2YD;;AAEA;EIzYE,yBAAuB;AJ2YzB;;AIxYA,UAAA;AJ2YA;EIzYC,yBAAA;EJ2YC,kCAAkC;EIzYpC,cAAe;EACb,gBAAgB;EACjB,eAAA;EJ2YC,gBAAgB;AIzYlB;;AJ4YA;EACE,cAAc;AIzYhB;;AJ4YA;;EIvYE,6BF7Mc;AFwlBhB;;AIxYA;EACE,0CFhNc;EEiNf,yBAAA;AJ2YD;;AAEA;EIzYC,yBAAA;AJ2YD;;AAEA;EIzYC,yBAAA;AJ2YD;;AIvYA;EACE,yBAAkB;AJ0YpB;;AAEA;EIxYA,yBAA0B;AAC1B;;AJ2YA;EACE,yBAAyB;AI5Y3B;;AJ+YA;EIzYI,yBAAU;AJ2Yd;;AAEA;EACE,yBAAyB;AIxY3B;;AJ2YA;EItYG,yBAAA;AJwYH;;AAEA,wBIrYoB;AJsYpB;;EAEE,kBAAkB;EI1YpB,gBAKE;AJuYF;;AAEA,yBAAyB;AIrYzB;EACE,UAAU;AJuYZ;;AAEA;EInYA,kBAAgB;EACd,QFlQO;EEmQR,UAAA;EJqYC,qBAAqB;EInYvB,eAAgB;AJqYhB;;AAEA,2BIpYC;AJqYD;EInYA,cAAgB;AAChB;;AJsYA;EInYC,gBAAA;EJqYC,WAAW;AIpYb;;AAEA;EACE,kBFhSM;AFsqBR;;AK7qBA;ELgrBE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AK9qBf;;ALirBD;;;;EK3qBI,mBAAkB;EAClB,cAAA;ALgrBJ;;AAEA;;;EK7qBI,yBAAkB;EAClB,qBAAkB;ALirBtB;;AAEA;;;EK7qBI,+BAA8B;ALirBlC;;AAEA;;;;;;uDK1qBiC;ALirBjC;EK/qBI,kBAAA;EACA,eAAA;EACA,qBAAmB;EACnB,gBAAgB;EAChB,yBAAwB;EAGxB,iBAAgB;EACjB,wCAAA;ALirBH;;AAEA;EKhrBI,kBAAY;EACZ,kBAAY;EACZ,YAAY;EACZ,aAAY;EACb,iBAAA;ELkrBD,kBAAkB;EKjrBlB,UAAA;EACE,8BAA8B;EAC/B;;;;;;GAID;EAEE,6BAAiB;ELwrBnB,uCAAuC;EKlrBrC,mCAAgC;EAChC,oBAAgB;ALsrBpB;;AAEA;EKprBI,oCAAoB;EACrB;;;;;;GAKC;ALurBJ;;AAEA;EKrrBI,8BAAa;ALurBjB;;AAEA;EKrrBI,oCAAgB;ALurBpB;;AAEA;EAEE,2BAA2B;AKtrB3B;;ALyrBF;;EKrrBE,wBAAoB;EAClB;;;;GAGF;AL0rBF;;AAEA;;;;EKtrBG,mBAAA;EL2rBD,sBAAsB;EK1rBtB,eAAA;EACE,YAAU;EACV,aAAM;EACN,cAAO;EACP,kCAAU;EACX,cAAA;EL4rBD,gBAAgB;EK3rBhB,kBAAc;EACZ,qBAAkB;EAClB,UAAO;AL6rBX;;AAEA;EK3rBG,qBAAA;EL6rBD,oBAAoB;AK5rBpB;;AL+rBF;EK5rBI,SAAA;EACA,qBAAoB;AL8rBxB;;AAEA;EK5rBG,oBAAA;EL8rBD,sBAAsB;AK7rBtB;;ALgsBF;EK7rBG,UAAA;AL+rBH;;AAEA;EK9rBG,kBAAA;ELgsBD,MAAM;EK9rBR,OAAA;EAEQ,UAAA;AL+rBR;;AK5rBA;EAEQ,kBH7IC;EG8IJ,YAAA;EL8rBH,aAAa;EK5rBf,kBAAa;EAEL,kBH1IE;AFu0BV;;AK1rBA;EAEQ,wBH9IE;EF20BR,iDAAiD;EKxrB3C,qBHlJD;AF60BP;;AKxrBA;EAGK,+CAAA;AL0rBL;;AAEA;EKvrBK,cAAA;ALyrBL;;AAEA;EKtrBK,0CAAA;ALwrBL;;AAEA;EKrrBK,yCAAA;ALurBL;;AAEA;EKprBK,wCAAA;ALsrBL;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EM72BE,yCAAA;AACF;;ANg3BA;EM12BI,wCAAW;AN42Bf;;AMh3BA;EAQI,wCAAY;AN42BhB;;AAEA;EMt3BA,yCAYe;AN42Bf;;AAEA;EM13BA,0CAgBuB;AN42BvB;;AAEA;EM93BA,uCAoBc;AN42Bd;;AAEA;;;;;;CAMC;AMz2BD,mBAAQ;AN22BR;EMz2BE,cAAU;EACV,WAAQ;AN22BV;;AAEA;EACE,YAAY;EMj3Bd,oBAOe;AN42Bf;;AAEA;EM12BI,aAAY;AN42BhB;;AAEA;EM12BG,cAAA;AN42BH;;AAEA;EMz2BE,kBAAgB;EAChB,SAAA;EACA,gBAAY;EN42BZ,gCAAgC;EMv2B1B,0BAAe;EAEhB,uCAAA;AN02BP;;AAEA;EMp2BK,yBAAA;ENs2BH,gBAAgB;EMh2BlB,gBAAU;EACR,YAAU;ANk2BZ;;AAEA;EACE,eAAe;EMh2BjB,iBAAM;ANk2BN;;AAEA;EMp2BA,aAGI;ANm2BJ;;AAEA;EMh2BA,kBACG;EACC,cAAa;EACb,kBAAgB;ANi2BpB;;AMp2BA;EAMI,iBAAU;ANk2Bd;;AAEA;EMh2BG,aAAA;ANk2BH;;AAEA;EM91BI,4BAAiB;EACjB,+BAAkB;ANg2BtB;;AAEA;EM91BI,kBAAkB;EAYnB,YAAA;ENq1BD,WAAW;EMz2Bb,cACE;AN02BF;;AAEA;EACE,iBAAiB;EM92BnB,iBACE;EAeI,kBAAkB;EAClB,wCAAS;EACT,+BAAU;EACX,qBAAA;ENi2BH,kBAAkB;AM91BpB;;ANi2BA;EACE,eAAe;EM91BjB,uCAAW;ANg2BX;;AAEA;EM91BE,kBAAS;EACT,SAAA;EACA,UAAA;ANg2BF;;AAEA;;;EMx2BA,wCAYkB;ANg2BlB;;AAEA;EM51BA,YAAU;EACR,WAAU;EACX,mBAAA;EN81BC,SAAS;EM51BX,aAAc;EACZ,oBAAkB;EAClB,eAAU;EAMX,SAAA;ENy1BC,+BAA+B;AMj2BjC;;ANo2BA;EM71BG,yCAAA;AN+1BH;;AAEA;EM51BE,kBJpKa;AFkgCf;;AAEA;EM51BE,kBJnJU;EIoJV,gBAAe;AN81BjB;;AAEA;EM51BC,yBAAA;EN81BC,gBAAgB;AM51BlB;;AN+1BA;EM51BE,YAAS;EACT,cAAW;EACX,qBAAkB;EAOnB,YAAA;ENw1BC,WAAW;EMp2Bb,yBAA2B;EAQvB,kBJxKU;EIyKV,yBAAqB;EACrB,eAAA;EACD,iBAAA;AN+1BH;;AAEA;EMnyBC,cAAA;ENqyBC,cAAc;EMh2BhB,kBAEE;EACE,iBAAA;EACA,kBAAe;ANg2BnB;;AAEA;;;EM51BI,cAAc;EACd,qBAAiB;EACjB,yBAAe;ANg2BnB;;AAEA;EM91BI,iBAAe;ANg2BnB;;AAEA;EM71BM,2BAAgB;ENk2BpB,kBAAkB;EMv3BpB,WAAa;EAyBT,qBAAe;EAChB,oCAAA;ENi2BD,oBAAoB;EM33BtB,iBA2BI;EAEE,eAAe;EACf,mCAAgC;EAChC,kCAA2B;EAE5B,0BAAA;ANi2BL;;AAEA;EM51BU,gBAAe;AN81BzB;;AAEA;EM51BU,eAAW;AN81BrB;;AAEA;EM31BU,wBAAY;AN81BtB;;AM/4BA;EAoDY,qBAAe;EAChB,eAAA;EN+1BT,iBAAiB;EMv1BnB,oBAAqB;EACnB,kBAAa;EACb,WAAA;EACD,4BAAA;ANy1BD;;AAEA;EMv1BE,YJnPO;AF4kCT;;AM31BA;EAII,eAAA;AN21BJ;;AM/1BA;EAQI,yBJnPgB;EIoPhB,yBJzPU;AFolCd;;AMv1BA;;EAOC,0BAAA;ENq1BC,cAAc;AM51BhB;;AN+1BA;;EAEE,yBAAyB;AMx1B3B;;AN21BA;;EMr1BA,yBAAyB;EACvB,cAAc;ANw1BhB;;AMr1BA;EAEI,kBJlRU;AFymCd;;AMj1BA;EACE,4BAAS;EACT,0BAAqB;ANo1BvB;;AAEA;EMl1BE,cAAc;ANo1BhB;;AAEA;EACE,kBAAkB;AMl1BpB;;ANq1BA;EACE,cAAc;AMt1BhB;;ANy1BA;EACE,6BAA6B;EMl1B/B,sBAEE;EAEI,oBAAS;EACV,eAAA;ENi1BH,eAAe;EMt1BjB,yBAEE;EAKI,cAAa;EACd,kCAAA;ANk1BL;;AAEA;;EAEE,4BAA4B;AM91B9B;;ANi2BA;EMj1BQ,kBAAa;ANm1BrB;;AAEA;;;EM90BI,wBAAU;ANk1Bd;;AMz2BA;EA0BM,aAAS;ANm1Bf;;AM72BA;EA4BQ,0BAAuB;ANq1B/B;;AAEA;EMn3BA,mBAqBE;EAYM,gBAAe;EACf,aAAY;EACb,yBAAA;ANq1BP;;AAEA;EMl1BQ,WAAW;EAoCZ,UAAA;ANizBP;;AAEA;EMp1BU,kBAAY;ANs1BtB;;AAEA;;;EMn1BY,yBJ1WG;EI2WJ,yBAAA;ANu1BX;;AAEA;EMr1BU,eAAU;EACV,6BAAkB;ANu1B5B;;AAEA;EACE,kBAAkB;EMh5BpB,mBAqBE;AN63BF;;AAEA;EMv1BY,kBAAY;EACZ,YAAU;EAKX,yBAAA;ENq1BT,yBAAyB;AMx5B3B;;AN25BA;;;;;;;;EMx0Bc,cAAW;ANi1BzB;;AAEA;EM/0Ba,cAAA;ENi1BX,UAAU;EMx6BZ,kBAqBE;EAsEY,YJtYP;EFutCL,gDAAgD;AM56BlD;;AN+6BA;;;;;;;;EMl0BG,gBAAA;EN40BD,iBAAiB;EMz7BnB,kBA8GE;EACE,YAAU;EACX,UAAA;AN60BH;;AAEA;;;;;;;;EM/7BA,cAAU;ANw8BV;;AAEA;;;;;;;;EMh0BQ,eAAa;ANy0BrB;;AMn0BA;EAEI,cAAQ;EACT,WAAA;ENq0BD,iBAAiB;EMx0BnB,kBAAQ;EAKJ,YAAO;ANs0BX;;AMj0BA;EACA,cAAY;ANo0BZ;;AAEA;EMt0BA,aAGI;EACA,kBAAkB;ANq0BtB;;AAEA;EM/zBG,aAAA;ANi0BH;;AAEA;EMp0BK,iBAAA;ANs0BL;;AMj1BA;EAgBI,UAAQ;ANq0BZ;;AAEA;EMn0BI,sBAAS;ANq0Bb;;AAEA;EMn0BI,aAAa;EACb,UAAO;ANq0BX;;AMj0BA;EACE,cJnfM;EIofP,iBAAA;ENo0BC,yBAAyB;AMl0B3B;;ANq0BA;EACE,aAAa;AMl0Bf;;ANq0BA;;;;;;;EM3zBA,aAAY;ANm0BZ;;AAEA;EMj0BE,QAAA;ANm0BF;;AAEA;EMh0BA,OAAA;ANk0BA;;AAEA,WMj0BE;ANk0BF;EACE,kBAAkB;AMh0BpB;;ANm0BA;EMxzBC,kBAAA;EN0zBC,QAAQ;EMr0BV,WAAA;EAII,+BAAgB;ANo0BpB;;AAEA;EM10BA,cAOE;ANq0BF;;AAEA;;EMh0BA,2CAAyB;EACzB,eAAc;EACZ,YAAY;EACb,cAAA;ENm0BC,0BAA0B;EMj0B5B,uBAAa;EACX,qCAAiB;ENo0BjB,gBAAgB;EMh0BlB,mBAAM;EACJ,YAAS;ANk0BX;;AM/zBA;EAEI,+BAAQ;ANi0BZ;;AMn0BA;EAKM,+BAA6B;ANk0BnC;;AAEA;EMh0BK,+BAAA;ANk0BL;;AM7zBA;EACE,+BAAoC;ANg0BtC;;AAEA,gBM/zBY;ANg0BZ;EM9zBE,eAAW;EACZ,gBAAA;ENg0BC,aAAa;EM7zBf,gBAAa;EACX,yBAAa;AN+zBf;;AM7zBA;EACE,eAAa;EAmDd,iBAAA;EN8wBC,kBAAkB;AMl0BpB;;ANq0BA;EM/zBI,kBAAkB;EAKnB,eAAA;AN6zBH;;AAEA;EMh0BK,gBAAA;ENk0BH,WAAW;AM50Bb;;AN+0BA;EM/zBI,YAAY;EACZ,wCAAY;ANi0BhB;;AAEA,wBMh0BmB;ANi0BnB;EM/zBG,kBAAA;ANi0BH;;AAEA;EM/zBI,iBAAgB;ANi0BpB;;AM31BA;EA8BI,cAAc;ANi0BlB;;AAEA;EM9yBG,qCAAA;ANgzBH;;AAEA;EMh0BM,oCAAmB;EACnB,gCAAc;EAEd,2BAAS;EACT,yBAAgB;ANk0BtB;;AAEA,WMj0BM;ANk0BN;EACE,yBAAyB;EM/2B3B,SAAA;EA+CM,uBAAe;EACf,kBAAiB;EACjB,QJ7mBG;EI8mBJ,WAAA;ANm0BL;;AAEA;EM/zBE,aAAW;ANi0Bb;;AAEA;EM/zBE,aJvnBK;AFw7CP;;AO78CA;EPg9CE,SAAS;EACT,2BO/8Cc;EAEhB,kBAAU;AP+8CV;;AAEA;EO78CA,aAAA;AAEA;;AP+8CA;EOx8CC,WAAA;EP08CC,cAAc;EOj9ChB,kBAGO;EACH,YAAA;EACA,iBAAgB;EACjB,kBAAA;EPg9CD,eAAe;EO78CjB,eAAa;AAEb;;AP+8CA;EO38CI,WAAW;EACX,gBAAY;AP68ChB;;AAEA;EACE,cAAc;EO18ChB,WAAA;EAEA,gBACE;EACE,iBAAU;AP08Cd;;AAEA;EOx8CG,uBAAA;EP08CD,mBAAmB;EOv8CrB,cAAe;EAEf,WAAA;EACE,SAAA;EACA,gBAAgB;EAChB,iBAAS;EACV,eAAA;EPw8CC,gBAAgB;AOt8ClB;;APy8CA;EO97CC,eAAA;EPg8CC,iBAAiB;EO18CnB,cAEE;AP08CF;;AAEA;EOx8CI,2CAAwB;EACxB,eAAU;EACV,yBAAkB;EACnB,gBAAA;EP08CD,uBAAuB;EOv8CzB,cAAe;AACf;;AP08CA;;eOp8CiB;APu8CjB;EOr8CI,kBAAgB;APu8CpB;;AO/8CA,gBAEE;APg9CF;EOt8CM,iBAAa;EACd,oBAAA;APw8CL;;AAEA;EOr8CI,mBAAgB;EAChB,gBAAe;APu8CnB;;AAEA,YOr8CI;APs8CJ;EOp8CI,kBLrEG;EKsEH,cAAa;EACb,WAAS;EACT,YAAY;EACb,YAAA;EPs8CD,UAAU;AOn+CZ;;APs+CA,aOr8CI;APs8CJ;EOp8CI,kBAAiB;EACjB,qBAAmB;EAMpB,iBAAA;EPi8CD,UAAU;AO3+CZ;;AP8+CA,cOt8CM;APu8CN;EACE,0CAA0C;EOn8C5C,gBAAA;EACA,kBAAgB;APq8ChB;;AAEA,mBAAmB;AOv8CnB;EAGI,kBAAe;APu8CnB;;AAEA;EOn8CA,kBAAA;EACA,YAAc;EACZ,cAAY;EACZ,wBAAW;EACX,UAAQ;EACT,kBAAA;APq8CD;;AAEA,cAAc;AACd;EQlkDA,eAAK;EACH,iBAAe;EACf,mBNmCmB;EMlCnB,uBAAiB;EACjB,cAAS;EACT,gBN6Be;AFuiDjB;;AQjkDA;EACE,gBAAS;EACV,oBAAA;ARokDD;;AAEA;EQlkDE,kBAAe;EAChB,sBAAA;ERokDC,eAAe;EQnkDjB,WAAa;EACX,YAAS;EACT,iBAAe;EAChB,kBAAA;ERqkDC,4BAA4B;EQpkD9B,kBAAkB;EAChB,qBAAS;EAEV,oBAAA;ARskDD;;AAEA;EQpkDE,kBAAkB;EACnB,uBAAA;ERskDC,4BAA4B;EQrkD9B,mBAAY;AACZ;;ARwkDA;EACE,cAAc;EQrkDhB,yBAAY;ARukDZ;;AAEA,mBQtkDC;ARukDD;EQtkDA,oBAAmB;AACnB;;ARykDA;EQtkDE,mBAAkB;EACnB,iBAAA;ARwkDD;;AAEA,sBE/mDU;AFgnDV;EQtkDC,YAAA;ERwkDC,WAAW;EQvkDb,cAAY;AACZ;;AR0kDA;;eQtkDC;ARykDD;EQvkDA,kBAAa;EACX,eAAA;EACA,iBAAiB;EAClB,wBAAA;ERykDC,kCAAkC;AQxkDpC;;AR2kDA;EQxkDC,iBAAA;AR0kDD;;AAEA;;EQvkDC,6BAAA;ER0kDC,eAAe;AQzkDjB;;AR4kDA;;EAEE,4BAA4B;EQzkD9B,eAAa;AR2kDb;;AAEA;;EQzkDA,2BAAoB;EAClB,eAAA;AR4kDF;;AAEA;EQzkDE,gDAAoC;AR4kDtC;;AAEA;;;;;;;;;EQnkDC,yBAAA;AR6kDD;;AAEA;EQ5kDE,yBAAmC;EACpC,qBAAA;AR8kDD;;AAEA;;;;;;;;;EQrkDA,oCAAU;EACR,oCAAkC;AR+kDpC;;AAEA;EQ9kDA,oCAAkC;EAChC,oCAA8C;ARglDhD;;AAEA;EQ9kDA,oCAAc;EACZ,oCAAkB;EACnB,qBAAA;ERglDC,WAAW;AQ9kDb;;ARilDA;;;;;;;;;EQxkDI,oCNtIY;EMuIZ,gCAAwB;ARklD5B;;AAEA;EQ/kDA,oCAA0B;EACxB,oCAA0B;ARilD5B;;AAEA;;;;;;;;;EQvkDE,oCAAqC;EAOtC,gCAAA;AR2kDD;;AAEA;EQhlDI,oCAAwB;EACxB,oCAAiD;ARklDrD;;AQ9kDA;;;;;;;;;EAQG,oCAAA;ERklDD,gCAAgC;AQ/kDlC;;ARklDA;EQzkDC,oCAAA;ER2kDC,oCAAoC;AQplDtC;;ARulDA;;;;;;;;;EQ5kDA,oCAAA;EAKI,gCNjLY;AFmwDhB;;AAEA;EACE,oCAAoC;EQ/kDtC,oCAA0B;ARilD1B;;AAEA;;;;;;;;;EQvkDE,oCAAyB;EACzB,gCAA0B;ARilD5B;;AQnlDA;EAKI,oCNtMY;EMuMZ,oCAAwB;ARklD5B;;AAEA;;;;;;;;;EQxkDI,oCAA8C;EAC/C,gCAAA;ARklDH;;AAEA;EQ/kDC,oCAAA;ERilDC,oCAAoC;AQ/kDtC;;ARklDA;;;EAGE,oCAAoC;EQhlDtC,gCAAa;ARklDb;;AAEA;EACE,oCAAoC;EQjlDtC,oCAAc;ARmlDd;;AAEA;;;EQhlDE,oCAAwB;EACxB,gCAAkB;ARolDpB;;AQllDA;EACE,wCAAwB;ARqlD1B;;AAEA;EQplDA,yBAAe;EACb,mDAAwB;ARslD1B;;AAEA;EQrlDA,yBAAe;EACb,oCAAwB;ARulD1B;;AAEA;;;EQplDE,yBAAkB;EACnB,yBAAA;ERwlDC,oCAAoC;AQvlDtC;;AR0lDA;EQvlDC,yBAAA;ERylDC,oCAAoC;AQxlDtC;;AR2lDA;;;EQvlDA,yBAAW;EACT,yBAAwB;EACxB,oCAAoC;AR2lDtC;;AQzlDA;EACE,yBAAwB;EACxB,oCAAoC;AR4lDtC;;AQ1lDA;;;EAGC,yBAAA;ER6lDC,yBAAyB;ES13D3B,oCAAA;AT43DA;;ASx3DA;EACE,yBPaa;EOZb,oCAAgB;AT23DlB;;AAEA;;;ESr3DG,yBAAA;ETy3DD,yBAAyB;ESn4D3B,oCAOK;AT83DL;;AAEA;ES13DA,yBAAc;EACZ,oCAAuB;AT43DzB;;AAEA;;;ESx3DA,yBAAgB;EACd,yBPnBa;EOoBb,oCAAS;AT43DX;;AAEA;ES13DA,yBAAY;EACV,oCAAS;AT43DX;;AAEA;;;ESx3DA,yBAAgB;EACd,yBPhCM;EOiCN,oCAAe;AT43DjB;;AAEA;ES13DA,yBAAa;EACX,oCAAkB;AT43DpB;;ASz3DA;;;EAGE,yBAAkB;EAClB,yBAAoB;EACpB,oCAA6B;AT43D/B;;ASz3DA;EACE,yBAAS;EACV,oCAAA;AT43DD;;AAEA;;;ESx3DA,yBAA0B;EACxB,yBAAuB;EACxB,oCAAA;AT43DD;;AAEA;ES13DC,yBAAA;ET43DC,oCAAoC;AS13DtC;;AT63DA;;;ESx3DE,yBAAsB;EACvB,yBAAA;ET43DC,oCAAoC;AS13DtC;;AT63DA;EACE,kBAAkB;AS13DpB;;AT63DA,mBS33DC;AT43DD;ES13DA,yBAA0B;EACxB,oCAAiC;AT43DnC;;ASz3DA;EAGM,yBP1EU;EO2EX,oCAAA;AT03DL;;AAEA;EACE,yBU19Dc;EAEhB,oCAEmB;AVw9DnB;;AAEA;EUt9DM,yBAAkB;EAClB,oCAAgB;AVw9DtB;;AAEA;EUj+DA,yBAEI;EAQI,oCAAwB;AV09DhC;;AAEA;EUx9DO,yBAAA;EV09DL,oCAAoC;AUx+DtC;;AV2+DA;EACE,yBAAyB;EU5+D3B,oCAkBM;AV49DN;;AAEA;EACE,yBAAyB;EUv9D3B,oCAAY;AVy9DZ;;AAEA;EACE,yBAAyB;EUv9D3B,oCACkB;AVw9DlB;;AAEA;EU39DA,yBAIc;EACV,oCAAgB;AVy9DpB;;AU99DA;EAQI,yBAAgB;EACjB,oCAAA;AV09DH;;AUr9DA;EACE,yBR5Ca;EQ6Cb,oCAAY;AVw9Dd;;AAEA;EU98DC,yBAAA;EVg9DC,oCAAoC;AU99DtC;;AVi+DA;;eEhgEQ;AFmgER;EUv9DG,yBAAA;EAGH,gBAAA;EACE,mBAAS;AVw9DX;;AAEA;EUt9DE,aRhEM;AFwhER;;AAEA;EACE,iBAAiB;AUt9DnB;;AVy9DA;EACE,uBAAuB;EUt9DzB,kBAAA;EAEI,YAAS;EACT,0BAAa;AVu9DjB;;AW1iEA;EX6iEE,yBAAyB;EACzB,SAAS;EW3iEX,cACO;AX4iEP;;AAEA;EACE,SAAS;EW1iEX,kCAAqB;EACrB,eAAY;EACR,cAAW;AX4iEf;;AAEA;EACE,+BAA+B;EW1iEjC,eAAa;EACb,mBAAW;AX4iEX;;AAEA;EW1iEI,kBAAW;AX4iEf;;AAEA;EW1iEC,yBAAA;EX4iEC,qCAAqC;EW1iEvC,kBAAW;EACP,oBAAkB;EACrB,6BAAA;AX4iED;;AWziEA;EACE,4BAAkB;AX4iEpB;;AAEA;EW1iEE,gCAAS;AX4iEX;;AWziEA;EACI,gCAAmB;AX4iEvB;;AWziEA;EACA,gCAAiC;AX4iEjC;;AAEA;EW1iEA,gCAA2B;AAC3B;;AX6iEA;EACE,gCAAgC;AW1iElC;;AX6iEA;EW1iEC,gCAAA;AX4iED;;AAEA;EWxiEM,gCT7DU;AFumEhB;;AAEA;EWtiEA,gCAEU;AXsiEV;;AAEA;EWpiEK,cAAA;AXsiEL;;AAEA;;eE5mEQ;AF+mER;EACE,qBAAqB;EW9hEvB,wBAES;EACH,qBThFC;ESiFD,kBTjFC;ESkFD,gBTvFS;ESwFV,aAAA;AX8hEL;;AAEA;EWxhEM,wBT1FW;ES2FX,STjGE;ESkGH,UAAA;EX0hEH,oBAAoB;AWthEtB;;AXyhEA;EWphEM,eT3GS;AFioEf;;AWjhEA;EAGM,UAAA;EACA,iBT1GI;AF4nEV;;AAEA;EW9gEA,UAAA;EAGM,eAAA;AX8gEN;;AAEA;EACE,gBAAgB;AW1gElB;;AX6gEA;EWxgEM,gBTzIS;AFmpEf;;AWlgEA;EAGM,gBTjJI;AFopEV;;AAEA,iBAAiB;AW//DjB;EAGM,yBTzJW;ES0JX,YT1JI;ES2JL,kBAAA;EX+/DH,aAAa;EW3/Df,kBAEI;AX2/DJ;;AAEA;EACE,kBAAkB;EWv/DpB,SAAA;EAGM,WAAA;EACA,cT1KW;ES2KZ,gBAAA;AXu/DL;;AAEA;EWj/DM,4BTlLU;ESmLX,iBAAA;EXm/DH,eAAe;EW/+DjB,yBAES;EACH,cTtMG;ESuMH,gBTvMU;ESwMX,SAAA;AX++DL;;AAEA;EWz+DM,aTjMI;AF4qEV;;AWt+DA;;EAIM,ST3MC;ES4MF,aAAA;AXu+DL;;AAEA;;eWh+DK;AXm+DL;;EW59DA,6BAAmB;EACf,gBAAW;AX+9Df;;AY5sEA;;EZgtEE,WAAW;EY5sEb,cAAa;EACX,WAAS;AZ8sEX;;AY3sEA;;EAEE,kBAAgB;EAChB,yBAAgB;EAChB,kBV0Be;EUzBf,WAAW;EAKZ,YAAA;EZ0sEC,WAAW;AYptEb;;AZutEA;EACE,kBAAkB;AY5sEpB;;AZ+sEA;;EY1sEA,kBAAiB;EACjB,eAAA;EAIM,cVRQ;EUSR,QAAA;EACA,SAAA;AZ0sEN;;AAEA;EYltEA,mBAEE;AZktEF;;AAEA;;EYrsEA,wBAAe;AZwsEf;;AAEA;;EYrsEE,UAAQ;AZwsEV;;AAEA;;EYtsEA,UAAA;AZysEA;;AAEA;EYvsEC,yBAAA;EZysEC,qBAAqB;EYvsEvB,cAAc;AACd;;AZ0sEA;EACE,yBAAyB;EYxsE3B,qBAAoB;EAClB,cAAA;AZ0sEF;;AaxwEA;Eb2wEE,yBAAyB;EACzB,qBa1wEc;EAEhB,cAAU;Ab0wEV;;AAEA;EaxwEE,yBAAY;EACZ,qBAAmB;EACnB,cAAU;Ab0wEZ;;AavwEA;EACE,yBAAgB;EAChB,qBAAc;EACd,cAAa;Ab0wEf;;AAEA;EaxwEA,yBAAsB;EACpB,qBAAQ;EAKT,cAAA;AbswED;;AAEA;Ea1wEI,yBAAgB;EACjB,qBAAA;Eb4wED,cAAc;AazwEhB;;Ab4wEA;EACE,yBAAyB;Ea7wE3B,qBAEE;EACE,cAAW;Ab6wEf;;AAEA;Ea1wEA,yBAAsB;EACpB,qBAAQ;EAKT,cAAA;AbwwED;;AAEA;Ea5wEI,qBAAiB;EAClB,cAAA;Ab8wEH;;AazwEA;EACI,qBAAiB;EACjB,cAAa;Ab4wEjB;;AAEA;Ea1wEI,qBAAgB;EAChB,cAAc;Ab4wElB;;AanxEA;EAUM,qBAAW;EACb,cAAA;Ab6wEJ;;AAEA;Ea3wEI,qBAAa;EACb,cAAU;Ab6wEd;;AAEA;Ea3wEI,qBAAkB;EAOrB,cAAA;AbuwED;;AAEA;Ea5wEM,qBAAkB;EAClB,cAAS;Ab8wEf;;Aa1wEA;EACE,qBAAqB;EAKtB,cAAA;AbywED;;AAEA;Ea7wEI,qBAAgB;EACjB,cAAA;Ab+wEH;;AAEA;;EAEE,YAAY;AahxEd;;AbmxEA;;eAEe;Aa7wEf;EACE,mBAAO;Ab+wET;;AahxEA;EAGI,cAAW;EACX,yBAAiB;EAClB,gBAAA;EbixED,kCAAkC;Ecj3EpC,eAAA;Adm3EA;;Ach3EA;EACE,0CAAkB;Adm3EpB;;Acp3EA;;EAKG,cAAA;Ado3EH;;AAEA,gBcl3Ec;Adm3Ed;EACE,cAAc;Ecj3EhB,kBAAY;EACV,gBAAc;EAYf,yBAAA;Adw2ED;;AAEA;;Ecj3EI,0CAAY;EACZ,cAAW;Ado3Ef;;AAEA;Ecl3EI,4DAAe;Ado3EnB;;Ach3EA;;;EAGE,oBAAc;EAOf,oCAAA;Ed62EC,6BAA6B;Acv3E/B;;Ad03EA;EACE,2CAA2C;Ec33E7C,mBAOK;EACD,cAAA;Ads3EJ;;Acl3EA,aAAY;Adq3EZ;Ecn3EE,cAAA;Adq3EF;;AAEA;;;Ecn3EG,yBAAA;Adu3EH;;AAEA;;eAEe;Acr3Ef;EACE,mCZ3Ce;EY4Cf,yBAAwC;EACxC,2BAAoC;EAOrC,YAAA;Edi3EC,mBAAmB;Ec33ErB,gBAIE;Ady3EF;;AAEA;Ecv3EI,gBAAgB;EACjB,cAAA;Ed03ED,gBAAgB;Ecv3ElB,iBAAc;Ady3Ed;;AAEA;Ecj3EC,sBAAA;Adm3ED;;AAEA;Ecz3EG,cAAA;Ed23ED,gBAAgB;Acj4ElB;;Ado4EA;EACE,uBAAuB;Acz3EzB;;Ad43EA;EACE,iBAAiB;Ee58EnB,mBAAA;Af88EA;;Ae18EA;EACE,uBAAgB;Af68ElB;;AAEA;Eeh8EC,eAAA;Efk8EC,iBAAiB;Ael9EnB;;Afq9EA,yBe78EG;Af88EH;Eet9EA,iBAUG;EACC,aAAW;EAIZ,WAAA;Ef28ED,kBAAkB;Ee19EpB,qBAUG;EAGG,gBbfU;EagBX,kBAAA;Afg9EL;;AAEA;Ee58EE,WbjBM;AF+9ER;;AAEA;Ee58EA,iBAAiB;EACf,aAAA;EACA,kBbvBa;EawBb,WAAA;EACD,qBAAA;Ef88EC,gBAAgB;Ee58ElB,kBAAiB;Af88EjB;;AAEA;Ee58EC,WAAA;Ef88EC,kBAAkB;Ee58EpB,SAAA;Af88EA;;AAEA;;EAEE,qBAAqB;Ae58EvB;;Af+8EA;;Ee38EE,cAAW;EACX,gBAAe;Af88EjB;;AAEA;;Ee38EE,sBAAkB;Af88EpB;;AAEA;;Ee38EE,iBAAW;EACX,mBAAgB;Af88ElB;;AgB3gFA;;EhB+gFE,sBgB7gFqB;AACvB;;AhB+gFA;;EgB3gFE,eAAA;EACA,iBAAe;AhB8gFjB;;AAEA;;eAEe;AgBthFf;EAUI,kBAAkB;AhB+gFtB;;AAEA;EgB7gFI,gBAAe;AhB+gFnB;;AgB7hFA;;EAkBG,YAAA;AhBghFH;;AAEA;EgB/gFG,kBAAA;AhBihFH;;AAEA;EgBhhFG,kBAAA;EhBkhFD,OAAO;EgB9gFT,YAAc;EACd,WAAS;EACP,kBdGe;EcIhB,MAAA;EhB0gFC,iBAAiB;EgBlhFnB,eAGE;AhBihFF;;AAEA;EgB/gFG,cAAA;EhBihFD,yBAAyB;EgB9gF3B,qBAAc;AhBghFd;;AAEA;EgB9gFA,cAAa;AhBghFb;;AAEA;EgB9gFA,yBAAgB;AhBghFhB;;AAEA;EgB9gFA,cAAe;EACb,yBdnCK;EcoCN,qBAAA;AhBghFD;;AgB7gFA;EACE,cAAA;AhBghFF;;AAEA;EgB9gFA,yBAAoB;AACpB;;AhBihFA;EACE,cAAc;EgB9gFhB,yBAAoB;EACpB,qBAAoB;AhBghFpB;;AAEA;EgB9gFA,cAAA;AACA;;AhBihFA;EACE,yBAAyB;AgB9gF3B;;AhBihFA;EgB9gFC,cAAA;EhBghFC,yBAAyB;EiBnmF3B,qBAAA;AjBqmFA;;AiBjmFA;EACE,cAAQ;AjBomFV;;AAEA;EiBlmFA,yBAAe;AACf;;AjBqmFA;EiBnlFC,oCAAA;AjBqlFD;;AAEA;;eiBlmFgB;AjBqmFhB;EACE,gBAAgB;EiB7mFlB,kCASW;EACP,yBAAiB;EAClB,eAAA;AjBsmFH;;AAEA;EiBrmFG,kCAAA;AjBumFH;;AAEA;EiBtmFG,eAAA;AjBwmFH;;AAEA;EiB7lFG,cAAA;AjB+lFH;;AAEA;EiBpmFM,yBAAyB;EACzB,cAAW;EACZ,qBAAA;AjBsmFL;;AiBjmFA;EACE,yBAAiB;EACjB,cAAA;EACA,qBAAY;AjBomFd;;AAEA;EiBlmFE,yBAAuB;EACvB,cAAA;EACA,qBAAe;AjBomFjB;;AiBlmFA;EACE,yBAAY;EACZ,cfpBe;EeqBhB,qBAAA;AjBqmFD;;AAEA;EiBpmFE,kBAAiB;EACjB,UAAA;EACD,YAAA;EjBsmFC,eAAe;EiBpmFjB,eAAA;EACA,YAAa;EACT,WAAA;EACA,yBAAkB;EACrB,kBAAA;EjBsmFC,kBAAkB;EiBpmFpB,iBACM;AjBqmFN;;AAEA;EiBlmFA,WAAA;EACA,gBAAkB;AjBomFlB;;AAEA;;sBiBjmFmB;AjBomFnB,YiB5lFC;AjB6lFD;EiBvmFA,oBAIY;EACR,YfrEI;EesEJ,kBftEW;EeuEX,uBAAe;EACf,4BAAc;EjBsmFhB,wCAAwC;AiBnmF1C;;AjBsmFA;EACE,6BAA6B;EiBpmF/B,cAAS;EAEL,kBf3FW;Ee4FX,ef5FW;Ee6FX,iDAAe;AjBqmFnB;;AiBlmFA;EACI,ef9Fa;AFmsFjB;;AiBnmFA;EACI,iBf/FU;AFqsFd;;AiBpmFA;EACI,oCf5GY;AFmtFhB;;AiBrmFA,aAAU;AjBwmFV;EiBtmFC,kCAAA;AjBwmFD;;AAEA;EiBvmFC,iBAAA;EjBymFC,kBAAkB;EiBxmFpB,yBAAoB;AjB0mFpB;;AAEA;EiBzmFA,0BAAoB;AjB2mFpB;;AAEA;EiB1mFA,yBAAuB;AjB4mFvB;;AAEA;EiB3mFA,4BAAuB;AjB6mFvB;;AAEA;EiB5mFA,2BAAuB;AjB8mFvB;;AAEA,eAAe;AiB7mFf;EACI,yBfpIY;EeqIf,yBAAA;AjB+mFD;;AAEA;;EiB7mFE,yBAAU;AjBgnFZ;;AAEA;;;EiB5mFE,4BAAkB;AjBgnFpB;;AAEA;;EiB7mFE,0BAAe;AjBgnFjB;;AAEA;;EiB7mFE,2BAAU;AjBgnFZ;;AiB5mFA;;0CAEmB;AjB+mFnB;EACE,wBAAwB;EiB9mF1B,iBAAe;AjBgnFf;;AAEA,cAAc;AiB/mFd;EACI,iBAAiB;EACpB,aAAA;AjBinFD;;AAEA;EiBhnFI,kBAAU;EACb,cAAA;EjBknFC,6BAA6B;AiBjnF/B;;AjBonFA;EiBjnFE,iBf1Ie;AF6vFjB;;AiBjnFA;EACI,iBAAQ;AjBonFZ;;AiBlnFA;EACE,iBAAgB;AjBqnFlB;;AiBlnFA;EAEI,cAAa;AjBonFjB;;AAEA;EiBjnFA,4BAAqB;EACrB,yBAAY;EACV,eAAA;AjBmnFF;;AAEA,eiBlnFS;AjBmnFT;EiBjnFE,iBAAgB;EAChB,oCAA4B;EAC5B,YAAA;EACA,cAAa;EACb,YAAA;EACA,eftLK;EeuLN,6BAAA;AjBmnFD;;AAEA;EiBlnFE,YAAW;EACZ,kCAAA;AjBonFD;;AiB/mFA;EAEI,4BAAqB;EACtB,iBAAA;EjBinFD,mBAAmB;AkBz0FrB;;AlB40FA,iBkB10FgB;AAEhB;EAEA,kBAAM;EACJ,kBAAgB;AlBy0FlB;;AAEA;EACE,6CAA6C;AkBv0F/C;;AlB00FA,mBkBx0FC;AlBy0FD;EkBx0FA,WAAa;AlB00Fb;;AAEA;EkBx0FE,iBAAY;AlB00Fd;;AAEA;EkBx0FE,aAAY;EACZ,cAAY;EAMb,eAAA;ElBq0FC,cAAc;AkBp1FhB;;AlBu1FA;EkB10FI,6BAAqB;AlB40FzB;;AkBx0FA;EACE,cAAY;EACZ,aAAS;EACT,eAAe;AlB20FjB;;AAEA;;;;EkBv0FE,eAAS;AlB40FX;;AAEA;;;;EkBx0FE,eAAa;AlB60Ff;;AAEA;;;;EAIE,eAAe;AkB70FjB;;AlBg1FA;;;;EkB30FC,eAAA;AlBg1FD;;AAEA;;;;EkB50FA,eAAa;AACb;;AAEA;;;;ElBo1FE,eAAe;AkB/0FjB;;AAEA;;;;EAIE,ehBlEe;AFm5FjB;;AkB/0FA;;EAEA,aAAW;AACX;;AAEA;;EAEC,aAAA;AlBk1FD;;AAEA;;EkBh1FC,aAAA;AlBm1FD;;AAEA;;EkBj1FC,aAAA;AlBo1FD;;AAEA;EkBn1FE,kBAAY;EACb,qBAAA;ElBq1FC,UAAU;EkBn1FZ,eAAiB;EACf,iBAAe;EAChB,kBAAA;ElBq1FC,mBAAmB;EmB57FrB,cAAA;EnB87FE,kBAAkB;EAClB,oBmB77Fc;EAEhB,UAAA;EAEE,+BAAgB;AnB67FlB;;AAEA;EmBp7FC,UAAA;AnBs7FD;;AAEA,amB77FI;AnB87FJ;EmB57FI,eAAY;AnB87FhB;;AAEA;EmB17FA,mBAAkB;AnB47FlB;;AAEA;EmB17FA,iBAAiB;AnB47FjB;;AAEA;EmBz7FE,4CjBRY;EiBSZ,UAAU;AnB47FZ;;AAEA;EmB17FC,eAAA;EnB47FC,gBAAgB;EmB17FlB,kCAAc;AACd;;AnB67FA;EACE,uBAAuB;AmB97FzB;;AnBi8FA;EmB36FG,yBAAA;AnB66FH;;AAEA;EmB57FM,gBAAc;EACf,kCAAA;AnB87FL;;AAEA,oBmB77FkB;AnB87FlB;EmBt7FK,uBAAA;EnBy7FH,sBAAsB;EmB98FxB,uBAGE;EAeM,oCAAc;EACd,4BAA2B;EAC5B,kBAAA;EnB+7FL,uBAAuB;EmB17FzB,gCACE;AnB27FF;;AAEA;EACE,0BAA0B;EmBl7F5B,4BAA4B;AnBo7F5B;;AAEA,gBAAgB;AmBn7FhB;EACE,qBAAiB;AnBq7FnB;;AmBl7FA;;eAEe;AnBq7Ff,oBmBp7FoB;AnBq7FpB;EACE,gBAAgB;EmBp7FlB,eACE;EACE,kCAAQ;AnBq7FZ;;AmBj7FA;EACE,gBAAY;AnBo7Fd;;AAEA;EmBv7FA,yBAAmB;EAKf,kBAAiB;EAClB,iBAAA;EnBq7FD,YAAY;EmB37Fd,eAAA;EAQI,eAAe;EAEhB,gBAAA;EAVH,4BAAmB;EAYf,gBAAgB;AnBu7FpB;;AAEA;EmBr7FG,yBAAA;EAIH,gBAAA;EACA,qBACE;AnBo7FF;;AAEA;EACE,YAAY;EmBj7Fd,kBAAkB;EAClB,eAAA;EACE,sBAAQ;EACR,kBjBtHM;AFyiGR;;AAEA;EmBj7FE,YAAA;EACA,iBAAiB;EAClB,eAAA;EnBm7FC,gBAAgB;EmBj7FlB,kBAAA;AnBm7FA;;AAEA;EmBj7FC,kBAAA;AnBm7FD;;AAEA;EmBj7FC,4BAAA;AnBm7FD;;AAEA;EmBj7FE,iBAAe;AnBm7FjB;;AmBh7FA;EACE,iBAAiB;AnBm7FnB;;AAEA;EmBj7FA,kBAAoB;AnBm7FpB;;AAEA;;;;;;;;;;;EmBv6FC,cAAA;AnBm7FD;;AAEA;;;;;;;;;;;EoBxlGA,cAAe;ApBomGf;;AAEA;;;;;;;;;;;EoBvlGE,cAAY;ApBmmGd;;AqBtnGA;ErBynGE,qBAAqB;EqBpnGvB,2BAA6B;ArBunG7B;;AAEA;EACE,qBAAqB;EqBnnGrB,2BAAwB;ArBsnG1B;;AqBnnGA;EACI,qBAAW;EAEd,2BAAA;ArBsnGD;;AqBnnGA;EACA,eAAiB;AACjB;;AAEA;;eAEY;AACZ,wBAAuB;AACvB;EAEA,gBAAkB;EAClB,oBAAqB;EACrB,WAAY;EACZ,yBAAuB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAc;EACd,YAAA;EACA,eAAa;ArBsnGf;;AqBnnGA;EACE,eAAA;ArBsnGF;;AAEA;EACE,cAAc;EqBpnGhB,WAAA;EACI,WAAW;EACd,gBAAA;ErBsnGC,cAAc;EqBlnGhB,mBAAmB;EACf,mBnBvDK;EmBwDL,eAAc;EACjB,SAAA;ArBonGD;;AAEA,aqBpnGe;ArBqnGf;EACE,sBAAsB;AqBpnGxB;;ArBunGA;EqBpnGE,oCAAgB;EAChB,uBAAe;ArBsnGjB;;AAEA;;;EqBnnGE,4BnBlDK;EmBmDL,6BAAY;ArBunGd;;AAEA;;;EqBpnGE,YnBvEM;EmBwEP,WAAA;ErBwnGC,UAAU;AqBtnGZ;;ArBynGA;;;;EqBnnGE,sDAAY;EACZ,2BnBnEc;AF2rGhB;;AsBhtGA;;;;EAKE,iEpBEa;EoBDb,sCAAiB;AtBktGnB;;AAEA;;EAEE,yBAAyB;AsBhtG3B;;AtBmtGA;EsBhtGE,iBAAW;AtBktGb;;AsBrtGA;EAMI,oCAAoC;EACrC,gBAAA;EAPH,yCASU;AtBmtGV;;AAEA;EACE,oCAAoC;AsB/tGtC;;AtBkuGA;EsBltGI,2BAAe;EACf,oCAAe;AtBotGnB;;AsBruGA;;;EAsBG,iBAAA;AtBqtGH;;AAEA;;;EsB9sGG,eAAA;EtBktGD,oBAAoB;AsBxtGtB;;AtB2tGA;;;EsB9sGI,yBAAU;EACV,yBAAU;EACV,kBAAY;EACb,cAAA;AtBktGH;;AAEA,wBErvGgB;AFsvGhB;EsB/sGM,SAAQ;EACR,YAAY;AtBitGlB;;AsBxuGA,iBAkBE;AtBytGF;EsBjtGQ,yBAAqC;EACtC,mBAAA;EtBmtGL,eAAe;EsB9uGjB,cAAgB;EA8BR,yCAAqC;AtBotG7C;;AsBlvGA;EAoCM,gBpBvEG;EoB0FJ,mBAAA;EtBgsGH,gBAAgB;AsBvvGlB;;AtB0vGA;EACE,gBAAgB;AsB3vGlB;;AtB8vGA;EsBptGS,oCAAA;EtBstGP,eAAe;AsBhwGjB;;AtBmwGA;EACE,iBAAiB;EsBpwGnB,cAAgB;AtBswGhB;;AAEA;EACE,gBAAgB;AsBzwGlB;;AtB4wGA;EsBttGO,iBAAA;EtBwtGL,eAAe;EsB9wGjB,cAAgB;EA2DV,cpB5EG;AFkyGT;;AAEA,qBAAqB;AsBltGrB;;;EAGC,sBAAA;AtBotGD;;AAEA;EsB/qGC,wBAAA;AtBirGD;;AAEA,wBEj0GgB;AFk0GhB;EsBntGI,kBpB1GW;AF+zGf;;AsB3tGA;;epBpGQ;AFo0GR;EACE,gCAAgC;AsBjuGlC;;AtBouGA;EsBrtGK,aAAA;EtButGH,SAAS;EsBtuGX,UAAU;AtBwuGV;;AAEA;EsBptGM,eAAQ;EAaT,gBAAA;EtB0sGH,cAAc;EsB7uGhB,eAAU;AtB+uGV;;AAEA;;esBrtGO;AtBwtGP;EsBpvGA,uCA6Be;EACP,WAAU;AtBytGlB;;AAEA;EsBvtGO,wBAAA;AtBytGP;;AAEA;;EAEE,WAAW;EsBptGb,YAAQ;AtBstGR;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EuB11GI,oCAAS;EACV,yBAAA;EvBm3GD,iCAAiC;EuBl4GnC,4BAgBkB;AvBo3GlB;;AAEA;;;;EuBj3GM,oCAAgB;EACjB,yBAAA;EvBs3GH,iCAAiC;AuBn3GnC;;AvBs3GA;EACE,uCAAuC;AuBn3GzC;;AvBs3GA;;EuBt3GA,yBAOe;EACX,yBAAkB;AvBk3GtB;;AAEA;EuB53GA,uCAAA;AvB83GA;;AAEA;EuBh3GA,kBAAc;EACZ,cAAS;EACV,gBAAA;EvBk3GC,eAAe;EuB92GjB,kCAAiB;AAEjB;;AvBg3GA;;;;EuB32GE,uCAAmC;EACnC,YAAY;EACb,WAAA;AvBg3GD;;AAEA;;EAEE,yBAAyB;EuBh3G3B,cAAc;AACd;;AvBm3GA;EACE,cAAc;AuBj3GhB;;AvBo3GA;;EuBj3GA,eAAY;EACV,YAAS;EACV,cAAA;AvBo3GD;;AAEA;;euBl3GC;AvBq3GD;EwBv8GA,mBAAA;ExBy8GE,iBAAiB;EACjB,wBwBx8Gc;EAEhB,yBAAuB;EACrB,2BAAW;AxBw8Gb;;AAEA;EwBt8GA,YAAA;EACE,kBAAW;EACZ,WAAA;AxBw8GD;;AAEA;EwBv8GE,yBAAkB;AxBy8GpB;;AAEA;EACE,cAAc;EyB19GhB,iBAAA;AzB49GA;;AyBz9GA;EACE,cvBiCe;EuBhCf,cAAa;EACd,eAAA;EzB49GC,eAAe;AyB39GjB;;AzB89GA;EACE,qBAAqB;EyBt9GvB,gBAAA;AACA;;AzBy9GA;EACE,eAAe;EyBn9GjB,kBAAc;EAGR,kCvB1BU;AF6+GhB;;AyB/8GA;EAGM,eAAA;EACD,iBAAA;EzBg9GH,kCAAkC;EyB78GpC,kBAAc;EAGR,UAAA;EACD,UAAA;EzB68GH,YAAY;AyBz8Gd;;AzB48GA;EACE,mBAAmB;EyBr8GrB,yBAAc;EAGR,eAAA;EACD,yBAAA;AzBq8GL;;AAEA;EyB/7GK,mBAAA;EzBi8GH,yBAAyB;AyB77G3B;;AzBg8GA;EACE,mBAAmB;EyBz7GrB,yBACE;AzB07GF;;AAEA;EyBr7GA,mBAAc;AzBu7Gd;;AAEA;EyBh7GA,mBAAA;AAEA;;AzBk7GA;EyB76GK,cAAA;EzB+6GH,YAAY;AyB36Gd;;AzB86GA;EACE,mBAAmB;AyB/6GrB;;AzBk7GA;EACE,cAAc;EyBz6GhB,YAAA;AzB26GA;;AAEA;EyB76GA,cAAA;EAKM,YAAA;AzB26GN;;AyBt6GA;EACE,8BvBpHY;EuB2Hb,yBAAA;AzBm6GD;;AAEA;;;;EyBl6GE,kBvBxIO;EuB+IR,kBAAA;AzBi6GD;;AAEA;EyBr6GK,2BAAA;AzBu6GL;;AAEA;EyB75GC,mBAAA;EzB+5GC,8BAA8B;EyBv6GhC,cAAA;AzBy6GA;;AAEA;EyBj6GA,mBAAA;EACE,cAAY;AzBm6Gd;;AyBp6GA;EAKM,mBvBpJG;EuBqJJ,cAAA;AzBm6GL;;AAEA;EyBz5GC,mBAAA;EzB25GC,cAAc;EyBn6GhB,eAAA;EAKM,yBvB3JW;AF4jHjB;;AyB55GA;EACE,mBvBlKK;EuByKN,cAAA;EzBy5GC,eAAe;EyBj6GjB,yBAAuB;AzBm6GvB;;AAEA;EyB35GA,mBAAA;EACE,cAAY;EAOb,eAAA;EzBu5GC,yBAAyB;AyB/5G3B;;AzBk6GA;EACE,0BAA0B;AyBx5G5B;;AzB25GA;EyBv4GC;;IAnBD,WAAA;EAKM;AzB05GN;;AAEA;;eyBt5Gc;AzBy5Gd,eyBx5GK;AzBy5GL;EyBr6GA,kBASE;EAMM,kBvB/MO;AFwmHf;;AyBn5GA;EACE,6BvBnNQ;EuBiOT,oCAAA;AzBy4GD;;AAEA;;EAEE,4BAA4B;AyB55G9B;;AzB+5GA;EACE,yBAAyB;EyB/4G3B,gCAAmB;EACjB,SAAA;AzBi5GF;;AyBl5GA;EAKM,yBvBvOW;AFwnHjB;;AyBt5GA;EAWQ,gBAAgB;EACjB,YAAA;EzB+4GL,gBAAgB;AyB14GlB;;AzB64GA;EACE,oCAAoC;AyB94GtC;;AzBi5GA;EACE,uBAAuB;AyBl5GzB;;AzBq5GA;EACE,6BAA6B;EyBr4G/B,oCAAsC;AzBu4GtC;;AAEA;;EyBp4GM,4BvBlRU;AFypHhB;;AyB54GA;EAWQ,uBvBxRC;AF6pHT;;AyB/3GA,gBAAA;AzBk4GA;EyBn3GC,oCAAA;EzBq3GC,oCAAoC;AyBp4GtC;;AzBu4GA;EACE,oCAAoC;EyB53G/B;mCzBg4G4B;AyB33GnC;;AzB83GA;;;EyBz3GM,gCvBxSU;AFqqHhB;;AyBl4GA;;;;;EAkBE,oCvBlTQ;AF0qHV;;AyBz3GA;EAKM,kCvBtTW;AF8qHjB;;AyB73GA;EAWQ,wBvB5TE;AFkrHV;;AyB/2GA;EACE,+BvBrUK;EuBmVN,2BAAA;AzBq2GD;;AAEA;;eAEe;AyBx3Gf;EAWQ,WAAA;EACD,yBAAA;AzBg3GP;;AAEA;EyB91GC,WAAA;AzBg2GD;;AAEA;EyB32GK,yBAAA;EzB62GH,iCAAiC;EyBn3GnC,cAAA;EAWQ,oCvBjWQ;AF4sHhB;;A0B1tHA;;e1B8tHe;A0B1tHf;EACA,kCAAmB;EACjB,gBAAgB;A1B4tHlB;;AAEA;E0B1tHE,iCAAkB;A1B4tHpB;;AAEA,kB0B3tHC;A1B4tHD;E0B3tHA,cAAG;A1B6tHH;;AAEA;E0B3tHC,yBAAA;A1B6tHD;;AAEA;E0B5tHE,yBAAe;A1B8tHjB;;A0B5tHA;EACE,yBAAqB;A1B+tHvB;;A0B5tHA;EAGM,yBAAsB;A1B6tH5B;;A0BhuHA;EAOI,yBAAiB;A1B6tHrB;;AAEA;EACE,yBAAyB;A0BvuH3B;;A1B0uHA;EACE,yBAAyB;A0BztH3B;;A1B4tHA;EACE,yBAAyB;A0BrtH3B;;A1BwtHA;EACE,yBAAyB;A0BrtH3B;;A1BwtHA,2B0BttHsB;A1ButHtB;EACE,2BAA2B;E0BttH7B,cAAA;AACA;;A1BytHA;E0BttHE,yBxBhEc;AFwxHhB;;AAEA;E0BttHA,yBAA2B;AAC3B;;A1BytHA;E0BttHE,yBxB/De;AFuxHjB;;A0BttHA;EACA,yBAA0B;A1BytH1B;;AAEA;E0BxtHA,yBAAsB;A1B0tHtB;;AAEA;E0BxtHA,yBAAmB;AACnB;;A1B2tHA;E0BxtHC,yBAAA;A1B0tHD;;A0BxtHA;EACE,yBAAW;A1B2tHb;;AAEA;E0BztHE,yBAAgB;A1B2tHlB;;AAEA;E0BztHC,yBAAA;A1B2tHD;;AAEA;E0B1tHC,yBAAA;A1B4tHD;;AAEA;E0B3tHC,yBAAA;A1B6tHD;;AAEA;E0B5tHE,yBxBrGa;AFm0Hf;;AAEA;EACE,yBAAyB;A0B7tH3B;;A1BguHA;E0B7tHE,yBAAuB;A1B+tHzB;;AAEA;E0B9tHA,yBAAuB;A1BguHvB;;AAEA;E2Bv1HA,yBAAsB;AACtB;;A3B01HA;EACE,yBAAyB;A2B31H3B;;A3B81HA,uB2Bv1HG;A3Bw1HH;E2B/1HA,cAAA;A3Bi2HA;;AAEA;EACE,2BAA2B;E2Bp2H7B,wBAcE;A3Bw1HF;;AAEA;;E2Bt1HM,oBAAS;A3By1Hf;;AAEA;EACE,cAAc;A2B92HhB;;A3Bi3HA;E2Bz1HQ,wCzBnBO;AF82Hf;;AAEA;E2Bz1HQ,yBAAqB;A3B21H7B;;AAEA;E2Bz1HQ,yBAAkB;A3B21H1B;;AAEA;E2Bz1HO,yCAAA;A3B21HP;;AAEA;E2B11HQ,yBAAqB;A3B41H7B;;AAEA;E2B11HQ,yBAAkB;A3B41H1B;;AAEA;E2B11HQ,yCAAS;A3B41HjB;;AAEA;E2B74HA,yBAcE;A3Bi4HF;;AAEA;E2B11HM,yBAAwB;A3B41H9B;;A2Bn5HA;EA0DQ,yCAAa;A3B61HrB;;A2Bv5HA;EA+DQ,yBAAoB;A3B41H5B;;AAEA;E2B75HA,yBAcE;A3Bi5HF;;AAEA;EACE,wCAAwC;A2Bl6H1C;;A3Bq6HA;E2Bx1HO,yBAAA;A3B01HP;;AAEA;E2Bv1HQ,yBzBlFQ;AF26HhB;;A2B36HA;EAqFQ,wCzBrFQ;AF+6HhB;;A2B/6HA;EAAA,yBA0FE;A3By1HF;;AAEA;EACE,yBAAyB;A2Bt7H3B;;A3By7HA;E2B11HK,uCAAA;A3B41HL;;AAEA;E2Bz1HK,yBAAA;A3B21HL;;AAEA;EACE,yB4Bl8Hc;AAEhB;;A5Bm8HA;E4B/7HI,yCAAY;A5Bi8HhB;;A4Br8HA;EAOM,yBAAiB;A5Bk8HvB;;AAEA;E4B38HA,yBAWM;A5Bk8HN;;AAEA;E4Bh8HK,0CAAA;A5Bk8HL;;AAEA;E4Bh8HG,yBAAA;A5Bk8HH;;AAEA;E4B/7HE,yBAAoB;A5Bi8HtB;;AAEA;;e4B/7He;A5Bk8Hf,e4Bj8HC;A5Bk8HD;E4Bj8HA,yBAAmB;EACjB,YAAW;EACX,cAAW;E5Bo8HX,gBAAgB;E4Bl8HlB,kBAAmB;EACjB,kBAAgB;EACjB,WAAA;A5Bo8HD;;AAEA;E4Bn8HC,mBAAA;E5Bq8HC,0CAA0C;E4Bp8H5C,cAAc;A5Bs8Hd;;AAEA;EACE,2BAA2B;E4Br8H7B,8BAAgB;A5Bu8HhB;;AAEA;;E4Br8HE,mCAAiB;A5Bw8HnB;;AAEA;E4Bv8HA,sBAAmB;A5By8HnB;;AAEA;E4Bt8HA,iBAAmB;EACjB,Y1B3DO;E0B4DP,WAAA;A5Bw8HF;;AAEA;;EAEE,wBAAwB;A6B3gI1B;;A7B8gIA;;E6BxgII,wBAAgB;A7B2gIpB;;A6B7gIA;EAKI,cAAQ;A7B4gIZ;;A6BzgIA,uBAAoB;A7B4gIpB;E6B1gIC,oBAAA;A7B4gID;;AAEA,qBEphIQ;AFqhIR;;EAEE,qCAAqC;E6B5gIvC,oBAAoB;EAClB,yB3BLc;E2BMf,cAAA;A7B8gID;;AAEA,0BEthIgB;AFuhIhB;;;;;;;;EASE,0CAA0C;E6BhhI5C,yBAAc;A7BkhId;;AAEA;;;;;;;;E6B1gIC,yBAAA;A7BmhID;;AAEA;E6BhhIC,kCAAA;A7BkhID;;AAEA,kB6BlhIa;A7BmhIb;EACE,WAAW;E6BlhIb,kBAAgB;A7BohIhB;;AAEA;;E6BlhIA,WAAK;EACL,kBAAgB;EAChB,wBAAwB;EACtB,gBAAU;EAEV,gBAAU;EACV,yBAAc;EACd,oCAAwB;EACzB,oCAAA;A7BqhID;;AAEA;E6BphIE,WAAW;A7BshIb;;A6BphIA;EACE,6BAAgB;A7BuhIlB;;A6BrhIA;EACE,mBAAgB;EACjB,yBAAA;EACD,2CAA4C;EAC5C,YAAA;AACA;;AAEA;EACA,kCAAmC;EACnC,4BAA4B;EAC5B,uBAAuB;EAErB,2BAAwB;A7ByhI1B;;A8BzmIA;EACA,WAAA;AACA;;A9B6mIA,qB8B1mIe;A9B2mIf;EACE,4BAA4B;A8B7mI9B;;A9BgnIA;E8B3mIG,uBAAA;A9B6mIH;;AAEA;E8BxmII,eAAe;EAChB,mBAAA;A9B0mIH;;AAEA;E8BtmIG,kBAAA;A9BwmIH;;AAEA;E8BtmIK,qBAAA;E9BwmIH,iBAAiB;E8BnmInB,kBAAW;A9BqmIX;;AAEA;E8BvmIA,+BAMK;EACC,oCAA+B;EAChC,yBAAA;E9BmmIH,kBAAkB;E+B3oIpB,yBAAA;E/B6oIE,WAAW;EACX,qB+B5oIc;EAEhB,YAAA;EAEI,OAAA;EACA,kBAAW;EACX,kBAAW;EACX,4BAAM;EACN,W7BSK;E6BRL,wBAAgB;A/B2oIpB;;AAEA;EACE,cAAc;E+BrpIhB,qBAYE;EACE,eAAU;EACX,YAAA;E/B2oID,OAAO;E+BxoIT,kBACI;EACA,iBAAe;EAChB,gBAAA;E/ByoID,kBAAkB;E+B5oIpB,SAAA;EAKI,WAAU;A/B0oId;;AAEA;E+BxoII,eAAU;EACV,UAAA;EACA,UAAQ;EACR,wBAAW;A/B0oIf;;AAEA;;;;EAIE,aAAa;A+B5pIf;;A/B+pIA;;;;E+BroIE,oB7B9CO;E6B+CR,aAAA;A/B0oID;;AAEA;;;;E+BroIA,gBAAA;EACE,0B7B9Ce;AFwrIjB;;AAEA;;;;E+BroIC,yBAAA;E/B0oIC,mBAAmB;A+BxoIrB;;A/B2oIA;;;;E+BroIE,yB7B1Dc;E6B2Dd,qB7B3Dc;AFqsIhB;;A+BvoIA;;;;E/B6oIE,cAAc;A+BxoIhB;;A/B2oIA;;;E+BtoIA,yBAAiB;EACf,qB7BvEK;AFitIP;;AAEA;;;E+BjoIC,cAAA;A/BqoID;;AAEA;E+BzoII,oBAAkB;A/B2oItB;;A+BvoIA;;eAGe;A/ByoIf;E+BvoIG,oCAAA;E/ByoID,sBAAsB;E+B9oIxB,YAAA;A/BgpIA;;AAEA;E+BxoII,iBAAY;EACZ,sBAAqB;A/B0oIzB;;AAEA;E+BxoII,gBAAY;EACZ,YAAA;EACA,kCAAkB;A/B0oItB;;A+B3pIA;EAoBM,yDAAsB;A/B2oI5B;;AAEA;;E+BroIA,kBAAa;EACX,oBAAkB;EAOnB,wBAAA;A/BkoID;;AAEA;;E+BtoIG,mBAAA;A/ByoIH;;AAEA;;;;;;E+BhoIE,wBAAkB;EAClB,eAAQ;A/BuoIV;;AAEA;;;E+BnoIE,gBAAa;A/BuoIf;;AAEA;;;E+B/nIC,gBAAA;A/BmoID;;AAEA;;EAEE,cAAc;E+BpoIhB,mBAAgB;AAChB;;A/BuoIA;E+BnoIE,gBAAc;A/BsoIhB;;AAEA;E+BpoIE,iB7BxIe;E6ByIf,sBAAe;A/BsoIjB;;AgCpzIA;EhCuzIE,mBAAmB;AACrB;;AAEA;;;EgC9yIQ,yBAAY;EACZ,yB9B2Ba;E8B1Bb,wBAAmB;EAMpB,2BAAA;EhC8yIL,sBAAsB;AgC7zIxB;;AhCg0IA;;egC/zIE;AhCk0IF;;EgC/yIQ,iCAAgB;AhCkzIxB;;AAEA;EACE,oBAAoB;AgC7yItB;;AhCgzIA;EgC3yIM,YAAQ;AhC6yId;;AAEA;EgCpzIA,yBAEI;EAOI,WAAO;AhC8yIf;;AAEA;EgCzzIA,cAAgB;AhC2zIhB;;AAEA;EgC7zIA,cAAgB;AhC+zIhB;;AAEA;EgC5yIM,c9BnCG;AFi1IT;;AAEA;EgCr0IA,cAAgB;AhCu0IhB;;AAEA;EgCz0IA,mBACE;AhC00IF;;AAEA;EgC7yIM,uBAAgB;EACjB,iBAAA;EhC+yIH,gBAAgB;EgC3yIlB,UAAU;EACR,kBAAS;EACT,gB9BrDO;AFk2IT;;AAEA;EgC3yIA,WAAA;AhC6yIA;;AAEA;EACE,WAAW;AgC5yIb;;AhC+yIA;EgC5yIE,kBAAQ;EACR,iCAAsB;AhC8yIxB;;AgClzIA;;;EASG,kBAAA;EhC+yID,QAAQ;EgC7yIV,UAAU;EACR,cAAS;EACT,wB9B1Ec;AFy3IhB;;AAEA;EiC94IA,gBAAA;EjCg5IE,mBAAmB;AACrB;;AAEA;EiC54IG,gBAAA;AjC84IH;;AAEA;EiC14IG,gBAAA;AjC44IH;;AAEA;;;;;;;;;EiCl4IG,wBAAA;AjC44IH;;AAEA,gBiC54Ic;AjC64Id,gBiC54Ie;AjC64If,gBiC54IG;AjC64IH;EkC16IA,oBAAA;AlC46IA;;AkCx6IA;EAEI,0BAAe;EAChB,2BAAA;AlC06IH;;AAEA;EkCt6IG,gCAAA;ElCw6ID,yBAAyB;AmCr7I3B;;AnCw7IA;EmCp7IA,0BAAU;AnCs7IV;;AAEA;EmCn7IA,2BAAS;AnCs7IT;;AAEA;EmCr7IA,gCACgB;AnCs7IhB;;AAEA;EmCn7IA,8BAAY;AnCq7IZ;;AAEA;;emCp7IK;AnCu7IL;EmCr7II,kBAAgB;EAChB,WAAW;EACX,0BAAiB;EACjB,MAAA;EACD,cAAA;EnCu7ID,gBAAgB;EmCr7IlB,sBAAmB;EACjB,yBjCO0B;AFg7I5B;;AmCp7IA;EACE,kBjC5BM;AFm9IR;;AmCp7IA;EACA,eAAY;AACZ;;AnCw7IA;EACE,kBAAkB;EmCp7IpB,WACI;EACA,0BjC5BW;EiC6BX,SAAS;EACT,gBAAa;EACb,sBAAe;EACf,YAAA;EACD,WAAA;EnCq7ID,kBAAkB;EmCn7IpB,iBAAiB;EACb,kBjCpCI;EiCqCP,cAAA;EnCq7IC,0CAA0C;AmCn7I5C;;AnCs7IA;EmCn7IE,kBjCxCc;AF69IhB;;AAEA;EmCn7IE,yBAAwB;EACxB,qBAAS;AnCq7IX;;AAEA;EmCn7IA,yBAAe;EACb,qBAAoB;AnCq7ItB;;AAEA;EmCn7IA,yBAAgB;EACd,qBjCxDc;AF6+IhB;;AmCl7IA;EACE,yBAAmB;EACpB,qBAAA;AnCq7ID;;AAEA;EmCn7IE,yBAAwB;EACxB,qBAAa;AnCq7If;;AmCl7IA;EACE,yBAAmB;EACpB,qBAAA;AnCq7ID;;AAEA;EmCl7IG,yBAAA;EnCo7ID,qBAAqB;AmCj7IvB;;AnCo7IA;EmCj7IE,yBAAY;EACZ,qBAAe;AnCm7IjB;;AAEA;EmCj7IE,yBAAwB;EACzB,qBAAA;AnCm7ID;;AAEA;EmCj7IE,yBAAc;AnCm7IhB;;AAEA;EmCl7IA,aAAe;EACb,wBjC1GQ;AF8hJV;;AAEA;EmCl7IA,YAAA;EACE,WAAA;EACA,iBjC/Ge;AFmiJjB;;AmCj7IA;EACE,YAAA;EACA,WjCnHK;EiCoHN,iBAAA;EnCo7IC,kBAAkB;EmCl7IpB,kBAAe;EACb,uBjCtHQ;EiCuHR,4BjCvHe;EiCwHhB,0BAAA;EnCo7IC,yBAAyB;EmCl7I3B,kBAAe;AnCo7If;;AAEA;EACE,sBAAsB;EmCl7IxB,eAAe;EACb,cAAA;AnCo7IF;;AAEA;EmCl7IA,kBAAe;AnCo7If;;AAEA;EACE,WAAW;EmCl7Ib,YAAA;AnCo7IA;;AAEA;EACE,kBAAkB;EmCj7IpB,MAAA;EAGM,8BAAkB;EAClB,SAAA;EACA,WAAW;EACZ,eAAA;EnCi7IH,kBAAkB;EmCv7IpB,QAAA;EASI,UAAA;EACA,kBAAgB;EnCm7IlB,aAAa;EAGb,mBoCzlJc;EAChB,2BAAM;EAGJ,uBAAmB;EACnB,+BAAkB;EAGlB,mBAAc;ApC2lJhB;;AAEA;EoCxlJE,wBAAmB;ApC2lJrB;;AAEA,eoC1lJC;ApC2lJD;EoC1lJA,YAAA;EACE,WAAS;EACT,cAAa;EACb,cAAQ;EACR,iBAAS;EACT,kBAAkB;EACnB,kBAAA;EpC4lJC,kCAAkC;EoC3lJpC,eAAA;ApC6lJA;;AAEA;;eoC1lJC;ApC6lJD;EoC5lJA,mBAAoB;EAClB,yBAAU;EACV,kBAAa;EACb,YAAY;EACZ,eAAe;EAChB,mBAAA;EpC8lJC,kBAAkB;AoC5lJpB;;AAGA;EACE,cAAW;ApC6lJb;;AAEA;EACE,YAAY;EoC5lJd,eAAA;EACE,gBAAS;EACV,cAAA;EpC8lJC,WAAW;AoC5lJb;;ApC+lJA;EoC3lJC,YAAA;EpC6lJC,mBAAmB;EoC3lJrB,uBAAoB;EAClB,sBAAkB;ApC6lJpB;;AAEA;EoC3lJE,cAAS;EACT,QAAO;ApC6lJT;;AAEA;EoC3lJE,clC9Be;AF2nJjB;;AoC1lJA;EACE,YAAS;EACT,YAAY;EACZ,0BAAsB;EACtB,mBAAkB;EAClB,kCAAgB;ApC6lJlB;;AAEA;EoC3lJE,clCzEa;AFsqJf;;AAEA;EoC3lJE,WAAU;EACV,YAAW;EACX,eAAY;EACZ,gBAAa;ApC6lJf;;AoC1lJA;EACE,4BAAS;EACV,mBAAA;EpC6lJC,YAAY;AoC3lJd;;ApC8lJA;;EqC3rJA,mBAAA;ErC8rJE,0BAA0B;AAC5B;;AAEA;EqC3rJE,YAAU;EACV,mBAAgB;EACjB,uBAAA;ErC6rJC,sBAAsB;AqC3rJxB;;ArC8rJA;EACE,cAAc;EqC/rJhB,QAAA;ArCisJA;;AAEA;EqCzrJG,0BAAA;ErC2rJD,mBAAmB;EqCxrJrB,YAAA;ArC0rJA;;AAEA;;0CqCtrJW;ArCyrJX;EqCvrJE,eAAc;ArCyrJhB;;AAEA;;;;EqCprJE,8BAA8B;ArCyrJhC;;AAEA;;;EqCrrJE,yBAAmB;ArCyrJrB;;AAEA;;EqCtrJA,cAAA;ArCyrJA;;AAEA;EqCvrJC,eAAI;ArCyrJL;;AAEA;EACE,UAAU;EqCvrJZ,WAAA;ArCyrJA;;AAEA;;eqCtrJG;ArCyrJH;EACE,eAAe;AACjB;;AAEA;EACE,eqCxrJE;ArCyrJJ;;AAEA;;eAEe;AACf;EqCvrJA,WAAA;EACE,gBAAE;ArCyrJJ;;AAEA;EACE,gBqCxrJE;ArCyrJJ;;AAEA;EqCvrJA,gBAAkB;ArCyrJlB;;AAEA;EqCvrJE,kBAAI;ErCyrJJ,gBqCxrJY;ArCyrJd;;AAEA;EqCvrJE,eAAU;EACV,gBAAE;ErCyrJF,kCqCxrJY;ErCyrJZ,iBAAiB;EqCxrJjB,yBAAI;ArC0rJN;;AAEA;EACE,kCAAkC;AsC9xJpC;;AtCiyJA;EsC7xJA,mBAAA;AtC+xJA;;AsC3xJA;;;;;EAKC,UAAA;AtC8xJD;;AAEA;EsC7xJC,mBAAA;EtC+xJC,eAAe;EsC7xJjB,iBAAmB;EAClB,eAAa;EACb,yBAAU;AtC+xJX;;AAEA;;;;;;;EsCvxJE,qBpCxBa;AFuzJf;;AAEA;EsC7xJA,mBAAgB;EACd,YAAW;EACX,cAAc;EACf,0BAAA;EACD,2BAAY;EACV,6BAAgB;EACjB,wBAAA;EtCgyJC,4BAA4B;EsC/xJ9B,uBAAY;AtCiyJZ;;AAEA;EACE,oBAAoB;EsChyJtB,eAAY;AtCkyJZ;;AAEA;EsChyJA,mBAAA;AtCkyJA;;AsC/xJA;EACE,mBpClCO;AFo0JT;;AsChyJA;;;EtCqyJE,oCAAoC;EsCjyJtC,yBAAgB;EACd,4BAAmB;AtCmyJrB;;AsCjyJA;EACE,mBAAW;AtCoyJb;;AAEA;EACE,mBAAmB;AsClyJrB;;AtCqyJA;EACE,kBAAkB;EsClyJpB,YAAA;EACE,eAAc;EACf,eAAA;EtCoyJC,eAAe;EsCjyJjB,gBAAA;EtCmyJE,kBAAkB;EAClB,yBsClyJc;AAEhB;;AtCmyJA;EACE,YAAY;EsC5xJd,cACE;EACE,iBAAU;AtC6xJd;;AsC/xJA;EAKI,mDAAkB;EAClB,cAAS;AtC8xJb;;AAEA;EsC5xJI,oDAAY;EACZ,cAAW;AtC8xJf;;AAEA;EsC5xJG,oDAAA;EtC8xJD,cAAc;AsC3xJhB;;AtC8xJA;EsC3xJE,mDAAqB;EACrB,cAAY;AtC6xJd;;AAEA;EsC3xJE,mDAAW;EAMZ,cAAA;AtCwxJD;;AAEA;EsC5xJI,oDpCnGY;EoCoGb,cAAA;AtC8xJH;;AAEA;EACE,qDsC5xJc;EAEhB,cAAc;AtC4xJd;;AAEA;EsC1xJA,kDAAA;EtC4xJE,cAAc;AAChB;;AAEA;EsC1xJE,kBAAiB;EAClB,gBAAA;EtC4xJC,kCAAkC;AsC3xJpC;;AtC8xJA;EACE,kBAAkB;EsC/xJpB,gBAGE;EACE,kCAAa;AtC8xJjB;;AAEA;;eAEe;AsCtyJf;;EAWM,aAAW;EACX,mBpCjHW;EoCkHX,kBAAiB;AtC+xJvB;;AAEA;EsC7xJM,cAAU;EACV,kBAAkB;EAClB,cAAU;EACV,eAAe;EACf,iBpCzJS;EoC0JV,mBAAA;EtC+xJH,kBAAkB;EsCrzJpB,kBAGE;AtCozJF;;AAEA;EsC7xJM,SAAQ;EACR,kBAAe;EACf,QpClKE;EoCmKF,SAAA;EACA,kBAAgB;AtC+xJtB;;AsC1xJA;EACE,aACE;EtC4xJF,mCsC3xJmB;EtC4xJnB,oCsC3xJG;EtC4xJH,8BAA8B;AAChC;;AAEA;EACE,UsCxxJW;EtCyxJX,mCsCxxJe;EtCyxJf,oCsCxxJG;EAJH,iCAMmB;AtCwxJrB;;AAEA,esCtxJI;AtCuxJJ;;EAEE,WAAW;EACX,YAAY;EsCnxJd,iBAAA;AtCqxJA;;AsCjxJA;EACE,SAAQ;AtCoxJV;;AAEA,esCnxJE;AtCoxJF;EsClxJE,kBAAkB;AtCoxJpB;;AAEA;EACE,kBAAkB;EsClxJpB,yBAAU;EACR,aAAa;EACb,kBAAiB;EACjB,iBAAgB;EAChB,aAAW;EACZ,gBAAA;EtCoxJC,aAAa;EsClxJf,cAAQ;EACN,kCAAiB;AtCoxJnB;;AAEA;;;EAGE,qBAAqB;EACrB,kBsCjxJc;EAChB,sBAAe;EACb,kBAAkB;EAClB,gBAAe;EAwChB,eAAA;EtC2uJC,yBAAyB;EsCrxJ3B,qBAIE;EACE,cAAU;EACV,eAAS;EACV,kBAAA;EtCmxJD,MAAM;EsC1xJR,UAAA;EAUI,WAAU;EACV,YAAS;EACT,iBAAgB;AtCmxJpB;;AsC/xJA;EAeI,SAAS;AtCoxJb;;AAEA;EsClxJI,SAAA;AtCoxJJ;;AAEA;;esClxJe;AtCqxJf;EsCnxJI,gBAAe;EACf,kBpC/PW;EoCgQZ,gBAAA;AtCqxJH;;AAEA;EsCpxJI,apCnQI;AFyhKR;;AsCpzJA;EAkCI,kBAAkB;EAClB,OAAO;EAMR,QAAA;AtCixJH;;AAEA;EsCrxJM,aAAa;EACd,0BAAA;AtCuxJL;;AAEA;EsCnxJE,YAAU;EACV,cAAS;EACT,eAAU;AtCqxJZ;;AAEA;EsCnxJE,sBAAiB;EACjB,oBpC3Pe;EoCuShB,8BAAA;EtC0uJC,sCAAsC;AsC/xJxC;;AtCkyJA;EsCpxJI,kBpC/RW;EoCgSX,0BAAyB;EACzB,yBAAkB;EAClB,iCAAiB;AtCsxJrB;;AAWA;EACE;IsCnzJF,uBA8Ba;EACP;EACA;IACA,oBAAO;EACP;AtCuxJN;;AAWA;EsCtxJM;IACA,+BAAa;EACb;EACA;IACA,iCAA0C;EAC3C;AtCwxJL;;AAWA;EuCljKC;IvCojKG,UAAU;EuC3mKd;EAUI;IACA,UAAY;EACZ;AvComKJ;;AuChnKA;;eAeK;AvCsmKL;;euCnmKI;AvCsmKJ;EuCpmKI,WAAW;EACX,WAAS;EACT,kBAAkB;EAClB,yBAAS;AvCsmKb;;AAEA;EACE,cAAc;AuChoKhB;;AvCmoKA;EuCrmKI,iBAAe;EACf,UrC7BI;EqC8BJ,cAAc;AvCumKlB;;AAEA;EuCrmKI,YAAU;EACV,WAAU;EACV,cAAQ;EACR,kBAAW;EAQZ,eAAA;EvCgmKD,cAAc;EuC/oKhB,iBA2BE;AvCsnKF;;AAEA;EuCvmKM,gBAAU;EACV,cAAS;AvCymKf;;AuCtpKA;EAkDM,gBAAe;AvCwmKrB;;AAEA;EuCnmKE,iBAAgB;EAChB,gBrC1Cc;AF+oKhB;;AAEA;EuCnmKE,cAAc;AvCqmKhB;;AuClmKA;;eA2BC;AvC4kKD;EuCvmKA,yBAEW;AvCumKX;;AAEA;EuCrmKG,aAAA;AvCumKH;;AAEA;EuCrmKM,mBAAmB;AvCumKzB;;AAEA;EuCrmKM,WAAW;EACX,WAAU;EACV,eAAU;AvCumKhB;;AAEA;;EuCznKA,gBAOE;AvCqnKF;;AAEA;EuC9nKA,cAwBE;AvCwmKF;;AAEA;;euCnmKe;AvCsmKf;EuCpmKI,aAAU;AvCsmKd;;AuC1mKA;EAQM,kBAAe;AvCsmKrB;;AAEA;EuCpmKM,kBAAS;EACT,SAAM;EACN,WAAU;EACV,eAAU;EACV,yBAAY;EACZ,YAAQ;EACR,WAAQ;EACT,kBAAA;EvCsmKH,iBAAiB;EuCznKnB,kBAME;AvCqnKF;;AAEA;EuC7nKA,kBAME;EAiBM,+BAAgB;EACjB,qBAAA;EvCymKL,YAAY;EuCjoKd,iBA2BE;EACE,0CAAU;EACV,kBAAY;EACb,WAAA;AvCwmKH;;AAEA;EuCvmKG,cAAA;EvCymKD,yBAAyB;AuC1oK3B;;AvC6oKA;;eAEe;AuCtmKf;EACE,aAAS;AvCwmKX;;AAEA;;euCvmKE;AvC0mKF;EuCxmKI,mDAAgB;EAChB,sBAAS;AvC0mKb;;AuCjnKA;EAUI,gBrCnII;AF8uKR;;AAEA;EuCzmKI,aAAU;EACV,iBAAgB;EAChB,eAAS;EACV,kBAAA;AvC2mKH;;AAEA;EuCzmKM,gBAAc;EACd,eAAe;EACf,kCAAkB;EACnB,iBAAA;EvC2mKH,gBAAgB;EuCnoKlB,YAAc;EA2BV,qBAAc;EACd,gBAAe;EACf,kBAAgB;EACjB,kBAAA;EvC2mKD,eAAe;EuCzoKjB,cA+BE;AvC4mKF;;AAEA;EuC7oKA,kBA+BE;EAGI,SAAA;EACD,gBAAA;EvC8mKH,eAAe;EuCjpKjB,eA+BE;EAOI,cAAY;EACZ,kCAAW;EACX,yBAAkB;AvC8mKxB;;AuCtpKA;EA4CI;IACA,eAAgB;EAChB;AvC8mKJ;;AuC1mKA;EACE;IACE,UAAA;IACA,WAAO;EvC6mKT;EACA;IuChnKA,eAKW;EvC6mKX;EACA;IuCnnKA,kBAQE;EvC6mKF;AACF;;AAEA;;euCrmKK;AvCwmKL;EACE,YuC7mKM;EvC8mKN,WuC7mKM;EvC8mKN,cuC7mKM;EvC8mKN,yBuC7mKK;EAlBL,kBAoBE;EvC6mKF,kBuC3mKiB;EvC4mKjB,WuC3mKK;EAvBL,iBAoBE;AvCgnKJ;;AAEA;EACE,auC1mKmB;EvC2mKnB,iBuC1mKO;EvC2mKP,gBAAgB;EAChB,eAAe;AuCtmKjB;;AvCymKA;EACE,iBuClmKG;EAPH,cACE;EvC0mKF,mBuCvmKgB;AvCwmKlB;;AAEA;;euCjmKe;AvComKf;EuClmKE,kBAAW;EACX,mBAAc;AvComKhB;;AuCvmKA;EAMI,kBAAkB;EACnB,iBAAA;AvCqmKH;;AAEA;EuCpmKI,kBAAgB;EAChB,uBAAkB;EACnB,yBAAA;AvCsmKH;;AAEA;EuCrmKG,eAAA;EvCumKD,kCAAkC;EuCtnKpC,mBAgBE;EACE,cAAc;EACd,yBAAW;EACZ,mBAAA;AvCwmKH;;AAEA;EuCvmKG,eAAA;EvCymKD,kCAAkC;EwC/2KpC,mBAAA;ExCi3KE,cAAc;AAChB;;AAEA;EACE,ewC/2Ke;ExCg3Kf,+BwC/2KW;AxCg3Kb;;AAEA;EACE,kBwC92Ke;ExC+2Kf,uBwC92KC;AxC+2KH;;AAEA;EACE,mBwC92KC;EACD,iBAAc;AxC+2KhB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EyCr4KZ,SAAA;EzCu4KE,UAAU;EACV,gByCt4Kc;EAEhB,WAAQ;EACN,YAAK;EzCs4KL,iByCr4Kc;EzCs4Kd,kCyCr4KC;AzCs4KH;;AyCn4KA;EACE,eAAK;EzCs4KL,iByCr4Kc;EzCs4Kd,cyCr4KC;EAED,yBAAa;EzCq4Kb,kByCp4KS;EzCq4KT,iByC53KC;EAVD,yBAGO;EzCq4KP,iCyCp4K4B;EzCq4K5B,YyCp4KG;EALH,cAMG;EzCu4KH;iCyCl4KuB;EzCo4KvB,mByCn4KkB;EASlB,qDAAc;EzCm4Kd,kByCl4Ke;EzCm4Kf,SyCl4KC;EACD,mBAAe;EzCm4Kf,WyCl4KE;AzCm4KJ;;AAEA;EACE,WyCl4KC;EAED,kBAAgB;EzCk4KhB,OyCj4KM;EzCk4KN,SyCj4KC;EAED,WAAA;EzCi4KA,8ByCh4Ka;EzCi4Kb,mCyCh4Ke;EzCi4Kf,oCyCh4KC;EAED,6BAAc;AzCg4KhB;;AAEA;EACE,WyC73KW;EzC83KX,kByC73KoB;EzC83KpB,QyC73KG;EAGH,SAAG;EzC43KH,WyC33KS;EzC43KT,kCyC33KC;EACD,+BAAc;EzC43Kd,oCyC33Ka;EzC43Kb,6ByC33KC;AzC43KH;;AAEA;;eyCz3Ka;AzC43Kb;EACE,yBAAyB;EACzB,iBAAiB;EyC13KnB,cAAQ;EACN,mBAAkB;EzC43KlB,kByC33KkB;EzC43KlB,mByC33KmB;EzC43KnB,WyC33KQ;AzC43KV;;AAEA;EyCj4KE,mBAAkB;EzCm4KlB,gByC33KkB;EzC43KlB,kByC33KG;AzC43KL;;AAEA;EACE,cyCr3KC;AzCs3KH;;AAEA;EACE,0CyC13KG;EAEH,SAAA;EzC03KA,WyCz3KS;EzC03KT,SyCz3KC;EACD,kBAAU;EzC03KV,SyCz3KS;EzC03KT,UyCz3KC;EACD,UAAA;AzC03KF;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EyCx3KrB,kBAAmB;EACjB,cAAW;EzC03KX,cyCz3KW;EzC03KX,YyCz3KC;EAED,WAAA;EzCy3KA,iByCx3KgB;EzCy3KhB,kByCx3KC;EAED,kBAAY;EzCw3KZ,QyCv3KE;EzCw3KF,WyCv3KC;AzCw3KH;;AAEA;EACE,cAAc;EACd,eAAe;EyCh3KjB,eAAiB;EACf,kBAAY;EzCk3KZ,SyCj3KS;AzCk3KX;;AAEA;EACE,eyCj3KC;EzCk3KD,eAAe;AACjB;;AyC92KA;EACE,cAAc;EzCi3Kd,eyCh3Kc;EzCi3Kd,gByCh3KC;EAED,eAAS;EzCg3KT,yByC/2KqB;AzCg3KvB;;AAEA;EyC92KA,kBAAmB;AzCg3KnB;;AAEA;EACE,WAAW;EACX,cAAc;EyC92KhB,UAAQ;AzCg3KR;;AAEA;EACE,qCAAqC;EACrC,4DAA4D;EyC/2K9D,kCAAwB;EACtB,cAAY;EzCi3KZ,SyCh3KS;EzCi3KT,WyCh3KC;EACD,iBAAa;EzCi3Kb,kByCh3KS;EzCi3KT,QyCh3KC;EACD,QACE;AzCg3KJ;;AAEA;EyCn3KE,aAKO;AzCg3KT;;AAEA;EACE,mByC72Ka;AzC82Kf;;AAEA;EACE,WyC52KC;EACD,cACE;EzC42KF,UyC32KI;AzC42KN;;AAEA;EACE,qCyCx2KG;EAEH,2DAAY;EzCw2KZ,kCyCv2KiB;EzCw2KjB,cyCv2Ka;EzCw2Kb,SyCv2KE;EzCw2KF,UyCv2KC;EACD,iBAAgB;EzCw2KhB,kByCv2KY;EzCw2KZ,YyCh2KC;EATD,QAAA;EzC22KA,QyCx2KI;AzCy2KN;;AAEA;EACE,gByCx2KK;AzCy2KP;;AAEA;EyCp2KE,gBAAA;AzCs2KF;;AAEA;EACE,UyCp2KS;EzCq2KT,YyCp2KC;AzCq2KH;;AAEA;EyCl2KE,aAAU;AzCo2KZ;;AAEA;EACE,cyCl2KS;EzCm2KT,kByCl2KC;AzCm2KH;;AAEA;EyCj2KE,mBAAW;EzCm2KX,mByCl2KgB;EzCm2KhB,UyCl2KC;AzCm2KH;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,4BAA4B;IAC5B,4BAA4B;IAC5B,8BAA8B;EAChC;EACA;IACE,WAAW;EACb;EACA;IACE,4DAA4D;IAC5D,kCAAkC;IAClC,4BAA4B;IAC5B,WAAW;EACb;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;eAEe;AACf;EACE;;;;;IAKE,aAAa;IACb,SAAS;IACT,UAAU;EACZ;EACA;;IAEE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,aAAa;EACf;AACF;;AAEA;;eAEe;AACf;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,OAAO;EACT;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,yBAAyB;IAEzB,2CAA2C;IAC3C,UAAU;IACV,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,cAAc;EAChB;EACA;IACE,SAAS;IACT,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,cAAc;EAChB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,YAAY;EACd;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gCAAgC;IAChC,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,iBAAiB;EACnB;EACA;IAEE,0CAA0C;EAC5C;EACA;IAEE,mDAAmD;EACrD;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,gBAAgB;AAClB;AACA,oCAAoC;;AAEpC;EACE,2BAA2B;AAC7B;AACA;EACE,sCAAsC;EACtC,aAAa;EACb,mCAAmC;EACnC,uCAAuC;EACvC,sDAAsD;AACxD;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;EAaE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE;;AAEF;EACE,oBAAoB;EACpB;UACQ;EACR,WAAW;EACX,gBAAgB;EAEhB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,2EAAoE;EACpE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;AACpB;AACA;;;;;;;;;;;;;;;;;CAiBC;;AAED;;EAEE,UAAU;EACV,MAAM;AACR;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;kBACgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,mBAAmB;EAGnB,iDAAiD;EACjD,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,mBAAmB;EAGnB,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;;EAGE,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
